try {
  if (typeof Array.prototype.find === "undefined" || typeof CustomEvent === "undefined" || typeof Math.trunc === "undefined" || typeof NodeList.prototype.forEach === "undefined" || typeof Number.isNaN === "undefined" || typeof String.prototype.includes === "undefined" || typeof URL === "undefined") {
    (function (self, undefined) {
      function ArrayCreate(r) {
        if (1 / r == -Infinity && (r = 0), r > Math.pow(2, 32) - 1) throw new RangeError("Invalid array length");
        var n = [];
        return n.length = r, n;
      }

      function Call(t, l) {
        var n = arguments.length > 2 ? arguments[2] : [];
        if (!1 === IsCallable(t)) throw new TypeError(Object.prototype.toString.call(t) + "is not a function.");
        return t.apply(l, n);
      }

      function CreateDataProperty(e, r, t) {
        var a = {
          value: t,
          writable: !0,
          enumerable: !0,
          configurable: !0
        };

        try {
          return Object.defineProperty(e, r, a), !0;
        } catch (n) {
          return !1;
        }
      }

      function CreateDataPropertyOrThrow(t, r, o) {
        var e = CreateDataProperty(t, r, o);
        if (!e) throw new TypeError("Cannot assign value `" + Object.prototype.toString.call(o) + "` to property `" + Object.prototype.toString.call(r) + "` on object `" + Object.prototype.toString.call(t) + "`");
        return e;
      }

      function CreateMethodProperty(e, r, t) {
        var a = {
          value: t,
          writable: !0,
          enumerable: !1,
          configurable: !0
        };
        Object.defineProperty(e, r, a);
      }

      function Get(n, t) {
        return n[t];
      }

      function HasOwnProperty(r, t) {
        return Object.prototype.hasOwnProperty.call(r, t);
      }

      function IsCallable(n) {
        return "function" == typeof n;
      }

      function RequireObjectCoercible(e) {
        if (null === e || e === undefined) throw TypeError(Object.prototype.toString.call(e) + " is not coercible to Object.");
        return e;
      }

      function SameValueNonNumber(e, n) {
        return e === n;
      }

      function ToBoolean(o) {
        return Boolean(o);
      }

      function ToObject(e) {
        if (null === e || e === undefined) throw TypeError();
        return Object(e);
      }

      function GetV(t, e) {
        return ToObject(t)[e];
      }

      function GetMethod(e, n) {
        var r = GetV(e, n);
        if (null === r || r === undefined) return undefined;
        if (!1 === IsCallable(r)) throw new TypeError("Method not callable: " + n);
        return r;
      }

      function Type(e) {
        switch (typeof e) {
          case "undefined":
            return "undefined";

          case "boolean":
            return "boolean";

          case "number":
            return "number";

          case "string":
            return "string";

          case "symbol":
            return "symbol";

          default:
            return null === e ? "null" : "Symbol" in self && (e instanceof self.Symbol || e.constructor === self.Symbol) ? "symbol" : "object";
        }
      }

      function CreateIterResultObject(e, r) {
        if ("boolean" !== Type(r)) throw new Error();
        var t = {};
        return CreateDataProperty(t, "value", e), CreateDataProperty(t, "done", r), t;
      }

      function GetPrototypeFromConstructor(t, o) {
        var r = Get(t, "prototype");
        return "object" !== Type(r) && (r = o), r;
      }

      function OrdinaryCreateFromConstructor(r, e) {
        var t = arguments[2] || {},
            o = GetPrototypeFromConstructor(r, e),
            a = Object.create(o);

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && Object.defineProperty(a, n, {
            configurable: !0,
            enumerable: !1,
            writable: !0,
            value: t[n]
          });
        }

        return a;
      }

      function IsConstructor(t) {
        return "object" === Type(t) && "function" == typeof t && !!t.prototype;
      }

      function Construct(r) {
        var t = arguments.length > 2 ? arguments[2] : r,
            o = arguments.length > 1 ? arguments[1] : [];
        if (!IsConstructor(r)) throw new TypeError("F must be a constructor.");
        if (!IsConstructor(t)) throw new TypeError("newTarget must be a constructor.");
        if (t === r) return new (Function.prototype.bind.apply(r, [null].concat(o)))();
        var n = OrdinaryCreateFromConstructor(t, Object.prototype);
        return Call(r, n, o);
      }

      function IsRegExp(e) {
        if ("object" !== Type(e)) return !1;
        var n = "Symbol" in self && "match" in self.Symbol ? Get(e, self.Symbol.match) : undefined;
        if (n !== undefined) return ToBoolean(n);

        try {
          var t = e.lastIndex;
          return e.lastIndex = 0, RegExp.prototype.exec.call(e), !0;
        } catch (l) {} finally {
          e.lastIndex = t;
        }

        return !1;
      }

      function IteratorClose(r, t) {
        if ("object" !== Type(r["[[Iterator]]"])) throw new Error(Object.prototype.toString.call(r["[[Iterator]]"]) + "is not an Object.");
        var e = r["[[Iterator]]"],
            o = GetMethod(e, "return");
        if (o === undefined) return t;

        try {
          var n = Call(o, e);
        } catch (c) {
          var a = c;
        }

        if (t) return t;
        if (a) throw a;
        if ("object" !== Type(n)) throw new TypeError("Iterator's return method returned a non-object.");
        return t;
      }

      function IteratorComplete(t) {
        if ("object" !== Type(t)) throw new Error(Object.prototype.toString.call(t) + "is not an Object.");
        return ToBoolean(Get(t, "done"));
      }

      function IteratorNext(t) {
        if (arguments.length < 2) var e = Call(t["[[NextMethod]]"], t["[[Iterator]]"]);else e = Call(t["[[NextMethod]]"], t["[[Iterator]]"], [arguments[1]]);
        if ("object" !== Type(e)) throw new TypeError("bad iterator");
        return e;
      }

      function IteratorStep(t) {
        var r = IteratorNext(t);
        return !0 !== IteratorComplete(r) && r;
      }

      function IteratorValue(t) {
        if ("object" !== Type(t)) throw new Error(Object.prototype.toString.call(t) + "is not an Object.");
        return Get(t, "value");
      }

      function OrdinaryToPrimitive(r, t) {
        if ("string" === t) var e = ["toString", "valueOf"];else e = ["valueOf", "toString"];

        for (var i = 0; i < e.length; ++i) {
          var n = e[i],
              a = Get(r, n);

          if (IsCallable(a)) {
            var o = Call(a, r);
            if ("object" !== Type(o)) return o;
          }
        }

        throw new TypeError("Cannot convert to primitive.");
      }

      function SameValueZero(n, e) {
        return Type(n) === Type(e) && ("number" === Type(n) ? !(!isNaN(n) || !isNaN(e)) || 1 / n === Infinity && 1 / e == -Infinity || 1 / n == -Infinity && 1 / e === Infinity || n === e : SameValueNonNumber(n, e));
      }

      function ToInteger(n) {
        if ("symbol" === Type(n)) throw new TypeError("Cannot convert a Symbol value to a number");
        var t = Number(n);
        return isNaN(t) ? 0 : 1 / t === Infinity || 1 / t == -Infinity || t === Infinity || t === -Infinity ? t : (t < 0 ? -1 : 1) * Math.floor(Math.abs(t));
      }

      function ToLength(n) {
        var t = ToInteger(n);
        return t <= 0 ? 0 : Math.min(t, Math.pow(2, 53) - 1);
      }

      function ToPrimitive(e) {
        var t = arguments.length > 1 ? arguments[1] : undefined;

        if ("object" === Type(e)) {
          if (arguments.length < 2) var i = "default";else t === String ? i = "string" : t === Number && (i = "number");
          var r = "function" == typeof self.Symbol && "symbol" == typeof self.Symbol.toPrimitive ? GetMethod(e, self.Symbol.toPrimitive) : undefined;

          if (r !== undefined) {
            var n = Call(r, e, [i]);
            if ("object" !== Type(n)) return n;
            throw new TypeError("Cannot convert exotic object to primitive.");
          }

          return "default" === i && (i = "number"), OrdinaryToPrimitive(e, i);
        }

        return e;
      }

      function ToString(t) {
        switch (Type(t)) {
          case "symbol":
            throw new TypeError("Cannot convert a Symbol value to a string");

          case "object":
            return ToString(ToPrimitive(t, String));

          default:
            return String(t);
        }
      }

      function ToPropertyKey(r) {
        var i = ToPrimitive(r, String);
        return "symbol" === Type(i) ? i : ToString(i);
      }

      if (!("find" in Array.prototype)) {
        CreateMethodProperty(Array.prototype, "find", function e(r) {
          var t = ToObject(this),
              n = ToLength(Get(t, "length"));
          if (!1 === IsCallable(r)) throw new TypeError(r + " is not a function");

          for (var o = arguments.length > 1 ? arguments[1] : undefined, a = 0; a < n;) {
            var i = ToString(a),
                f = Get(t, i);
            if (ToBoolean(Call(r, o, [f, a, t]))) return f;
            a += 1;
          }

          return undefined;
        });
      }

      if (!("includes" in Array.prototype)) {
        CreateMethodProperty(Array.prototype, "includes", function e(r) {
          "use strict";

          var t = ToObject(this),
              o = ToLength(Get(t, "length"));
          if (0 === o) return !1;
          var n = ToInteger(arguments[1]);
          if (n >= 0) var a = n;else (a = o + n) < 0 && (a = 0);

          for (; a < o;) {
            var i = Get(t, ToString(a));
            if (SameValueZero(r, i)) return !0;
            a += 1;
          }

          return !1;
        });
      }

      if (!function (n) {
        if (!("Event" in n)) return !1;

        try {
          return new Event("click"), !0;
        } catch (t) {
          return !1;
        }
      }(self)) {
        !function () {
          function e(e, t) {
            if (!e) throw new Error("Not enough arguments");
            var n;

            if ("createEvent" in document) {
              n = document.createEvent("Event");
              var o = !(!t || t.bubbles === undefined) && t.bubbles,
                  i = !(!t || t.cancelable === undefined) && t.cancelable;
              return n.initEvent(e, o, i), n;
            }

            return n = document.createEventObject(), n.type = e, n.bubbles = !(!t || t.bubbles === undefined) && t.bubbles, n.cancelable = !(!t || t.cancelable === undefined) && t.cancelable, n;
          }

          var t = {
            click: 1,
            dblclick: 1,
            keyup: 1,
            keypress: 1,
            keydown: 1,
            mousedown: 1,
            mouseup: 1,
            mousemove: 1,
            mouseover: 1,
            mouseenter: 1,
            mouseleave: 1,
            mouseout: 1,
            storage: 1,
            storagecommit: 1,
            textinput: 1
          };

          if ("undefined" != typeof document && "undefined" != typeof window) {
            var n = window.Event && window.Event.prototype || null;
            e.NONE = 0, e.CAPTURING_PHASE = 1, e.AT_TARGET = 2, e.BUBBLING_PHASE = 3, window.Event = Window.prototype.Event = e, n && Object.defineProperty(window.Event, "prototype", {
              configurable: !1,
              enumerable: !1,
              writable: !0,
              value: n
            }), "createEvent" in document || (window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function o() {
              var e = this,
                  n = arguments[0],
                  o = arguments[1];
              if (e === window && n in t) throw new Error("In IE8 the event: " + n + " is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.");
              e._events || (e._events = {}), e._events[n] || (e._events[n] = function (t) {
                var n,
                    o = e._events[t.type].list,
                    i = o.slice(),
                    r = -1,
                    c = i.length;

                for (t.preventDefault = function a() {
                  !1 !== t.cancelable && (t.returnValue = !1);
                }, t.stopPropagation = function l() {
                  t.cancelBubble = !0;
                }, t.stopImmediatePropagation = function s() {
                  t.cancelBubble = !0, t.cancelImmediate = !0;
                }, t.currentTarget = e, t.relatedTarget = t.fromElement || null, t.target = t.target || t.srcElement || e, t.timeStamp = new Date().getTime(), t.clientX && (t.pageX = t.clientX + document.documentElement.scrollLeft, t.pageY = t.clientY + document.documentElement.scrollTop); ++r < c && !t.cancelImmediate;) {
                  r in i && (n = i[r], o.includes(n) && "function" == typeof n && n.call(e, t));
                }
              }, e._events[n].list = [], e.attachEvent && e.attachEvent("on" + n, e._events[n])), e._events[n].list.push(o);
            }, window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function i() {
              var e,
                  t = this,
                  n = arguments[0],
                  o = arguments[1];
              t._events && t._events[n] && t._events[n].list && -1 !== (e = t._events[n].list.indexOf(o)) && (t._events[n].list.splice(e, 1), t._events[n].list.length || (t.detachEvent && t.detachEvent("on" + n, t._events[n]), delete t._events[n]));
            }, window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function r(e) {
              if (!arguments.length) throw new Error("Not enough arguments");
              if (!e || "string" != typeof e.type) throw new Error("DOM Events Exception 0");
              var t = this,
                  n = e.type;

              try {
                if (!e.bubbles) {
                  e.cancelBubble = !0;

                  var o = function o(e) {
                    e.cancelBubble = !0, (t || window).detachEvent("on" + n, o);
                  };

                  this.attachEvent("on" + n, o);
                }

                this.fireEvent("on" + n, e);
              } catch (i) {
                e.target = t;

                do {
                  e.currentTarget = t, "_events" in t && "function" == typeof t._events[n] && t._events[n].call(t, e), "function" == typeof t["on" + n] && t["on" + n].call(t, e), t = 9 === t.nodeType ? t.parentWindow : t.parentNode;
                } while (t && !e.cancelBubble);
              }

              return !0;
            }, document.attachEvent("onreadystatechange", function () {
              "complete" === document.readyState && document.dispatchEvent(new e("DOMContentLoaded", {
                bubbles: !0
              }));
            }));
          }
        }();
      }

      if (!("CustomEvent" in self && ("function" == typeof self.CustomEvent || self.CustomEvent.toString().indexOf("CustomEventConstructor") > -1))) {
        self.CustomEvent = function e(t, n) {
          if (!t) throw Error('TypeError: Failed to construct "CustomEvent": An event name must be provided.');
          var l;
          if (n = n || {
            bubbles: !1,
            cancelable: !1,
            detail: null
          }, "createEvent" in document) try {
            l = document.createEvent("CustomEvent"), l.initCustomEvent(t, n.bubbles, n.cancelable, n.detail);
          } catch (a) {
            l = document.createEvent("Event"), l.initEvent(t, n.bubbles, n.cancelable), l.detail = n.detail;
          } else l = new Event(t, n), l.detail = n && n.detail || null;
          return l;
        }, CustomEvent.prototype = Event.prototype;
      }

      if (!("trunc" in Math)) {
        CreateMethodProperty(Math, "trunc", function t(r) {
          return r < 0 ? Math.ceil(r) : Math.floor(r);
        });
      }

      if (!("forEach" in NodeList.prototype)) {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }

      if (!("isNaN" in Number)) {
        !function () {
          var e = self;
          CreateMethodProperty(Number, "isNaN", function r(n) {
            return "number" === Type(n) && !!e.isNaN(n);
          });
        }();
      }

      if (!("getOwnPropertyDescriptor" in Object && "function" == typeof Object.getOwnPropertyDescriptor && function () {
        try {
          return "3" === Object.getOwnPropertyDescriptor("13.7", 1).value;
        } catch (t) {
          return !1;
        }
      }())) {
        !function () {
          var e = Object.getOwnPropertyDescriptor,
              t = function t() {
            try {
              return 1 === Object.defineProperty(document.createElement("div"), "one", {
                get: function get() {
                  return 1;
                }
              }).one;
            } catch (e) {
              return !1;
            }
          },
              r = {}.toString,
              n = "".split;

          CreateMethodProperty(Object, "getOwnPropertyDescriptor", function c(o, i) {
            var a = ToObject(o);
            a = ("string" === Type(a) || a instanceof String) && "[object String]" == r.call(o) ? n.call(o, "") : Object(o);
            var u = ToPropertyKey(i);
            if (t) try {
              return e(a, u);
            } catch (l) {}
            if (HasOwnProperty(a, u)) return {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: a[u]
            };
          });
        }();
      }

      if (!("isExtensible" in Object)) {
        !function (e) {
          CreateMethodProperty(Object, "isExtensible", function t(n) {
            return "object" === Type(n) && (!e || e(n));
          });
        }(Object.isExtensible);
      }

      if (!("keys" in Object && function () {
        return 2 === Object.keys(arguments).length;
      }(1, 2) && function () {
        try {
          return Object.keys(""), !0;
        } catch (t) {
          return !1;
        }
      }())) {
        CreateMethodProperty(Object, "keys", function () {
          "use strict";

          function t() {
            var t;

            try {
              t = Object.create({});
            } catch (r) {
              return !0;
            }

            return o.call(t, "__proto__");
          }

          function r(t) {
            var r = n.call(t),
                e = "[object Arguments]" === r;
            return e || (e = "[object Array]" !== r && null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Function]" === n.call(t.callee)), e;
          }

          var e = Object.prototype.hasOwnProperty,
              n = Object.prototype.toString,
              o = Object.prototype.propertyIsEnumerable,
              c = !o.call({
            toString: null
          }, "toString"),
              l = o.call(function () {}, "prototype"),
              i = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
              u = function u(t) {
            var r = t.constructor;
            return r && r.prototype === t;
          },
              a = {
            $console: !0,
            $external: !0,
            $frame: !0,
            $frameElement: !0,
            $frames: !0,
            $innerHeight: !0,
            $innerWidth: !0,
            $outerHeight: !0,
            $outerWidth: !0,
            $pageXOffset: !0,
            $pageYOffset: !0,
            $parent: !0,
            $scrollLeft: !0,
            $scrollTop: !0,
            $scrollX: !0,
            $scrollY: !0,
            $self: !0,
            $webkitIndexedDB: !0,
            $webkitStorageInfo: !0,
            $window: !0
          },
              f = function () {
            if ("undefined" == typeof window) return !1;

            for (var t in window) {
              try {
                if (!a["$" + t] && e.call(window, t) && null !== window[t] && "object" == typeof window[t]) try {
                  u(window[t]);
                } catch (r) {
                  return !0;
                }
              } catch (r) {
                return !0;
              }
            }

            return !1;
          }(),
              p = function p(t) {
            if ("undefined" == typeof window || !f) return u(t);

            try {
              return u(t);
            } catch (r) {
              return !1;
            }
          };

          return function s(o) {
            var u = "[object Function]" === n.call(o),
                a = r(o),
                f = "[object String]" === n.call(o),
                s = [];
            if (o === undefined || null === o) throw new TypeError("Cannot convert undefined or null to object");
            var y = l && u;
            if (f && o.length > 0 && !e.call(o, 0)) for (var h = 0; h < o.length; ++h) {
              s.push(String(h));
            }
            if (a && o.length > 0) for (var g = 0; g < o.length; ++g) {
              s.push(String(g));
            } else for (var w in o) {
              t() && "__proto__" === w || y && "prototype" === w || !e.call(o, w) || s.push(String(w));
            }
            if (c) for (var d = p(o), $ = 0; $ < i.length; ++$) {
              d && "constructor" === i[$] || !e.call(o, i[$]) || s.push(i[$]);
            }
            return s;
          };
        }());
      }

      if (!("getOwnPropertyNames" in Object && function () {
        try {
          return Object.getOwnPropertyNames(1), !0;
        } catch (t) {
          return !1;
        }
      }())) {
        !function () {
          var t = {}.toString,
              e = "".split,
              r = [].concat,
              o = Object.prototype.hasOwnProperty,
              c = Object.getOwnPropertyNames || Object.keys,
              n = "object" == typeof self ? c(self) : [];
          CreateMethodProperty(Object, "getOwnPropertyNames", function l(a) {
            var p = ToObject(a);
            if ("[object Window]" === t.call(p)) try {
              return c(p);
            } catch (j) {
              return r.call([], n);
            }
            p = "[object String]" == t.call(p) ? e.call(p, "") : Object(p);

            for (var i = c(p), s = ["length", "prototype"], O = 0; O < s.length; O++) {
              var b = s[O];
              o.call(p, b) && !i.includes(b) && i.push(b);
            }

            if (i.includes("__proto__")) {
              var f = i.indexOf("__proto__");
              i.splice(f, 1);
            }

            return i;
          });
        }();
      }

      if (!("includes" in String.prototype)) {
        CreateMethodProperty(String.prototype, "includes", function e(t) {
          "use strict";

          var r = arguments.length > 1 ? arguments[1] : undefined,
              n = RequireObjectCoercible(this),
              i = ToString(n);
          if (IsRegExp(t)) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
          var o = ToString(t),
              g = ToInteger(r),
              a = i.length,
              p = Math.min(Math.max(g, 0), a);
          return -1 !== String.prototype.indexOf.call(i, o, p);
        });
      }

      if (!("Symbol" in self && 0 === self.Symbol.length)) {
        !function (e, r, n) {
          "use strict";

          function t(e) {
            if ("symbol" === Type(e)) return e;
            throw TypeError(e + " is not a symbol");
          }

          var u,
              o = function () {
            try {
              var r = {};
              return e.defineProperty(r, "t", {
                configurable: !0,
                enumerable: !1,
                get: function get() {
                  return !0;
                },
                set: undefined
              }), !!r.t;
            } catch (n) {
              return !1;
            }
          }(),
              i = 0,
              a = "" + Math.random(),
              c = "__symbol:",
              l = c.length,
              f = "__symbol@@" + a,
              s = {},
              v = "defineProperty",
              y = "defineProperties",
              b = "getOwnPropertyNames",
              p = "getOwnPropertyDescriptor",
              h = "propertyIsEnumerable",
              m = e.prototype,
              d = m.hasOwnProperty,
              g = m[h],
              w = m.toString,
              S = Array.prototype.concat,
              P = e.getOwnPropertyNames ? e.getOwnPropertyNames(self) : [],
              O = e[b],
              j = function $(e) {
            if ("[object Window]" === w.call(e)) try {
              return O(e);
            } catch (r) {
              return S.call([], P);
            }
            return O(e);
          },
              E = e[p],
              N = e.create,
              T = e.keys,
              _ = e.freeze || e,
              k = e[v],
              F = e[y],
              I = E(e, b),
              x = function x(e, r, n) {
            if (!d.call(e, f)) try {
              k(e, f, {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: {}
              });
            } catch (t) {
              e[f] = {};
            }
            e[f]["@@" + r] = n;
          },
              z = function z(e, r) {
            var n = N(e);
            return j(r).forEach(function (e) {
              q.call(r, e) && L(n, e, r[e]);
            }), n;
          },
              A = function A(e) {
            var r = N(e);
            return r.enumerable = !1, r;
          },
              D = function ee() {},
              M = function M(e) {
            return e != f && !d.call(H, e);
          },
              W = function W(e) {
            return e != f && d.call(H, e);
          },
              q = function re(e) {
            var r = "" + e;
            return W(r) ? d.call(this, r) && this[f] && this[f]["@@" + r] : g.call(this, e);
          },
              B = function B(r) {
            var n = {
              enumerable: !1,
              configurable: !0,
              get: D,
              set: function set(e) {
                u(this, r, {
                  enumerable: !1,
                  configurable: !0,
                  writable: !0,
                  value: e
                }), x(this, r, !0);
              }
            };

            try {
              k(m, r, n);
            } catch (o) {
              m[r] = n.value;
            }

            H[r] = k(e(r), "constructor", J);
            var t = E(G.prototype, "description");
            return t && k(H[r], "description", t), _(H[r]);
          },
              C = function C(e) {
            var r = t(e);

            if (Y) {
              var n = V(r);
              if ("" !== n) return n.slice(1, -1);
            }

            if (s[r] !== undefined) return s[r];
            var u = r.toString(),
                o = u.lastIndexOf("0.");
            return u = u.slice(10, o), "" === u ? undefined : u;
          },
              G = function ne() {
            var r = arguments[0];
            if (this instanceof ne) throw new TypeError("Symbol is not a constructor");
            var n = c.concat(r || "", a, ++i);
            r === undefined || null !== r && !isNaN(r) && "" !== String(r) || (s[n] = String(r));
            var t = B(n);
            return o || e.defineProperty(t, "description", {
              configurable: !0,
              enumerable: !1,
              value: C(t)
            }), t;
          },
              H = N(null),
              J = {
            value: G
          },
              K = function K(e) {
            return H[e];
          },
              L = function te(e, r, n) {
            var t = "" + r;
            return W(t) ? (u(e, t, n.enumerable ? A(n) : n), x(e, t, !!n.enumerable)) : k(e, r, n), e;
          },
              Q = function Q(e) {
            return function (r) {
              return d.call(e, f) && d.call(e[f], "@@" + r);
            };
          },
              R = function ue(e) {
            return j(e).filter(e === m ? Q(e) : W).map(K);
          };

          I.value = L, k(e, v, I), I.value = R, k(e, "getOwnPropertySymbols", I), I.value = function oe(e) {
            return j(e).filter(M);
          }, k(e, b, I), I.value = function ie(e, r) {
            var n = R(r);
            return n.length ? T(r).concat(n).forEach(function (n) {
              q.call(r, n) && L(e, n, r[n]);
            }) : F(e, r), e;
          }, k(e, y, I), I.value = q, k(m, h, I), I.value = G, k(n, "Symbol", I), I.value = function (e) {
            var r = c.concat(c, e, a);
            return r in m ? H[r] : B(r);
          }, k(G, "for", I), I.value = function (e) {
            if (M(e)) throw new TypeError(e + " is not a symbol");
            return d.call(H, e) ? e.slice(2 * l, -a.length) : void 0;
          }, k(G, "keyFor", I), I.value = function ae(e, r) {
            var n = E(e, r);
            return n && W(r) && (n.enumerable = q.call(e, r)), n;
          }, k(e, p, I), I.value = function ce(e, r) {
            return 1 === arguments.length || void 0 === r ? N(e) : z(e, r);
          }, k(e, "create", I);

          var U = null === function () {
            return this;
          }.call(null);

          if (I.value = U ? function () {
            var e = w.call(this);
            return "[object String]" === e && W(this) ? "[object Symbol]" : e;
          } : function () {
            if (this === window) return "[object Null]";
            var e = w.call(this);
            return "[object String]" === e && W(this) ? "[object Symbol]" : e;
          }, k(m, "toString", I), u = function u(e, r, n) {
            var t = E(m, r);
            delete m[r], k(e, r, n), e !== m && k(m, r, t);
          }, function () {
            try {
              var r = {};
              return e.defineProperty(r, "t", {
                configurable: !0,
                enumerable: !1,
                get: function get() {
                  return !0;
                },
                set: undefined
              }), !!r.t;
            } catch (n) {
              return !1;
            }
          }()) {
            var V;

            try {
              V = Function("s", "var v = s.valueOf(); return { [v]() {} }[v].name;");
            } catch (Z) {}

            var X = function X() {},
                Y = V && "inferred" === X.name ? V : null;

            e.defineProperty(n.Symbol.prototype, "description", {
              configurable: !0,
              enumerable: !1,
              get: function get() {
                return C(this);
              }
            });
          }
        }(Object, 0, self);
      }

      if (!("Symbol" in self && "iterator" in self.Symbol)) {
        Object.defineProperty(self.Symbol, "iterator", {
          value: self.Symbol("iterator")
        });
      }

      function GetIterator(t) {
        var e = arguments.length > 1 ? arguments[1] : GetMethod(t, Symbol.iterator),
            r = Call(e, t);
        if ("object" !== Type(r)) throw new TypeError("bad iterator");
        var o = GetV(r, "next"),
            a = Object.create(null);
        return a["[[Iterator]]"] = r, a["[[NextMethod]]"] = o, a["[[Done]]"] = !1, a;
      }

      if (!("Symbol" in self && "species" in self.Symbol)) {
        Object.defineProperty(Symbol, "species", {
          value: Symbol("species")
        });
      }

      if (!("Map" in self && function (t) {
        try {
          var n = new t.Map([[1, 1], [2, 2]]);
          return 0 === t.Map.length && 2 === n.size && "Symbol" in t && "iterator" in t.Symbol && "function" == typeof n[t.Symbol.iterator];
        } catch (e) {
          return !1;
        }
      }(self))) {
        !function (e) {
          function t(e, t) {
            if ("object" !== Type(e)) throw new TypeError("createMapIterator called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!0 !== e._es6Map) throw new TypeError("createMapIterator called on incompatible receiver " + Object.prototype.toString.call(e));
            var r = Object.create(u);
            return Object.defineProperty(r, "[[Map]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: e
            }), Object.defineProperty(r, "[[MapNextIndex]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: 0
            }), Object.defineProperty(r, "[[MapIterationKind]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: t
            }), r;
          }

          var r = function () {
            try {
              var e = {};
              return Object.defineProperty(e, "t", {
                configurable: !0,
                enumerable: !1,
                get: function get() {
                  return !0;
                },
                set: undefined
              }), !!e.t;
            } catch (t) {
              return !1;
            }
          }(),
              o = 0,
              a = Symbol("meta_" + (1e8 * Math.random() + "").replace(".", "")),
              n = function n(e) {
            if ("object" == typeof e ? null !== e : "function" == typeof e) {
              if (!Object.isExtensible(e)) return !1;

              if (!Object.prototype.hasOwnProperty.call(e, a)) {
                var t = typeof e + "-" + ++o;
                Object.defineProperty(e, a, {
                  configurable: !1,
                  enumerable: !1,
                  writable: !1,
                  value: t
                });
              }

              return e[a];
            }

            return "" + e;
          },
              i = function i(e, t) {
            var r = n(t);
            if (!1 === r) return p(e, t);
            var o = e._table[r];
            return o !== undefined && o;
          },
              p = function p(e, t) {
            for (var r = 0; r < e._keys.length; r++) {
              var o = e._keys[r];
              if (o !== c && SameValueZero(o, t)) return r;
            }

            return !1;
          },
              l = function l(e, t, r) {
            var o = n(t);
            return !1 !== o && (!1 === r ? delete e._table[o] : e._table[o] = r, !0);
          },
              c = Symbol("undef"),
              y = function f() {
            if (!(this instanceof f)) throw new TypeError('Constructor Map requires "new"');
            var e = OrdinaryCreateFromConstructor(this, f.prototype, {
              _table: {},
              _keys: [],
              _values: [],
              _size: 0,
              _es6Map: !0
            });
            r || Object.defineProperty(e, "size", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: 0
            });
            var t = arguments.length > 0 ? arguments[0] : undefined;
            if (null === t || t === undefined) return e;
            var o = e.set;
            if (!IsCallable(o)) throw new TypeError("Map.prototype.set is not a function");

            try {
              for (var a = GetIterator(t);;) {
                var n = IteratorStep(a);
                if (!1 === n) return e;
                var i = IteratorValue(n);
                if ("object" !== Type(i)) try {
                  throw new TypeError("Iterator value " + i + " is not an entry object");
                } catch (u) {
                  return IteratorClose(a, u);
                }

                try {
                  var p = i[0],
                      l = i[1];
                  o.call(e, p, l);
                } catch (s) {
                  return IteratorClose(a, s);
                }
              }
            } catch (s) {
              if (Array.isArray(t) || "[object Arguments]" === Object.prototype.toString.call(t) || t.callee) {
                var c,
                    y = t.length;

                for (c = 0; c < y; c++) {
                  o.call(e, t[c][0], t[c][1]);
                }
              }
            }

            return e;
          };

          Object.defineProperty(y, "prototype", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: {}
          }), r ? Object.defineProperty(y, Symbol.species, {
            configurable: !0,
            enumerable: !1,
            get: function get() {
              return this;
            },
            set: undefined
          }) : CreateMethodProperty(y, Symbol.species, y), CreateMethodProperty(y.prototype, "clear", function b() {
            var e = this;
            if ("object" !== Type(e)) throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!0 !== e._es6Map) throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));

            for (var t = e._keys, o = 0; o < t.length; o++) {
              e._keys[o] = c, e._values[o] = c;
            }

            return this._size = 0, r || (this.size = this._size), this._table = {}, undefined;
          }), CreateMethodProperty(y.prototype, "constructor", y), CreateMethodProperty(y.prototype, "delete", function (e) {
            var t = this;
            if ("object" !== Type(t)) throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Map) throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(t));
            var o = i(t, e);

            if (!1 !== o) {
              var a = t._keys[o];
              if (a !== c && SameValueZero(a, e)) return this._keys[o] = c, this._values[o] = c, this._size = --this._size, r || (this.size = this._size), l(this, e, !1), !0;
            }

            return !1;
          }), CreateMethodProperty(y.prototype, "entries", function h() {
            return t(this, "key+value");
          }), CreateMethodProperty(y.prototype, "forEach", function (e) {
            var t = this;
            if ("object" !== Type(t)) throw new TypeError("Method Map.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Map) throw new TypeError("Method Map.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!IsCallable(e)) throw new TypeError(Object.prototype.toString.call(e) + " is not a function.");
            if (arguments[1]) var r = arguments[1];

            for (var o = t._keys, a = 0; a < o.length; a++) {
              t._keys[a] !== c && t._values[a] !== c && e.call(r, t._values[a], t._keys[a], t);
            }

            return undefined;
          }), CreateMethodProperty(y.prototype, "get", function d(e) {
            var t = this;
            if ("object" !== Type(t)) throw new TypeError("Method Map.prototype.get called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Map) throw new TypeError("Method Map.prototype.get called on incompatible receiver " + Object.prototype.toString.call(t));
            var r = i(t, e);

            if (!1 !== r) {
              var o = t._keys[r];
              if (o !== c && SameValueZero(o, e)) return t._values[r];
            }

            return undefined;
          }), CreateMethodProperty(y.prototype, "has", function v(e) {
            var t = this;
            if ("object" != typeof t) throw new TypeError("Method Map.prototype.has called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Map) throw new TypeError("Method Map.prototype.has called on incompatible receiver " + Object.prototype.toString.call(t));
            var r = i(t, e);

            if (!1 !== r) {
              var o = t._keys[r];
              if (o !== c && SameValueZero(o, e)) return !0;
            }

            return !1;
          }), CreateMethodProperty(y.prototype, "keys", function M() {
            return t(this, "key");
          }), CreateMethodProperty(y.prototype, "set", function w(e, t) {
            var o = this;
            if ("object" !== Type(o)) throw new TypeError("Method Map.prototype.set called on incompatible receiver " + Object.prototype.toString.call(o));
            if (!0 !== o._es6Map) throw new TypeError("Method Map.prototype.set called on incompatible receiver " + Object.prototype.toString.call(o));
            var a = i(o, e);
            if (!1 !== a) o._values[a] = t;else {
              -0 === e && (e = 0);
              var n = {
                "[[Key]]": e,
                "[[Value]]": t
              };
              o._keys.push(n["[[Key]]"]), o._values.push(n["[[Value]]"]), l(o, e, o._keys.length - 1), ++o._size, r || (o.size = o._size);
            }
            return o;
          }), r && Object.defineProperty(y.prototype, "size", {
            configurable: !0,
            enumerable: !1,
            get: function get() {
              var e = this;
              if ("object" !== Type(e)) throw new TypeError("Method Map.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Map) throw new TypeError("Method Map.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
              return this._size;
            },
            set: undefined
          }), CreateMethodProperty(y.prototype, "values", function j() {
            return t(this, "value");
          }), CreateMethodProperty(y.prototype, Symbol.iterator, y.prototype.entries), "name" in y || Object.defineProperty(y, "name", {
            configurable: !0,
            enumerable: !1,
            writable: !1,
            value: "Map"
          });
          var u = {};
          Object.defineProperty(u, "isMapIterator", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: !0
          }), CreateMethodProperty(u, "next", function _() {
            var e = this;
            if ("object" !== Type(e)) throw new TypeError("Method %MapIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!e.isMapIterator) throw new TypeError("Method %MapIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
            var t = e["[[Map]]"],
                r = e["[[MapNextIndex]]"],
                o = e["[[MapIterationKind]]"];
            if (t === undefined) return CreateIterResultObject(undefined, !0);
            if (!t._es6Map) throw new Error(Object.prototype.toString.call(t) + " has a [[MapData]] internal slot.");

            for (var a = t._keys, n = a.length; r < n;) {
              var i = Object.create(null);

              if (i["[[Key]]"] = t._keys[r], i["[[Value]]"] = t._values[r], r += 1, e["[[MapNextIndex]]"] = r, i["[[Key]]"] !== c) {
                if ("key" === o) var p = i["[[Key]]"];else if ("value" === o) p = i["[[Value]]"];else {
                  if ("key+value" !== o) throw new Error();
                  p = [i["[[Key]]"], i["[[Value]]"]];
                }
                return CreateIterResultObject(p, !1);
              }
            }

            return e["[[Map]]"] = undefined, CreateIterResultObject(undefined, !0);
          }), CreateMethodProperty(u, Symbol.iterator, function g() {
            return this;
          });

          try {
            CreateMethodProperty(e, "Map", y);
          } catch (s) {
            e.Map = y;
          }
        }(self);
      }

      if (!("Set" in self && function () {
        try {
          var e = new self.Set([1, 2]);
          return 0 === self.Set.length && 2 === e.size && "Symbol" in self && "iterator" in self.Symbol && "function" == typeof e[self.Symbol.iterator];
        } catch (t) {
          return !1;
        }
      }())) {
        !function (e) {
          function t(e, t) {
            if ("object" != typeof e) throw new TypeError("createSetIterator called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!0 !== e._es6Set) throw new TypeError("createSetIterator called on incompatible receiver " + Object.prototype.toString.call(e));
            var r = Object.create(i);
            return Object.defineProperty(r, "[[IteratedSet]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: e
            }), Object.defineProperty(r, "[[SetNextIndex]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: 0
            }), Object.defineProperty(r, "[[SetIterationKind]]", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: t
            }), r;
          }

          var r = function () {
            try {
              var e = {};
              return Object.defineProperty(e, "t", {
                configurable: !0,
                enumerable: !1,
                get: function get() {
                  return !0;
                },
                set: undefined
              }), !!e.t;
            } catch (t) {
              return !1;
            }
          }(),
              o = Symbol("undef"),
              n = function c() {
            if (!(this instanceof c)) throw new TypeError('Constructor Set requires "new"');
            var e = OrdinaryCreateFromConstructor(this, c.prototype, {
              _values: [],
              _size: 0,
              _es6Set: !0
            });
            r || Object.defineProperty(e, "size", {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: 0
            });
            var t = arguments.length > 0 ? arguments[0] : undefined;
            if (null === t || t === undefined) return e;
            var o = e.add;
            if (!IsCallable(o)) throw new TypeError("Set.prototype.add is not a function");

            try {
              for (var n = GetIterator(t);;) {
                var a = IteratorStep(n);
                if (!1 === a) return e;
                var i = IteratorValue(a);

                try {
                  o.call(e, i);
                } catch (y) {
                  return IteratorClose(n, y);
                }
              }
            } catch (y) {
              if (!Array.isArray(t) && "[object Arguments]" !== Object.prototype.toString.call(t) && !t.callee) throw y;
              var l,
                  p = t.length;

              for (l = 0; l < p; l++) {
                o.call(e, t[l]);
              }
            }

            return e;
          };

          Object.defineProperty(n, "prototype", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: {}
          }), r ? Object.defineProperty(n, Symbol.species, {
            configurable: !0,
            enumerable: !1,
            get: function get() {
              return this;
            },
            set: undefined
          }) : CreateMethodProperty(n, Symbol.species, n), CreateMethodProperty(n.prototype, "add", function p(e) {
            var t = this;
            if ("object" != typeof t) throw new TypeError("Method Set.prototype.add called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Set) throw new TypeError("Method Set.prototype.add called on incompatible receiver " + Object.prototype.toString.call(t));

            for (var n = t._values, a = 0; a < n.length; a++) {
              var i = n[a];
              if (i !== o && SameValueZero(i, e)) return t;
            }

            return 0 === e && 1 / e == -Infinity && (e = 0), t._values.push(e), this._size = ++this._size, r || (this.size = this._size), t;
          }), CreateMethodProperty(n.prototype, "clear", function y() {
            var e = this;
            if ("object" != typeof e) throw new TypeError("Method Set.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!0 !== e._es6Set) throw new TypeError("Method Set.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));

            for (var t = e._values, n = 0; n < t.length; n++) {
              t[n] = o;
            }

            return this._size = 0, r || (this.size = this._size), undefined;
          }), CreateMethodProperty(n.prototype, "constructor", n), CreateMethodProperty(n.prototype, "delete", function (e) {
            var t = this;
            if ("object" != typeof t) throw new TypeError("Method Set.prototype.delete called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Set) throw new TypeError("Method Set.prototype.delete called on incompatible receiver " + Object.prototype.toString.call(t));

            for (var n = t._values, a = 0; a < n.length; a++) {
              var i = n[a];
              if (i !== o && SameValueZero(i, e)) return n[a] = o, this._size = --this._size, r || (this.size = this._size), !0;
            }

            return !1;
          }), CreateMethodProperty(n.prototype, "entries", function u() {
            return t(this, "key+value");
          }), CreateMethodProperty(n.prototype, "forEach", function f(e) {
            var t = this;
            if ("object" != typeof t) throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Set) throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!IsCallable(e)) throw new TypeError(Object.prototype.toString.call(e) + " is not a function.");
            if (arguments[1]) var r = arguments[1];

            for (var n = t._values, a = 0; a < n.length; a++) {
              var i = n[a];
              i !== o && e.call(r, i, i, t);
            }

            return undefined;
          }), CreateMethodProperty(n.prototype, "has", function d(e) {
            var t = this;
            if ("object" != typeof t) throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
            if (!0 !== t._es6Set) throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));

            for (var r = t._values, n = 0; n < r.length; n++) {
              var a = r[n];
              if (a !== o && SameValueZero(a, e)) return !0;
            }

            return !1;
          });

          var a = function h() {
            return t(this, "value");
          };

          CreateMethodProperty(n.prototype, "values", a), CreateMethodProperty(n.prototype, "keys", a), r && Object.defineProperty(n.prototype, "size", {
            configurable: !0,
            enumerable: !1,
            get: function get() {
              var e = this;
              if ("object" != typeof e) throw new TypeError("Method Set.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Set) throw new TypeError("Method Set.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));

              for (var t = e._values, r = 0, n = 0; n < t.length; n++) {
                t[n] !== o && (r += 1);
              }

              return r;
            },
            set: undefined
          }), CreateMethodProperty(n.prototype, Symbol.iterator, a), "name" in n || Object.defineProperty(n, "name", {
            configurable: !0,
            enumerable: !1,
            writable: !1,
            value: "Set"
          });
          var i = {};
          Object.defineProperty(i, "isSetIterator", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: !0
          }), CreateMethodProperty(i, "next", function b() {
            var e = this;
            if ("object" != typeof e) throw new TypeError("Method %SetIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
            if (!e.isSetIterator) throw new TypeError("Method %SetIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
            var t = e["[[IteratedSet]]"],
                r = e["[[SetNextIndex]]"],
                n = e["[[SetIterationKind]]"];
            if (t === undefined) return CreateIterResultObject(undefined, !0);
            if (!t._es6Set) throw new Error(Object.prototype.toString.call(t) + " does not have [[SetData]] internal slot.");

            for (var a = t._values, i = a.length; r < i;) {
              var l = a[r];
              if (r += 1, e["[[SetNextIndex]]"] = r, l !== o) return "key+value" === n ? CreateIterResultObject([l, l], !1) : CreateIterResultObject(l, !1);
            }

            return e["[[IteratedSet]]"] = undefined, CreateIterResultObject(undefined, !0);
          }), CreateMethodProperty(i, Symbol.iterator, function s() {
            return this;
          });

          try {
            CreateMethodProperty(e, "Set", n);
          } catch (l) {
            e.Set = n;
          }
        }(self);
      }

      if (!("from" in Array && function () {
        try {
          return Array.from({
            length: -Infinity
          }), !0;
        } catch (r) {
          return !1;
        }
      }())) {
        !function () {
          function r(r) {
            return "string" == typeof r || "object" == typeof r && "[object String]" === t.call(r);
          }

          var t = Object.prototype.toString,
              e = String.prototype.match;
          CreateMethodProperty(Array, "from", function o(t) {
            var o = this,
                a = arguments.length > 1 ? arguments[1] : undefined;
            if (a === undefined) var n = !1;else {
              if (!1 === IsCallable(a)) throw new TypeError(Object.prototype.toString.call(a) + " is not a function.");
              var i = arguments.length > 2 ? arguments[2] : undefined;
              if (i !== undefined) var l = i;else l = undefined;
              n = !0;
            }
            var u = GetMethod(t, Symbol.iterator);

            if (u !== undefined) {
              if (IsConstructor(o)) var f = Construct(o);else f = ArrayCreate(0);

              for (var c = GetIterator(t, u), s = 0;;) {
                if (s >= Math.pow(2, 53) - 1) {
                  var h = new TypeError("Iteration count can not be greater than or equal 9007199254740991.");
                  return IteratorClose(c, h);
                }

                var y = ToString(s),
                    C = IteratorStep(c);
                if (!1 === C) return f.length = s, f;
                var g = IteratorValue(C);
                if (n) try {
                  var p = Call(a, l, [g, s]);
                } catch (b) {
                  return IteratorClose(c, b);
                } else p = g;

                try {
                  CreateDataPropertyOrThrow(f, y, p);
                } catch (b) {
                  return IteratorClose(c, b);
                }

                s += 1;
              }
            }

            if (r(t)) var v = e.call(t, /[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];else v = ToObject(t);
            var d = ToLength(Get(v, "length"));

            for (f = IsConstructor(o) ? Construct(o, [d]) : ArrayCreate(d), s = 0; s < d;) {
              y = ToString(s);
              var I = Get(v, y);
              p = !0 === n ? Call(a, l, [I, s]) : I, CreateDataPropertyOrThrow(f, y, p), s += 1;
            }

            return f.length = d, f;
          });
        }();
      }

      if (!function (r) {
        "use strict";

        try {
          var a = new r.URL("http://example.com");

          if ("href" in a && "searchParams" in a) {
            var e = new URL("http://example.com");

            if (e.search = "a=1&b=2", "http://example.com/?a=1&b=2" === e.href && (e.search = "", "http://example.com/" === e.href)) {
              if (!("sort" in r.URLSearchParams.prototype)) return !1;
              var t = new r.URLSearchParams("a=1"),
                  n = new r.URLSearchParams(t);
              if ("a=1" !== String(n)) return !1;
              var c = new r.URLSearchParams({
                a: "1"
              });
              if ("a=1" !== String(c)) return !1;
              var h = new r.URLSearchParams([["a", "1"]]);
              return "a=1" === String(h);
            }
          }

          return !1;
        } catch (m) {
          return !1;
        }
      }(self)) {
        !function (e) {
          "use strict";

          function t(t) {
            return !!t && ("Symbol" in e && "iterator" in e.Symbol && "function" == typeof t[Symbol.iterator] || !!Array.isArray(t));
          }

          !function () {
            function n(e) {
              var t = "",
                  n = !0;
              return e.forEach(function (e) {
                var r = encodeURIComponent(e.name),
                    a = encodeURIComponent(e.value);
                n || (t += "&"), t += r + "=" + a, n = !1;
              }), t.replace(/%20/g, "+");
            }

            function r(e, t) {
              var n = e.split("&");
              t && -1 === n[0].indexOf("=") && (n[0] = "=" + n[0]);
              var r = [];
              n.forEach(function (e) {
                if (0 !== e.length) {
                  var t = e.indexOf("=");
                  if (-1 !== t) var n = e.substring(0, t),
                      a = e.substring(t + 1);else n = e, a = "";
                  n = n.replace(/\+/g, " "), a = a.replace(/\+/g, " "), r.push({
                    name: n,
                    value: a
                  });
                }
              });
              var a = [];
              return r.forEach(function (e) {
                a.push({
                  name: decodeURIComponent(e.name),
                  value: decodeURIComponent(e.value)
                });
              }), a;
            }

            function a(e) {
              if (l) return new c(e);
              var t = document.createElement("a");
              return t.href = e, t;
            }

            function i(e) {
              var a = this;
              this._list = [], e === undefined || null === e || (e instanceof i ? this._list = r(String(e)) : "object" == typeof e && t(e) ? Array.from(e).forEach(function (e) {
                if (!t(e)) throw TypeError();
                var n = Array.from(e);
                if (2 !== n.length) throw TypeError();

                a._list.push({
                  name: String(n[0]),
                  value: String(n[1])
                });
              }) : "object" == typeof e && e ? Object.keys(e).forEach(function (t) {
                a._list.push({
                  name: String(t),
                  value: String(e[t])
                });
              }) : (e = String(e), "?" === e.substring(0, 1) && (e = e.substring(1)), this._list = r(e))), this._url_object = null, this._setList = function (e) {
                o || (a._list = e);
              };
              var o = !1;

              this._update_steps = function () {
                o || (o = !0, a._url_object && ("about:" === a._url_object.protocol && -1 !== a._url_object.pathname.indexOf("?") && (a._url_object.pathname = a._url_object.pathname.split("?")[0]), a._url_object.search = n(a._list), o = !1));
              };
            }

            function o(e, t) {
              var n = 0;

              this.next = function () {
                if (n >= e.length) return {
                  done: !0,
                  value: undefined
                };
                var r = e[n++];
                return {
                  done: !1,
                  value: "key" === t ? r.name : "value" === t ? r.value : [r.name, r.value]
                };
              };
            }

            function u(t, n) {
              function o() {
                var e = s.href.replace(/#$|\?$|\?(?=#)/g, "");
                s.href !== e && (s.href = e);
              }

              function u() {
                m._setList(s.search ? r(s.search.substring(1)) : []), m._update_steps();
              }

              if (!(this instanceof e.URL)) throw new TypeError("Failed to construct 'URL': Please use the 'new' operator.");
              n && (t = function () {
                if (l) return new c(t, n).href;
                var e;

                try {
                  var r;
                  if ("[object OperaMini]" === Object.prototype.toString.call(window.operamini) ? (e = document.createElement("iframe"), e.style.display = "none", document.documentElement.appendChild(e), r = e.contentWindow.document) : document.implementation && document.implementation.createHTMLDocument ? r = document.implementation.createHTMLDocument("") : document.implementation && document.implementation.createDocument ? (r = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "html", null), r.documentElement.appendChild(r.createElement("head")), r.documentElement.appendChild(r.createElement("body"))) : window.ActiveXObject && (r = new window.ActiveXObject("htmlfile"), r.write("<head></head><body></body>"), r.close()), !r) throw Error("base not supported");
                  var a = r.createElement("base");
                  a.href = n, r.getElementsByTagName("head")[0].appendChild(a);
                  var i = r.createElement("a");
                  return i.href = t, i.href;
                } finally {
                  e && e.parentNode.removeChild(e);
                }
              }());

              var s = a(t || ""),
                  f = function () {
                if (!("defineProperties" in Object)) return !1;

                try {
                  var e = {};
                  return Object.defineProperties(e, {
                    prop: {
                      get: function get() {
                        return !0;
                      }
                    }
                  }), e.prop;
                } catch (t) {
                  return !1;
                }
              }(),
                  h = f ? this : document.createElement("a"),
                  m = new i(s.search ? s.search.substring(1) : null);

              return m._url_object = h, Object.defineProperties(h, {
                href: {
                  get: function get() {
                    return s.href;
                  },
                  set: function set(e) {
                    s.href = e, o(), u();
                  },
                  enumerable: !0,
                  configurable: !0
                },
                origin: {
                  get: function get() {
                    return "data:" === this.protocol.toLowerCase() ? null : "origin" in s ? s.origin : this.protocol + "//" + this.host;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                protocol: {
                  get: function get() {
                    return s.protocol;
                  },
                  set: function set(e) {
                    s.protocol = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                username: {
                  get: function get() {
                    return s.username;
                  },
                  set: function set(e) {
                    s.username = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                password: {
                  get: function get() {
                    return s.password;
                  },
                  set: function set(e) {
                    s.password = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                host: {
                  get: function get() {
                    var e = {
                      "http:": /:80$/,
                      "https:": /:443$/,
                      "ftp:": /:21$/
                    }[s.protocol];
                    return e ? s.host.replace(e, "") : s.host;
                  },
                  set: function set(e) {
                    s.host = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                hostname: {
                  get: function get() {
                    return s.hostname;
                  },
                  set: function set(e) {
                    s.hostname = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                port: {
                  get: function get() {
                    return s.port;
                  },
                  set: function set(e) {
                    s.port = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                pathname: {
                  get: function get() {
                    return "/" !== s.pathname.charAt(0) ? "/" + s.pathname : s.pathname;
                  },
                  set: function set(e) {
                    s.pathname = e;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                search: {
                  get: function get() {
                    return s.search;
                  },
                  set: function set(e) {
                    s.search !== e && (s.search = e, o(), u());
                  },
                  enumerable: !0,
                  configurable: !0
                },
                searchParams: {
                  get: function get() {
                    return m;
                  },
                  enumerable: !0,
                  configurable: !0
                },
                hash: {
                  get: function get() {
                    return s.hash;
                  },
                  set: function set(e) {
                    s.hash = e, o();
                  },
                  enumerable: !0,
                  configurable: !0
                },
                toString: {
                  value: function value() {
                    return s.toString();
                  },
                  enumerable: !1,
                  configurable: !0
                },
                valueOf: {
                  value: function value() {
                    return s.valueOf();
                  },
                  enumerable: !1,
                  configurable: !0
                }
              }), h;
            }

            var l,
                c = e.URL;

            try {
              if (c) {
                if ("searchParams" in (l = new e.URL("http://example.com"))) {
                  var s = new u("http://example.com");
                  if (s.search = "a=1&b=2", "http://example.com/?a=1&b=2" === s.href && (s.search = "", "http://example.com/" === s.href)) return;
                }

                "href" in l || (l = undefined), l = undefined;
              }
            } catch (h) {}

            if (Object.defineProperties(i.prototype, {
              append: {
                value: function value(e, t) {
                  this._list.push({
                    name: e,
                    value: t
                  }), this._update_steps();
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              "delete": {
                value: function value(e) {
                  for (var t = 0; t < this._list.length;) {
                    this._list[t].name === e ? this._list.splice(t, 1) : ++t;
                  }

                  this._update_steps();
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              get: {
                value: function value(e) {
                  for (var t = 0; t < this._list.length; ++t) {
                    if (this._list[t].name === e) return this._list[t].value;
                  }

                  return null;
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              getAll: {
                value: function value(e) {
                  for (var t = [], n = 0; n < this._list.length; ++n) {
                    this._list[n].name === e && t.push(this._list[n].value);
                  }

                  return t;
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              has: {
                value: function value(e) {
                  for (var t = 0; t < this._list.length; ++t) {
                    if (this._list[t].name === e) return !0;
                  }

                  return !1;
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              set: {
                value: function value(e, t) {
                  for (var n = !1, r = 0; r < this._list.length;) {
                    this._list[r].name === e ? n ? this._list.splice(r, 1) : (this._list[r].value = t, n = !0, ++r) : ++r;
                  }

                  n || this._list.push({
                    name: e,
                    value: t
                  }), this._update_steps();
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              entries: {
                value: function value() {
                  return new o(this._list, "key+value");
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              keys: {
                value: function value() {
                  return new o(this._list, "key");
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              values: {
                value: function value() {
                  return new o(this._list, "value");
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              forEach: {
                value: function value(e) {
                  var t = arguments.length > 1 ? arguments[1] : undefined;

                  this._list.forEach(function (n) {
                    e.call(t, n.value, n.name);
                  });
                },
                writable: !0,
                enumerable: !0,
                configurable: !0
              },
              toString: {
                value: function value() {
                  return n(this._list);
                },
                writable: !0,
                enumerable: !1,
                configurable: !0
              },
              sort: {
                value: function m() {
                  for (var e = this.entries(), t = e.next(), n = [], r = {}; !t.done;) {
                    var a = t.value,
                        i = a[0];
                    n.push(i), Object.prototype.hasOwnProperty.call(r, i) || (r[i] = []), r[i].push(a[1]), t = e.next();
                  }

                  n.sort();

                  for (var o = 0; o < n.length; o++) {
                    this["delete"](n[o]);
                  }

                  for (var u = 0; u < n.length; u++) {
                    i = n[u], this.append(i, r[i].shift());
                  }
                }
              }
            }), "Symbol" in e && "iterator" in e.Symbol && (Object.defineProperty(i.prototype, e.Symbol.iterator, {
              value: i.prototype.entries,
              writable: !0,
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(o.prototype, e.Symbol.iterator, {
              value: function value() {
                return this;
              },
              writable: !0,
              enumerable: !0,
              configurable: !0
            })), c) for (var f in c) {
              Object.prototype.hasOwnProperty.call(c, f) && "function" == typeof c[f] && (u[f] = c[f]);
            }
            e.URL = u, e.URLSearchParams = i;
          }(), function () {
            if ("1" !== new e.URLSearchParams([["a", 1]]).get("a") || "1" !== new e.URLSearchParams({
              a: 1
            }).get("a")) {
              var n = e.URLSearchParams;

              e.URLSearchParams = function (e) {
                if (e && "object" == typeof e && t(e)) {
                  var r = new n();
                  return Array.from(e).forEach(function (e) {
                    if (!t(e)) throw TypeError();
                    var n = Array.from(e);
                    if (2 !== n.length) throw TypeError();
                    r.append(n[0], n[1]);
                  }), r;
                }

                return e && "object" == typeof e ? (r = new n(), Object.keys(e).forEach(function (t) {
                  r.set(t, e[t]);
                }), r) : new n(e);
              };
            }
          }();
        }(self);
      }
    })('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});

    ;
    if (!window.CustomEvent) window.CustomEvent = CustomEvent;
    if (!window.URL) window.URL = URL;
  }
} catch (e) {
  console.debug(e);
}

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var i = t();

    for (var n in i) {
      ("object" == typeof exports ? exports : e)[n] = i[n];
    }
  }
}(self, function () {
  return function () {
    var e = {
      18: function _(e, t, i) {
        var n,
            r,
            o,
            a = ["premium", "referrerPolicy"];

        function s() {
          s = function s(e, t) {
            return new i(e, void 0, t);
          };

          var e = RegExp.prototype,
              t = new WeakMap();

          function i(e, n, r) {
            var o = new RegExp(e, n);
            return t.set(o, r || t.get(e)), c(o, i.prototype);
          }

          function n(e, i) {
            var n = t.get(i);
            return Object.keys(n).reduce(function (t, i) {
              return t[i] = e[n[i]], t;
            }, Object.create(null));
          }

          return l(i, RegExp), i.prototype.exec = function (t) {
            var i = e.exec.call(this, t);
            return i && (i.groups = n(i, this)), i;
          }, i.prototype[Symbol.replace] = function (i, r) {
            if ("string" == typeof r) {
              var o = t.get(this);
              return e[Symbol.replace].call(this, i, r.replace(/\$<([^>]+)>/g, function (e, t) {
                return "$" + o[t];
              }));
            }

            if ("function" == typeof r) {
              var a = this;
              return e[Symbol.replace].call(this, i, function () {
                var e = arguments;
                return "object" !== w(e[e.length - 1]) && (e = [].slice.call(e)).push(n(e, a)), r.apply(this, e);
              });
            }

            return e[Symbol.replace].call(this, i, r);
          }, s.apply(this, arguments);
        }

        function l(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && c(e, t);
        }

        function c(e, t) {
          return (c = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        function u(e) {
          return function (e) {
            if (Array.isArray(e)) return b(e);
          }(e) || function (e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
          }(e) || y(e) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function p(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function d(e, t) {
          for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function h(e, t, i) {
          return t && d(e.prototype, t), i && d(e, i), e;
        }

        function f(e, t) {
          var i = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, n);
          }

          return i;
        }

        function m(e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2 ? f(Object(i), !0).forEach(function (t) {
              v(e, t, i[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : f(Object(i)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
            });
          }

          return e;
        }

        function g(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

            if (null != i) {
              var n,
                  r,
                  o = [],
                  a = !0,
                  s = !1;

              try {
                for (i = i.call(e); !(a = (n = i.next()).done) && (o.push(n.value), !t || o.length !== t); a = !0) {
                  ;
                }
              } catch (e) {
                s = !0, r = e;
              } finally {
                try {
                  a || null == i.return || i.return();
                } finally {
                  if (s) throw r;
                }
              }

              return o;
            }
          }(e, t) || y(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function y(e, t) {
          if (e) {
            if ("string" == typeof e) return b(e, t);
            var i = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? b(e, t) : void 0;
          }
        }

        function b(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var i = 0, n = new Array(t); i < t; i++) {
            n[i] = e[i];
          }

          return n;
        }

        function v(e, t, i) {
          return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = i, e;
        }

        function w(e) {
          return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        "object" == ("undefined" == typeof navigator ? "undefined" : w(navigator)) && (o = function o() {
          "use strict";

          function e(e, t, i) {
            return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }

          function t(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
          }

          function n(e, t, i) {
            return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = i, e;
          }

          function r(e, t) {
            var i = Object.keys(e);

            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              t && (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), i.push.apply(i, n);
            }

            return i;
          }

          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var i = null != arguments[t] ? arguments[t] : {};
              t % 2 ? r(Object(i), !0).forEach(function (t) {
                n(e, t, i[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : r(Object(i)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
              });
            }

            return e;
          }

          var l = {
            addCSS: !0,
            thumbWidth: 15,
            watch: !0
          };

          function c(e, t) {
            return function () {
              return Array.from(document.querySelectorAll(t)).includes(this);
            }.call(e, t);
          }

          var d = function d(e) {
            return null != e ? e.constructor : null;
          },
              f = function f(e, t) {
            return !!(e && t && e instanceof t);
          },
              y = function y(e) {
            return d(e) === String;
          },
              b = function b(e) {
            return Array.isArray(e);
          },
              _ = function _(e) {
            return f(e, NodeList);
          },
              k = y,
              x = b,
              T = _,
              C = function C(e) {
            return f(e, Element);
          },
              S = function S(e) {
            return f(e, Event);
          },
              A = function A(e) {
            return function (e) {
              return null == e;
            }(e) || (y(e) || b(e) || _(e)) && !e.length || function (e) {
              return d(e) === Object;
            }(e) && !Object.keys(e).length;
          },
              E = function () {
            function e(t, i) {
              (function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              })(this, e), C(t) ? this.element = t : k(t) && (this.element = document.querySelector(t)), C(this.element) && A(this.element.rangeTouch) && (this.config = o({}, l, {}, i), this.init());
            }

            return function (e, i, n) {
              i && t(e.prototype, i), n && t(e, n);
            }(e, [{
              key: "init",
              value: function value() {
                e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
              }
            }, {
              key: "destroy",
              value: function value() {
                e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
              }
            }, {
              key: "listeners",
              value: function value(e) {
                var t = this,
                    i = e ? "addEventListener" : "removeEventListener";
                ["touchstart", "touchmove", "touchend"].forEach(function (e) {
                  t.element[i](e, function (e) {
                    return t.set(e);
                  }, !1);
                });
              }
            }, {
              key: "get",
              value: function value(t) {
                if (!e.enabled || !S(t)) return null;
                var i,
                    n = t.target,
                    r = t.changedTouches[0],
                    o = parseFloat(n.getAttribute("min")) || 0,
                    a = parseFloat(n.getAttribute("max")) || 100,
                    s = parseFloat(n.getAttribute("step")) || 1,
                    l = n.getBoundingClientRect(),
                    c = 100 / l.width * (this.config.thumbWidth / 2) / 100;
                return 0 > (i = 100 / l.width * (r.clientX - l.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), o + function (e, t) {
                  if (1 > t) {
                    var i = function (e) {
                      var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                      return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
                    }(t);

                    return parseFloat(e.toFixed(i));
                  }

                  return Math.round(e / t) * t;
                }(i / 100 * (a - o), s);
              }
            }, {
              key: "set",
              value: function value(t) {
                e.enabled && S(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function (e, t) {
                  if (e && t) {
                    var i = new Event(t, {
                      bubbles: !0
                    });
                    e.dispatchEvent(i);
                  }
                }(t.target, "touchend" === t.type ? "change" : "input"));
              }
            }], [{
              key: "setup",
              value: function value(t) {
                var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                    n = null;
                if (A(t) || k(t) ? n = Array.from(document.querySelectorAll(k(t) ? t : 'input[type="range"]')) : C(t) ? n = [t] : T(t) ? n = Array.from(t) : x(t) && (n = t.filter(C)), A(n)) return null;
                var r = o({}, l, {}, i);

                if (k(t) && r.watch) {
                  var a = new MutationObserver(function (i) {
                    Array.from(i).forEach(function (i) {
                      Array.from(i.addedNodes).forEach(function (i) {
                        C(i) && c(i, t) && new e(i, r);
                      });
                    });
                  });
                  a.observe(document.body, {
                    childList: !0,
                    subtree: !0
                  });
                }

                return n.map(function (t) {
                  return new e(t, i);
                });
              }
            }, {
              key: "enabled",
              get: function get() {
                return "ontouchstart" in document.documentElement;
              }
            }]), e;
          }(),
              P = function P(e) {
            return null != e ? e.constructor : null;
          },
              z = function z(e, t) {
            return Boolean(e && t && e instanceof t);
          },
              M = function M(e) {
            return null == e;
          },
              I = function I(e) {
            return P(e) === Object;
          },
              L = function L(e) {
            return P(e) === String;
          },
              N = function N(e) {
            return P(e) === Function;
          },
              O = function O(e) {
            return Array.isArray(e);
          },
              j = function j(e) {
            return z(e, NodeList);
          },
              H = function H(e) {
            return M(e) || (L(e) || O(e) || j(e)) && !e.length || I(e) && !Object.keys(e).length;
          },
              V = M,
              R = I,
              D = function D(e) {
            return P(e) === Number && !Number.isNaN(e);
          },
              q = L,
              B = function B(e) {
            return P(e) === Boolean;
          },
              F = N,
              U = O,
              W = j,
              Y = function Y(e) {
            return null !== e && "object" == w(e) && 1 === e.nodeType && "object" == w(e.style) && "object" == w(e.ownerDocument);
          },
              K = function K(e) {
            return z(e, Event);
          },
              X = function X(e) {
            return z(e, KeyboardEvent);
          },
              J = function J(e) {
            return z(e, TextTrack) || !M(e) && L(e.kind);
          },
              $ = function $(e) {
            if (z(e, window.URL)) return !0;
            if (!L(e)) return !1;
            var t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = "http://".concat(e));

            try {
              return !H(new URL(t).hostname);
            } catch (e) {
              return !1;
            }
          },
              Q = H,
              G = function () {
            var e = document.createElement("span"),
                t = {
              WebkitTransition: "webkitTransitionEnd",
              MozTransition: "transitionend",
              OTransition: "oTransitionEnd otransitionend",
              transition: "transitionend"
            },
                i = Object.keys(t).find(function (t) {
              return void 0 !== e.style[t];
            });
            return !!q(i) && t[i];
          }();

          function Z(e, t) {
            setTimeout(function () {
              try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
              } catch (e) {}
            }, t);
          }

          var ee = {
            isIE: Boolean(window.document.documentMode),
            isEdge: window.navigator.userAgent.includes("Edge"),
            isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/.test(navigator.userAgent),
            isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
            isIos: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 || /(iPad|iPhone|iPod)/gi.test(navigator.platform)
          };

          function te(e, t) {
            return t.split(".").reduce(function (e, t) {
              return e && e[t];
            }, e);
          }

          function ie() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              i[n - 1] = arguments[n];
            }

            if (!i.length) return e;
            var r = i.shift();
            return R(r) ? (Object.keys(r).forEach(function (t) {
              R(r[t]) ? (Object.keys(e).includes(t) || Object.assign(e, v({}, t, {})), ie(e[t], r[t])) : Object.assign(e, v({}, t, r[t]));
            }), ie.apply(void 0, [e].concat(i))) : e;
          }

          function ne(e, t) {
            var i = e.length ? e : [e];
            Array.from(i).reverse().forEach(function (e, i) {
              var n = i > 0 ? t.cloneNode(!0) : t,
                  r = e.parentNode,
                  o = e.nextSibling;
              n.appendChild(e), o ? r.insertBefore(n, o) : r.appendChild(n);
            });
          }

          function re(e, t) {
            Y(e) && !Q(t) && Object.entries(t).filter(function (e) {
              var t = g(e, 2)[1];
              return !V(t);
            }).forEach(function (t) {
              var i = g(t, 2),
                  n = i[0],
                  r = i[1];
              return e.setAttribute(n, r);
            });
          }

          function oe(e, t, i) {
            var n = document.createElement(e);
            return R(t) && re(n, t), q(i) && (n.innerText = i), n;
          }

          function ae(e, t, i, n) {
            Y(t) && t.appendChild(oe(e, i, n));
          }

          function se(e) {
            W(e) || U(e) ? Array.from(e).forEach(se) : Y(e) && Y(e.parentNode) && e.parentNode.removeChild(e);
          }

          function le(e) {
            if (Y(e)) for (var t = e.childNodes.length; t > 0;) {
              e.removeChild(e.lastChild), t -= 1;
            }
          }

          function ce(e, t) {
            return Y(t) && Y(t.parentNode) && Y(e) ? (t.parentNode.replaceChild(e, t), e) : null;
          }

          function ue(e, t) {
            if (!q(e) || Q(e)) return {};
            var i = {},
                n = ie({}, t);
            return e.split(",").forEach(function (e) {
              var t = e.trim(),
                  r = t.replace(".", ""),
                  o = t.replace(/[[\]]/g, "").split("="),
                  a = g(o, 1)[0],
                  s = o.length > 1 ? o[1].replace(/["']/g, "") : "";

              switch (t.charAt(0)) {
                case ".":
                  q(n.class) ? i.class = "".concat(n.class, " ").concat(r) : i.class = r;
                  break;

                case "#":
                  i.id = t.replace("#", "");
                  break;

                case "[":
                  i[a] = s;
              }
            }), ie(n, i);
          }

          function pe(e, t) {
            if (Y(e)) {
              var i = t;
              B(i) || (i = !e.hidden), e.hidden = i;
            }
          }

          function de(e, t, i) {
            if (W(e)) return Array.from(e).map(function (e) {
              return de(e, t, i);
            });

            if (Y(e)) {
              var n = "toggle";
              return void 0 !== i && (n = i ? "add" : "remove"), e.classList[n](t), e.classList.contains(t);
            }

            return !1;
          }

          function he(e, t) {
            return Y(e) && e.classList.contains(t);
          }

          function fe(e, t) {
            var i = Element.prototype;
            return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function () {
              return Array.from(document.querySelectorAll(t)).includes(this);
            }).call(e, t);
          }

          function me(e) {
            return this.elements.container.querySelectorAll(e);
          }

          function ge(e) {
            return this.elements.container.querySelector(e);
          }

          function ye() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            Y(e) && (e.focus({
              preventScroll: !0
            }), t && de(e, this.config.classNames.tabFocus));
          }

          var be = {
            "audio/ogg": "vorbis",
            "audio/wav": "1",
            "video/webm": "vp8, vorbis",
            "video/mp4": "avc1.42E01E, mp4a.40.2",
            "video/ogg": "theora"
          },
              ve = {
            audio: "canPlayType" in document.createElement("audio"),
            video: "canPlayType" in document.createElement("video"),
            check: function check(e, t, i) {
              var n = ee.isIPhone && i && ve.playsinline,
                  r = ve[e] || "html5" !== t;
              return {
                api: r,
                ui: r && ve.rangeInput && ("video" !== e || !ee.isIPhone || n)
              };
            },
            pip: !(ee.isIPhone || !F(oe("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || oe("video").disablePictureInPicture)),
            airplay: F(window.WebKitPlaybackTargetAvailabilityEvent),
            playsinline: "playsInline" in document.createElement("video"),
            mime: function mime(e) {
              if (Q(e)) return !1;
              var t = g(e.split("/"), 1)[0],
                  i = e;
              if (!this.isHTML5 || t !== this.type) return !1;
              Object.keys(be).includes(i) && (i += '; codecs="'.concat(be[e], '"'));

              try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
              } catch (e) {
                return !1;
              }
            },
            textTracks: "textTracks" in document.createElement("video"),
            rangeInput: function () {
              var e = document.createElement("input");
              return e.type = "range", "range" === e.type;
            }(),
            touch: "ontouchstart" in document.documentElement,
            transitions: !1 !== G,
            reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
          },
              we = function () {
            var e = !1;

            try {
              var t = Object.defineProperty({}, "passive", {
                get: function get() {
                  return e = !0, null;
                }
              });
              window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
            } catch (e) {}

            return e;
          }();

          function _e(e, t, i) {
            var n = this,
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];

            if (e && "addEventListener" in e && !Q(t) && F(i)) {
              var s = t.split(" "),
                  l = a;
              we && (l = {
                passive: o,
                capture: a
              }), s.forEach(function (t) {
                n && n.eventListeners && r && n.eventListeners.push({
                  element: e,
                  type: t,
                  callback: i,
                  options: l
                }), e[r ? "addEventListener" : "removeEventListener"](t, i, l);
              });
            }
          }

          function ke(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                i = arguments.length > 2 ? arguments[2] : void 0,
                n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];

            _e.call(this, e, t, i, !0, n, r);
          }

          function xe(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                i = arguments.length > 2 ? arguments[2] : void 0,
                n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];

            _e.call(this, e, t, i, !1, n, r);
          }

          function Te(e) {
            var t = this,
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                n = arguments.length > 2 ? arguments[2] : void 0,
                r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                a = function a() {
              for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++) {
                l[c] = arguments[c];
              }

              xe(e, i, a, r, o), n.apply(t, l);
            };

            _e.call(this, e, i, a, !0, r, o);
          }

          function Ce(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};

            if (Y(e) && !Q(t)) {
              var r = new CustomEvent(t, {
                bubbles: i,
                detail: m(m({}, n), {}, {
                  plyr: this
                })
              });
              e.dispatchEvent(r);
            }
          }

          function Se() {
            this && this.eventListeners && (this.eventListeners.forEach(function (e) {
              var t = e.element,
                  i = e.type,
                  n = e.callback,
                  r = e.options;
              t.removeEventListener(i, n, r);
            }), this.eventListeners = []);
          }

          function Ae() {
            var e = this;
            return new Promise(function (t) {
              return e.ready ? setTimeout(t, 0) : ke.call(e, e.elements.container, "ready", t);
            }).then(function () {});
          }

          function Ee(e) {
            (function (e) {
              return z(e, Promise) && N(e.then);
            })(e) && e.then(null, function () {});
          }

          function Pe(e) {
            return U(e) ? e.filter(function (t, i) {
              return e.indexOf(t) === i;
            }) : e;
          }

          function ze(e, t) {
            return U(e) && e.length ? e.reduce(function (e, i) {
              return Math.abs(i - t) < Math.abs(e - t) ? i : e;
            }) : null;
          }

          function Me(e) {
            return !(!window || !window.CSS) && window.CSS.supports(e);
          }

          var Ie = [[1, 1], [4, 3], [3, 4], [5, 4], [4, 5], [3, 2], [2, 3], [16, 10], [10, 16], [16, 9], [9, 16], [21, 9], [9, 21], [32, 9], [9, 32]].reduce(function (e, t) {
            var i = g(t, 2),
                n = i[0],
                r = i[1];
            return m(m({}, e), {}, v({}, n / r, [n, r]));
          }, {});

          function Le(e) {
            return !!(U(e) || q(e) && e.includes(":")) && (U(e) ? e : e.split(":")).map(Number).every(D);
          }

          function Ne(e) {
            if (!U(e) || !e.every(D)) return null;

            var t = g(e, 2),
                i = t[0],
                n = t[1],
                r = function e(t, i) {
              return 0 === i ? t : e(i, t % i);
            }(i, n);

            return [i / r, n / r];
          }

          function Oe(e) {
            var t = function t(e) {
              return Le(e) ? e.split(":").map(Number) : null;
            },
                i = t(e);

            if (null === i && (i = t(this.config.ratio)), null === i && !Q(this.embed) && U(this.embed.ratio) && (i = this.embed.ratio), null === i && this.isHTML5) {
              var n = this.media;
              i = [n.videoWidth, n.videoHeight];
            }

            return Ne(i);
          }

          function je(e) {
            if (!this.isVideo) return {};
            var t = this.elements.wrapper,
                i = Oe.call(this, e);
            if (!U(i)) return {};
            var n = g(Ne(i), 2),
                r = n[0],
                o = n[1],
                a = 100 / r * o;

            if (Me("aspect-ratio: ".concat(r, "/").concat(o)) ? t.style.aspectRatio = "".concat(r, "/").concat(o) : t.style.paddingBottom = "".concat(a, "%"), this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
              var s = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10),
                  l = (s - a) / (s / 50);
              this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = "translateY(-".concat(l, "%)");
            } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);

            return {
              padding: a,
              ratio: i
            };
          }

          function He(e, t) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .05,
                n = e / t,
                r = ze(Object.keys(Ie), n);
            return Math.abs(r - n) <= i ? Ie[r] : [e, t];
          }

          var Ve = {
            getSources: function getSources() {
              var e = this;
              return this.isHTML5 ? Array.from(this.media.querySelectorAll("source")).filter(function (t) {
                var i = t.getAttribute("type");
                return !!Q(i) || ve.mime.call(e, i);
              }) : [];
            },
            getQualityOptions: function getQualityOptions() {
              return this.config.quality.forced ? this.config.quality.options : Ve.getSources.call(this).map(function (e) {
                return Number(e.getAttribute("size"));
              }).filter(Boolean);
            },
            setup: function setup() {
              if (this.isHTML5) {
                var e = this;
                e.options.speed = e.config.speed.options, Q(this.config.ratio) || je.call(e), Object.defineProperty(e.media, "quality", {
                  get: function get() {
                    var t = Ve.getSources.call(e).find(function (t) {
                      return t.getAttribute("src") === e.source;
                    });
                    return t && Number(t.getAttribute("size"));
                  },
                  set: function set(t) {
                    if (e.quality !== t) {
                      if (e.config.quality.forced && F(e.config.quality.onChange)) e.config.quality.onChange(t);else {
                        var i = Ve.getSources.call(e).find(function (e) {
                          return Number(e.getAttribute("size")) === t;
                        });
                        if (!i) return;
                        var n = e.media,
                            r = n.currentTime,
                            o = n.paused,
                            a = n.preload,
                            s = n.readyState,
                            l = n.playbackRate;
                        e.media.src = i.getAttribute("src"), ("none" !== a || s) && (e.once("loadedmetadata", function () {
                          e.speed = l, e.currentTime = r, o || Ee(e.play());
                        }), e.media.load());
                      }
                      Ce.call(e, e.media, "qualitychange", !1, {
                        quality: t
                      });
                    }
                  }
                });
              }
            },
            cancelRequests: function cancelRequests() {
              this.isHTML5 && (se(Ve.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
            }
          };

          function Re(e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              i[n - 1] = arguments[n];
            }

            return Q(e) ? e : e.toString().replace(/{(\d+)}/g, function (e, t) {
              return i[t].toString();
            });
          }

          var De = function De() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
            return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString());
          },
              qe = function qe() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return e.toString().replace(/\w\S*/g, function (e) {
              return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
            });
          };

          function Be(e) {
            var t = document.createElement("div");
            return t.appendChild(e), t.innerHTML;
          }

          var Fe = {
            pip: "PIP",
            airplay: "AirPlay",
            html5: "HTML5",
            vimeo: "Vimeo",
            youtube: "YouTube"
          },
              Ue = function Ue() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (Q(e) || Q(t)) return "";
            var i = te(t.i18n, e);
            if (Q(i)) return Object.keys(Fe).includes(e) ? Fe[e] : "";
            var n = {
              "{seektime}": t.seekTime,
              "{title}": t.title
            };
            return Object.entries(n).forEach(function (e) {
              var t = g(e, 2),
                  n = t[0],
                  r = t[1];
              i = De(i, n, r);
            }), i;
          },
              We = function () {
            function t(i) {
              var n = this;
              p(this, t), e(this, "get", function (e) {
                if (!t.supported || !n.enabled) return null;
                var i = window.localStorage.getItem(n.key);
                if (Q(i)) return null;
                var r = JSON.parse(i);
                return q(e) && e.length ? r[e] : r;
              }), e(this, "set", function (e) {
                if (t.supported && n.enabled && R(e)) {
                  var i = n.get();
                  Q(i) && (i = {}), ie(i, e);

                  try {
                    window.localStorage.setItem(n.key, JSON.stringify(i));
                  } catch (e) {}
                }
              }), this.enabled = i.config.storage.enabled, this.key = i.config.storage.key;
            }

            return h(t, null, [{
              key: "supported",
              get: function get() {
                try {
                  if (!("localStorage" in window)) return !1;
                  var e = "___test";
                  return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
                } catch (e) {
                  return !1;
                }
              }
            }]), t;
          }();

          function Ye(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "text";
            return new Promise(function (i, n) {
              try {
                var r = new XMLHttpRequest();
                if (!("withCredentials" in r)) return;
                r.addEventListener("load", function () {
                  if ("text" === t) try {
                    i(JSON.parse(r.responseText));
                  } catch (e) {
                    i(r.responseText);
                  } else i(r.response);
                }), r.addEventListener("error", function () {
                  throw new Error(r.status);
                }), r.open("GET", e, !0), r.responseType = t, r.send();
              } catch (e) {
                n(e);
              }
            });
          }

          function Ke(e, t) {
            if (q(e)) {
              var i = q(t),
                  n = function n() {
                return null !== document.getElementById(t);
              },
                  r = function r(e, t) {
                e.innerHTML = t, i && n() || document.body.insertAdjacentElement("afterbegin", e);
              };

              if (!i || !n()) {
                var o = We.supported,
                    a = document.createElement("div");

                if (a.setAttribute("hidden", ""), i && a.setAttribute("id", t), o) {
                  var s = window.localStorage.getItem("cache-".concat(t));

                  if (null !== s) {
                    var l = JSON.parse(s);
                    r(a, l.content);
                  }
                }

                Ye(e).then(function (e) {
                  if (!Q(e)) {
                    if (o) try {
                      window.localStorage.setItem("cache-".concat(t), JSON.stringify({
                        content: e
                      }));
                    } catch (e) {}
                    r(a, e);
                  }
                }).catch(function () {});
              }
            }
          }

          var Xe = function Xe(e) {
            return Math.trunc(e / 60 / 60 % 60, 10);
          };

          function Je() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if (!D(e)) return Je(void 0, t, i);

            var n,
                r = function r(e) {
              return "0".concat(e).slice(-2);
            },
                o = Xe(e),
                a = (n = e, Math.trunc(n / 60 % 60, 10)),
                s = function (e) {
              return Math.trunc(e % 60, 10);
            }(e);

            return o = t || o > 0 ? "".concat(o, ":") : "", "".concat(i && e > 0 ? "-" : "").concat(o).concat(r(a), ":").concat(r(s));
          }

          var $e = {
            getIconUrl: function getIconUrl() {
              var e = new URL(this.config.iconUrl, window.location),
                  t = window.location.host ? window.location.host : window.top.location.host,
                  i = e.host !== t || ee.isIE && !window.svg4everybody;
              return {
                url: this.config.iconUrl,
                cors: i
              };
            },
            findElements: function findElements() {
              try {
                return this.elements.controls = ge.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                  play: me.call(this, this.config.selectors.buttons.play),
                  pause: ge.call(this, this.config.selectors.buttons.pause),
                  restart: ge.call(this, this.config.selectors.buttons.restart),
                  rewind: ge.call(this, this.config.selectors.buttons.rewind),
                  fastForward: ge.call(this, this.config.selectors.buttons.fastForward),
                  mute: ge.call(this, this.config.selectors.buttons.mute),
                  pip: ge.call(this, this.config.selectors.buttons.pip),
                  airplay: ge.call(this, this.config.selectors.buttons.airplay),
                  settings: ge.call(this, this.config.selectors.buttons.settings),
                  captions: ge.call(this, this.config.selectors.buttons.captions),
                  fullscreen: ge.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = ge.call(this, this.config.selectors.progress), this.elements.inputs = {
                  seek: ge.call(this, this.config.selectors.inputs.seek),
                  volume: ge.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                  buffer: ge.call(this, this.config.selectors.display.buffer),
                  currentTime: ge.call(this, this.config.selectors.display.currentTime),
                  duration: ge.call(this, this.config.selectors.display.duration)
                }, Y(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip))), !0;
              } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
              }
            },
            createIcon: function createIcon(e, t) {
              var i = "http://www.w3.org/2000/svg",
                  n = $e.getIconUrl.call(this),
                  r = "".concat(n.cors ? "" : n.url, "#").concat(this.config.iconPrefix),
                  o = document.createElementNS(i, "svg");
              re(o, ie(t, {
                "aria-hidden": "true",
                focusable: "false"
              }));
              var a = document.createElementNS(i, "use"),
                  s = "".concat(r, "-").concat(e);
              return "href" in a && a.setAttributeNS("http://www.w3.org/1999/xlink", "href", s), a.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", s), o.appendChild(a), o;
            },
            createLabel: function createLabel(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  i = Ue(e, this.config);
              return oe("span", m(m({}, t), {}, {
                class: [t.class, this.config.classNames.hidden].filter(Boolean).join(" ")
              }), i);
            },
            createBadge: function createBadge(e) {
              if (Q(e)) return null;
              var t = oe("span", {
                class: this.config.classNames.menu.value
              });
              return t.appendChild(oe("span", {
                class: this.config.classNames.menu.badge
              }, e)), t;
            },
            createButton: function createButton(e, t) {
              var i = this,
                  n = ie({}, t),
                  r = function () {
                var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString();
                return (e = function () {
                  var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString();
                  return e = De(e, "-", " "), e = De(e, "_", " "), e = qe(e), De(e, " ", "");
                }(e)).charAt(0).toLowerCase() + e.slice(1);
              }(e),
                  o = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
              };

              switch (["element", "icon", "label"].forEach(function (e) {
                Object.keys(n).includes(e) && (o[e] = n[e], delete n[e]);
              }), "button" !== o.element || Object.keys(n).includes("type") || (n.type = "button"), Object.keys(n).includes("class") ? n.class.split(" ").some(function (e) {
                return e === i.config.classNames.control;
              }) || ie(n, {
                class: "".concat(n.class, " ").concat(this.config.classNames.control)
              }) : n.class = this.config.classNames.control, e) {
                case "play":
                  o.toggle = !0, o.label = "play", o.labelPressed = "pause", o.icon = "play", o.iconPressed = "pause";
                  break;

                case "mute":
                  o.toggle = !0, o.label = "mute", o.labelPressed = "unmute", o.icon = "volume", o.iconPressed = "muted";
                  break;

                case "captions":
                  o.toggle = !0, o.label = "enableCaptions", o.labelPressed = "disableCaptions", o.icon = "captions-off", o.iconPressed = "captions-on";
                  break;

                case "fullscreen":
                  o.toggle = !0, o.label = "enterFullscreen", o.labelPressed = "exitFullscreen", o.icon = "enter-fullscreen", o.iconPressed = "exit-fullscreen";
                  break;

                case "play-large":
                  n.class += " ".concat(this.config.classNames.control, "--overlaid"), r = "play", o.label = "play", o.icon = "play";
                  break;

                default:
                  Q(o.label) && (o.label = r), Q(o.icon) && (o.icon = e);
              }

              var a = oe(o.element);
              return o.toggle ? (a.appendChild($e.createIcon.call(this, o.iconPressed, {
                class: "icon--pressed"
              })), a.appendChild($e.createIcon.call(this, o.icon, {
                class: "icon--not-pressed"
              })), a.appendChild($e.createLabel.call(this, o.labelPressed, {
                class: "label--pressed"
              })), a.appendChild($e.createLabel.call(this, o.label, {
                class: "label--not-pressed"
              }))) : (a.appendChild($e.createIcon.call(this, o.icon)), a.appendChild($e.createLabel.call(this, o.label))), ie(n, ue(this.config.selectors.buttons[r], n)), re(a, n), "play" === r ? (U(this.elements.buttons[r]) || (this.elements.buttons[r] = []), this.elements.buttons[r].push(a)) : this.elements.buttons[r] = a, a;
            },
            createRange: function createRange(e, t) {
              var i = oe("input", ie(ue(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": Ue(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
              }, t));
              return this.elements.inputs[e] = i, $e.updateRangeFill.call(this, i), E.setup(i), i;
            },
            createProgress: function createProgress(e, t) {
              var i = oe("progress", ie(ue(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
              }, t));

              if ("volume" !== e) {
                i.appendChild(oe("span", null, "0"));
                var n = {
                  played: "played",
                  buffer: "buffered"
                }[e],
                    r = n ? Ue(n, this.config) : "";
                i.innerText = "% ".concat(r.toLowerCase());
              }

              return this.elements.display[e] = i, i;
            },
            createTime: function createTime(e, t) {
              var i = ue(this.config.selectors.display[e], t),
                  n = oe("div", ie(i, {
                class: "".concat(i.class ? i.class : "", " ").concat(this.config.classNames.display.time, " ").trim(),
                "aria-label": Ue(e, this.config)
              }), "00:00");
              return this.elements.display[e] = n, n;
            },
            bindMenuItemShortcuts: function bindMenuItemShortcuts(e, t) {
              var i = this;
              ke.call(this, e, "keydown keyup", function (n) {
                if ([32, 38, 39, 40].includes(n.which) && (n.preventDefault(), n.stopPropagation(), "keydown" !== n.type)) {
                  var r,
                      o = fe(e, '[role="menuitemradio"]');
                  !o && [32, 39].includes(n.which) ? $e.showMenuPanel.call(i, t, !0) : 32 !== n.which && (40 === n.which || o && 39 === n.which ? (r = e.nextElementSibling, Y(r) || (r = e.parentNode.firstElementChild)) : (r = e.previousElementSibling, Y(r) || (r = e.parentNode.lastElementChild)), ye.call(i, r, !0));
                }
              }, !1), ke.call(this, e, "keyup", function (e) {
                13 === e.which && $e.focusFirstMenuItem.call(i, null, !0);
              });
            },
            createMenuItem: function createMenuItem(e) {
              var t = this,
                  i = e.value,
                  n = e.list,
                  r = e.type,
                  o = e.title,
                  a = e.badge,
                  s = void 0 === a ? null : a,
                  l = e.checked,
                  c = void 0 !== l && l,
                  u = ue(this.config.selectors.inputs[r]),
                  p = oe("button", ie(u, {
                type: "button",
                role: "menuitemradio",
                class: "".concat(this.config.classNames.control, " ").concat(u.class ? u.class : "").trim(),
                "aria-checked": c,
                value: i
              })),
                  d = oe("span");
              d.innerHTML = o, Y(s) && d.appendChild(s), p.appendChild(d), Object.defineProperty(p, "checked", {
                enumerable: !0,
                get: function get() {
                  return "true" === p.getAttribute("aria-checked");
                },
                set: function set(e) {
                  e && Array.from(p.parentNode.children).filter(function (e) {
                    return fe(e, '[role="menuitemradio"]');
                  }).forEach(function (e) {
                    return e.setAttribute("aria-checked", "false");
                  }), p.setAttribute("aria-checked", e ? "true" : "false");
                }
              }), this.listeners.bind(p, "click keyup", function (e) {
                if (!X(e) || 32 === e.which) {
                  switch (e.preventDefault(), e.stopPropagation(), p.checked = !0, r) {
                    case "language":
                      t.currentTrack = Number(i);
                      break;

                    case "quality":
                      t.quality = i;
                      break;

                    case "speed":
                      t.speed = parseFloat(i);
                  }

                  $e.showMenuPanel.call(t, "home", X(e));
                }
              }, r, !1), $e.bindMenuItemShortcuts.call(this, p, r), n.appendChild(p);
            },
            formatTime: function formatTime() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                  t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              return D(e) ? Je(e, Xe(this.duration) > 0, t) : e;
            },
            updateTimeDisplay: function updateTimeDisplay() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                  t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                  i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
              Y(e) && D(t) && (e.innerText = $e.formatTime(t, i));
            },
            updateVolume: function updateVolume() {
              this.supported.ui && (Y(this.elements.inputs.volume) && $e.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), Y(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
            },
            setRange: function setRange(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
              Y(e) && (e.value = t, $e.updateRangeFill.call(this, e));
            },
            updateProgress: function updateProgress(e) {
              var t = this;

              if (this.supported.ui && K(e)) {
                var i,
                    n,
                    r = 0;
                if (e) switch (e.type) {
                  case "timeupdate":
                  case "seeking":
                  case "seeked":
                    i = this.currentTime, n = this.duration, r = 0 === i || 0 === n || Number.isNaN(i) || Number.isNaN(n) ? 0 : (i / n * 100).toFixed(2), "timeupdate" === e.type && $e.setRange.call(this, this.elements.inputs.seek, r);
                    break;

                  case "playing":
                  case "progress":
                    !function (e, i) {
                      var n = D(i) ? i : 0,
                          r = Y(e) ? e : t.elements.display.buffer;

                      if (Y(r)) {
                        r.value = n;
                        var o = r.getElementsByTagName("span")[0];
                        Y(o) && (o.childNodes[0].nodeValue = n);
                      }
                    }(this.elements.display.buffer, 100 * this.buffered);
                }
              }
            },
            updateRangeFill: function updateRangeFill(e) {
              var t = K(e) ? e.target : e;

              if (Y(t) && "range" === t.getAttribute("type")) {
                if (fe(t, this.config.selectors.inputs.seek)) {
                  t.setAttribute("aria-valuenow", this.currentTime);
                  var i = $e.formatTime(this.currentTime),
                      n = $e.formatTime(this.duration),
                      r = Ue("seekLabel", this.config);
                  t.setAttribute("aria-valuetext", r.replace("{currentTime}", i).replace("{duration}", n));
                } else if (fe(t, this.config.selectors.inputs.volume)) {
                  var o = 100 * t.value;
                  t.setAttribute("aria-valuenow", o), t.setAttribute("aria-valuetext", "".concat(o.toFixed(1), "%"));
                } else t.setAttribute("aria-valuenow", t.value);

                ee.isWebkit && t.style.setProperty("--value", t.value / t.max * 100 + "%");
              }
            },
            updateSeekTooltip: function updateSeekTooltip(e) {
              var t = this;

              if (this.config.tooltips.seek && Y(this.elements.inputs.seek) && Y(this.elements.display.seekTooltip) && 0 !== this.duration) {
                var i = "".concat(this.config.classNames.tooltip, "--visible"),
                    n = function n(e) {
                  return de(t.elements.display.seekTooltip, i, e);
                };

                if (this.touch) n(!1);else {
                  var r = 0,
                      o = this.elements.progress.getBoundingClientRect();
                  if (K(e)) r = 100 / o.width * (e.pageX - o.left);else {
                    if (!he(this.elements.display.seekTooltip, i)) return;
                    r = parseFloat(this.elements.display.seekTooltip.style.left, 10);
                  }
                  r < 0 ? r = 0 : r > 100 && (r = 100), $e.updateTimeDisplay.call(this, this.elements.display.seekTooltip, this.duration / 100 * r), this.elements.display.seekTooltip.style.left = "".concat(r, "%"), K(e) && ["mouseenter", "mouseleave"].includes(e.type) && n("mouseenter" === e.type);
                }
              }
            },
            timeUpdate: function timeUpdate(e) {
              var t = !Y(this.elements.display.duration) && this.config.invertTime;
              $e.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || $e.updateProgress.call(this, e);
            },
            durationUpdate: function durationUpdate() {
              if (this.supported.ui && (this.config.invertTime || !this.currentTime)) {
                if (this.duration >= Math.pow(2, 32)) return pe(this.elements.display.currentTime, !0), void pe(this.elements.progress, !0);
                Y(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
                var e = Y(this.elements.display.duration);
                !e && this.config.displayDuration && this.paused && $e.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && $e.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), $e.updateSeekTooltip.call(this);
              }
            },
            toggleMenuButton: function toggleMenuButton(e, t) {
              pe(this.elements.settings.buttons[e], !t);
            },
            updateSetting: function updateSetting(e, t, i) {
              var n = this.elements.settings.panels[e],
                  r = null,
                  o = t;
              if ("captions" === e) r = this.currentTrack;else {
                if (r = Q(i) ? this[e] : i, Q(r) && (r = this.config[e].default), !Q(this.options[e]) && !this.options[e].includes(r)) return void this.debug.warn("Unsupported value of '".concat(r, "' for ").concat(e));
                if (!this.config[e].options.includes(r)) return void this.debug.warn("Disabled value of '".concat(r, "' for ").concat(e));
              }

              if (Y(o) || (o = n && n.querySelector('[role="menu"]')), Y(o)) {
                this.elements.settings.buttons[e].querySelector(".".concat(this.config.classNames.menu.value)).innerHTML = $e.getLabel.call(this, e, r);
                var a = o && o.querySelector('[value="'.concat(r, '"]'));
                Y(a) && (a.checked = !0);
              }
            },
            getLabel: function getLabel(e, t) {
              switch (e) {
                case "speed":
                  return 1 === t ? Ue("normal", this.config) : "".concat(t, "&times;");

                case "quality":
                  if (D(t)) {
                    var i = Ue("qualityLabel.".concat(t), this.config);
                    return i.length ? i : "".concat(t, "p");
                  }

                  return qe(t);

                case "captions":
                  return Ze.getLabel.call(this);

                default:
                  return null;
              }
            },
            setQualityMenu: function setQualityMenu(e) {
              var t = this;

              if (Y(this.elements.settings.panels.quality)) {
                var i = "quality",
                    n = this.elements.settings.panels.quality.querySelector('[role="menu"]');
                U(e) && (this.options.quality = Pe(e).filter(function (e) {
                  return t.config.quality.options.includes(e);
                }));
                var r = !Q(this.options.quality) && this.options.quality.length > 1;

                if ($e.toggleMenuButton.call(this, i, r), le(n), $e.checkMenu.call(this), r) {
                  var o = function o(e) {
                    var i = Ue("qualityBadge.".concat(e), t.config);
                    return i.length ? $e.createBadge.call(t, i) : null;
                  };

                  this.options.quality.sort(function (e, i) {
                    var n = t.config.quality.options;
                    return n.indexOf(e) > n.indexOf(i) ? 1 : -1;
                  }).forEach(function (e) {
                    $e.createMenuItem.call(t, {
                      value: e,
                      list: n,
                      type: i,
                      title: $e.getLabel.call(t, "quality", e),
                      badge: o(e)
                    });
                  }), $e.updateSetting.call(this, i, n);
                }
              }
            },
            setCaptionsMenu: function setCaptionsMenu() {
              var e = this;

              if (Y(this.elements.settings.panels.captions)) {
                var t = "captions",
                    i = this.elements.settings.panels.captions.querySelector('[role="menu"]'),
                    n = Ze.getTracks.call(this),
                    r = Boolean(n.length);

                if ($e.toggleMenuButton.call(this, t, r), le(i), $e.checkMenu.call(this), r) {
                  var o = n.map(function (t, n) {
                    return {
                      value: n,
                      checked: e.captions.toggled && e.currentTrack === n,
                      title: Ze.getLabel.call(e, t),
                      badge: t.language && $e.createBadge.call(e, t.language.toUpperCase()),
                      list: i,
                      type: "language"
                    };
                  });
                  o.unshift({
                    value: -1,
                    checked: !this.captions.toggled,
                    title: Ue("disabled", this.config),
                    list: i,
                    type: "language"
                  }), o.forEach($e.createMenuItem.bind(this)), $e.updateSetting.call(this, t, i);
                }
              }
            },
            setSpeedMenu: function setSpeedMenu() {
              var e = this;

              if (Y(this.elements.settings.panels.speed)) {
                var t = "speed",
                    i = this.elements.settings.panels.speed.querySelector('[role="menu"]');
                this.options.speed = this.options.speed.filter(function (t) {
                  return t >= e.minimumSpeed && t <= e.maximumSpeed;
                });
                var n = !Q(this.options.speed) && this.options.speed.length > 1;
                $e.toggleMenuButton.call(this, t, n), le(i), $e.checkMenu.call(this), n && (this.options.speed.forEach(function (n) {
                  $e.createMenuItem.call(e, {
                    value: n,
                    list: i,
                    type: t,
                    title: $e.getLabel.call(e, "speed", n)
                  });
                }), $e.updateSetting.call(this, t, i));
              }
            },
            checkMenu: function checkMenu() {
              var e = this.elements.settings.buttons,
                  t = !Q(e) && Object.values(e).some(function (e) {
                return !e.hidden;
              });
              pe(this.elements.settings.menu, !t);
            },
            focusFirstMenuItem: function focusFirstMenuItem(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

              if (!this.elements.settings.popup.hidden) {
                var i = e;
                Y(i) || (i = Object.values(this.elements.settings.panels).find(function (e) {
                  return !e.hidden;
                }));
                var n = i.querySelector('[role^="menuitem"]');
                ye.call(this, n, t);
              }
            },
            toggleMenu: function toggleMenu(e) {
              var t = this.elements.settings.popup,
                  i = this.elements.buttons.settings;

              if (Y(t) && Y(i)) {
                var n = t.hidden,
                    r = n;
                if (B(e)) r = e;else if (X(e) && 27 === e.which) r = !1;else if (K(e)) {
                  var o = F(e.composedPath) ? e.composedPath()[0] : e.target,
                      a = t.contains(o);
                  if (a || !a && e.target !== i && r) return;
                }
                i.setAttribute("aria-expanded", r), pe(t, !r), de(this.elements.container, this.config.classNames.menu.open, r), r && X(e) ? $e.focusFirstMenuItem.call(this, null, !0) : r || n || ye.call(this, i, X(e));
              }
            },
            getMenuSize: function getMenuSize(e) {
              var t = e.cloneNode(!0);
              t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
              var i = t.scrollWidth,
                  n = t.scrollHeight;
              return se(t), {
                width: i,
                height: n
              };
            },
            showMenuPanel: function showMenuPanel() {
              var e = this,
                  t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                  i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                  n = this.elements.container.querySelector("#plyr-settings-".concat(this.id, "-").concat(t));

              if (Y(n)) {
                var r = n.parentNode,
                    o = Array.from(r.children).find(function (e) {
                  return !e.hidden;
                });

                if (ve.transitions && !ve.reducedMotion) {
                  r.style.width = "".concat(o.scrollWidth, "px"), r.style.height = "".concat(o.scrollHeight, "px");

                  var a = $e.getMenuSize.call(this, n),
                      s = function t(i) {
                    i.target === r && ["width", "height"].includes(i.propertyName) && (r.style.width = "", r.style.height = "", xe.call(e, r, G, t));
                  };

                  ke.call(this, r, G, s), r.style.width = "".concat(a.width, "px"), r.style.height = "".concat(a.height, "px");
                }

                pe(o, !0), pe(n, !1), $e.focusFirstMenuItem.call(this, n, i);
              }
            },
            setDownloadUrl: function setDownloadUrl() {
              var e = this.elements.buttons.download;
              Y(e) && e.setAttribute("href", this.download);
            },
            create: function create(e) {
              var t = this,
                  i = $e.bindMenuItemShortcuts,
                  n = $e.createButton,
                  r = $e.createProgress,
                  o = $e.createRange,
                  a = $e.createTime,
                  s = $e.setQualityMenu,
                  l = $e.setSpeedMenu,
                  c = $e.showMenuPanel;
              this.elements.controls = null, U(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(n.call(this, "play-large"));
              var u = oe("div", ue(this.config.selectors.controls.wrapper));
              this.elements.controls = u;
              var p = {
                class: "plyr__controls__item"
              };
              return Pe(U(this.config.controls) ? this.config.controls : []).forEach(function (s) {
                if ("restart" === s && u.appendChild(n.call(t, "restart", p)), "rewind" === s && u.appendChild(n.call(t, "rewind", p)), "play" === s && u.appendChild(n.call(t, "play", p)), "fast-forward" === s && u.appendChild(n.call(t, "fast-forward", p)), "progress" === s) {
                  var l = oe("div", {
                    class: "".concat(p.class, " plyr__progress__container")
                  }),
                      d = oe("div", ue(t.config.selectors.progress));

                  if (d.appendChild(o.call(t, "seek", {
                    id: "plyr-seek-".concat(e.id)
                  })), d.appendChild(r.call(t, "buffer")), t.config.tooltips.seek) {
                    var h = oe("span", {
                      class: t.config.classNames.tooltip
                    }, "00:00");
                    d.appendChild(h), t.elements.display.seekTooltip = h;
                  }

                  t.elements.progress = d, l.appendChild(t.elements.progress), u.appendChild(l);
                }

                if ("current-time" === s && u.appendChild(a.call(t, "currentTime", p)), "duration" === s && u.appendChild(a.call(t, "duration", p)), "mute" === s || "volume" === s) {
                  var f = t.elements.volume;

                  if (Y(f) && u.contains(f) || (f = oe("div", ie({}, p, {
                    class: "".concat(p.class, " plyr__volume").trim()
                  })), t.elements.volume = f, u.appendChild(f)), "mute" === s && f.appendChild(n.call(t, "mute")), "volume" === s && !ee.isIos) {
                    var m = {
                      max: 1,
                      step: .05,
                      value: t.config.volume
                    };
                    f.appendChild(o.call(t, "volume", ie(m, {
                      id: "plyr-volume-".concat(e.id)
                    })));
                  }
                }

                if ("captions" === s && u.appendChild(n.call(t, "captions", p)), "settings" === s && !Q(t.config.settings)) {
                  var g = oe("div", ie({}, p, {
                    class: "".concat(p.class, " plyr__menu").trim(),
                    hidden: ""
                  }));
                  g.appendChild(n.call(t, "settings", {
                    "aria-haspopup": !0,
                    "aria-controls": "plyr-settings-".concat(e.id),
                    "aria-expanded": !1
                  }));
                  var y = oe("div", {
                    class: "plyr__menu__container",
                    id: "plyr-settings-".concat(e.id),
                    hidden: ""
                  }),
                      b = oe("div"),
                      v = oe("div", {
                    id: "plyr-settings-".concat(e.id, "-home")
                  }),
                      w = oe("div", {
                    role: "menu"
                  });
                  v.appendChild(w), b.appendChild(v), t.elements.settings.panels.home = v, t.config.settings.forEach(function (n) {
                    var r = oe("button", ie(ue(t.config.selectors.buttons.settings), {
                      type: "button",
                      class: "".concat(t.config.classNames.control, " ").concat(t.config.classNames.control, "--forward"),
                      role: "menuitem",
                      "aria-haspopup": !0,
                      hidden: ""
                    }));
                    i.call(t, r, n), ke.call(t, r, "click", function () {
                      c.call(t, n, !1);
                    });
                    var o = oe("span", null, Ue(n, t.config)),
                        a = oe("span", {
                      class: t.config.classNames.menu.value
                    });
                    a.innerHTML = e[n], o.appendChild(a), r.appendChild(o), w.appendChild(r);
                    var s = oe("div", {
                      id: "plyr-settings-".concat(e.id, "-").concat(n),
                      hidden: ""
                    }),
                        l = oe("button", {
                      type: "button",
                      class: "".concat(t.config.classNames.control, " ").concat(t.config.classNames.control, "--back")
                    });
                    l.appendChild(oe("span", {
                      "aria-hidden": !0
                    }, Ue(n, t.config))), l.appendChild(oe("span", {
                      class: t.config.classNames.hidden
                    }, Ue("menuBack", t.config))), ke.call(t, s, "keydown", function (e) {
                      37 === e.which && (e.preventDefault(), e.stopPropagation(), c.call(t, "home", !0));
                    }, !1), ke.call(t, l, "click", function () {
                      c.call(t, "home", !1);
                    }), s.appendChild(l), s.appendChild(oe("div", {
                      role: "menu"
                    })), b.appendChild(s), t.elements.settings.buttons[n] = r, t.elements.settings.panels[n] = s;
                  }), y.appendChild(b), g.appendChild(y), u.appendChild(g), t.elements.settings.popup = y, t.elements.settings.menu = g;
                }

                if ("pip" === s && ve.pip && u.appendChild(n.call(t, "pip", p)), "airplay" === s && ve.airplay && u.appendChild(n.call(t, "airplay", p)), "download" === s) {
                  var _ = ie({}, p, {
                    element: "a",
                    href: t.download,
                    target: "_blank"
                  });

                  t.isHTML5 && (_.download = "");
                  var k = t.config.urls.download;
                  !$(k) && t.isEmbed && ie(_, {
                    icon: "logo-".concat(t.provider),
                    label: t.provider
                  }), u.appendChild(n.call(t, "download", _));
                }

                "fullscreen" === s && u.appendChild(n.call(t, "fullscreen", p));
              }), this.isHTML5 && s.call(this, Ve.getQualityOptions.call(this)), l.call(this), u;
            },
            inject: function inject() {
              var e = this;

              if (this.config.loadSprite) {
                var t = $e.getIconUrl.call(this);
                t.cors && Ke(t.url, "sprite-plyr");
              }

              this.id = Math.floor(1e4 * Math.random());
              var i = null;
              this.elements.controls = null;
              var n,
                  r = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
              },
                  o = !0;

              if (F(this.config.controls) && (this.config.controls = this.config.controls.call(this, r)), this.config.controls || (this.config.controls = []), Y(this.config.controls) || q(this.config.controls) ? i = this.config.controls : (i = $e.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: Ze.getLabel.call(this)
              }), o = !1), o && q(this.config.controls) && (i = function (e) {
                var t = e;
                return Object.entries(r).forEach(function (e) {
                  var i = g(e, 2),
                      n = i[0],
                      r = i[1];
                  t = De(t, "{".concat(n, "}"), r);
                }), t;
              }(i)), q(this.config.selectors.controls.container) && (n = document.querySelector(this.config.selectors.controls.container)), Y(n) || (n = this.elements.container), n[Y(i) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", i), Y(this.elements.controls) || $e.findElements.call(this), !Q(this.elements.buttons)) {
                var a = function a(t) {
                  var i = e.config.classNames.controlPressed;
                  Object.defineProperty(t, "pressed", {
                    enumerable: !0,
                    get: function get() {
                      return he(t, i);
                    },
                    set: function set() {
                      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                      de(t, i, e);
                    }
                  });
                };

                Object.values(this.elements.buttons).filter(Boolean).forEach(function (e) {
                  U(e) || W(e) ? Array.from(e).filter(Boolean).forEach(a) : a(e);
                });
              }

              if (ee.isEdge && Z(n), this.config.tooltips.controls) {
                var s = this.config,
                    l = s.classNames,
                    c = s.selectors,
                    u = "".concat(c.controls.wrapper, " ").concat(c.labels, " .").concat(l.hidden),
                    p = me.call(this, u);
                Array.from(p).forEach(function (t) {
                  de(t, e.config.classNames.hidden, !1), de(t, e.config.classNames.tooltip, !0);
                });
              }
            }
          };

          function Qe(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                i = e;

            if (t) {
              var n = document.createElement("a");
              n.href = i, i = n.href;
            }

            try {
              return new URL(i);
            } catch (e) {
              return null;
            }
          }

          function Ge(e) {
            var t = new URLSearchParams();
            return R(e) && Object.entries(e).forEach(function (e) {
              var i = g(e, 2),
                  n = i[0],
                  r = i[1];
              t.set(n, r);
            }), t;
          }

          var Ze = {
            setup: function setup() {
              if (this.supported.ui) if (!this.isVideo || this.isYouTube || this.isHTML5 && !ve.textTracks) U(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && $e.setCaptionsMenu.call(this);else {
                var e, t;

                if (Y(this.elements.captions) || (this.elements.captions = oe("div", ue(this.config.selectors.captions)), e = this.elements.captions, t = this.elements.wrapper, Y(e) && Y(t) && t.parentNode.insertBefore(e, t.nextSibling)), ee.isIE && window.URL) {
                  var i = this.media.querySelectorAll("track");
                  Array.from(i).forEach(function (e) {
                    var t = e.getAttribute("src"),
                        i = Qe(t);
                    null !== i && i.hostname !== window.location.href.hostname && ["http:", "https:"].includes(i.protocol) && Ye(t, "blob").then(function (t) {
                      e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(function () {
                      se(e);
                    });
                  });
                }

                var n = Pe((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map(function (e) {
                  return e.split("-")[0];
                })),
                    r = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
                "auto" === r && (r = g(n, 1)[0]);
                var o = this.storage.get("captions");

                if (B(o) || (o = this.config.captions.active), Object.assign(this.captions, {
                  toggled: !1,
                  active: o,
                  language: r,
                  languages: n
                }), this.isHTML5) {
                  var a = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                  ke.call(this, this.media.textTracks, a, Ze.update.bind(this));
                }

                setTimeout(Ze.update.bind(this), 0);
              }
            },
            update: function update() {
              var e = this,
                  t = Ze.getTracks.call(this, !0),
                  i = this.captions,
                  n = i.active,
                  r = i.language,
                  o = i.meta,
                  a = i.currentTrackNode,
                  s = Boolean(t.find(function (e) {
                return e.language === r;
              }));
              this.isHTML5 && this.isVideo && t.filter(function (e) {
                return !o.get(e);
              }).forEach(function (t) {
                e.debug.log("Track added", t), o.set(t, {
                  default: "showing" === t.mode
                }), "showing" === t.mode && (t.mode = "hidden"), ke.call(e, t, "cuechange", function () {
                  return Ze.updateCues.call(e);
                });
              }), (s && this.language !== r || !t.includes(a)) && (Ze.setLanguage.call(this, r), Ze.toggle.call(this, n && s)), this.elements && de(this.elements.container, this.config.classNames.captions.enabled, !Q(t)), U(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && $e.setCaptionsMenu.call(this);
            },
            toggle: function toggle(e) {
              var t = this,
                  i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

              if (this.supported.ui) {
                var n = this.captions.toggled,
                    r = this.config.classNames.captions.active,
                    o = V(e) ? !n : e;

                if (o !== n) {
                  if (i || (this.captions.active = o, this.storage.set({
                    captions: o
                  })), !this.language && o && !i) {
                    var a = Ze.getTracks.call(this),
                        s = Ze.findTrack.call(this, [this.captions.language].concat(u(this.captions.languages)), !0);
                    return this.captions.language = s.language, void Ze.set.call(this, a.indexOf(s));
                  }

                  this.elements.buttons.captions && (this.elements.buttons.captions.pressed = o), de(this.elements.container, r, o), this.captions.toggled = o, $e.updateSetting.call(this, "captions"), Ce.call(this, this.media, o ? "captionsenabled" : "captionsdisabled");
                }

                setTimeout(function () {
                  o && t.captions.toggled && (t.captions.currentTrackNode.mode = "hidden");
                });
              }
            },
            set: function set(e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                  i = Ze.getTracks.call(this);
              if (-1 !== e) {
                if (D(e)) {
                  if (e in i) {
                    if (this.captions.currentTrack !== e) {
                      this.captions.currentTrack = e;
                      var n = i[e],
                          r = n || {},
                          o = r.language;
                      this.captions.currentTrackNode = n, $e.updateSetting.call(this, "captions"), t || (this.captions.language = o, this.storage.set({
                        language: o
                      })), this.isVimeo && this.embed.enableTextTrack(o), Ce.call(this, this.media, "languagechange");
                    }

                    Ze.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && Ze.updateCues.call(this);
                  } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
              } else Ze.toggle.call(this, !1, t);
            },
            setLanguage: function setLanguage(e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

              if (q(e)) {
                var i = e.toLowerCase();
                this.captions.language = i;
                var n = Ze.getTracks.call(this),
                    r = Ze.findTrack.call(this, [i]);
                Ze.set.call(this, n.indexOf(r), t);
              } else this.debug.warn("Invalid language argument", e);
            },
            getTracks: function getTracks() {
              var e = this,
                  t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              return Array.from((this.media || {}).textTracks || []).filter(function (i) {
                return !e.isHTML5 || t || e.captions.meta.has(i);
              }).filter(function (e) {
                return ["captions", "subtitles"].includes(e.kind);
              });
            },
            findTrack: function findTrack(e) {
              var t,
                  i = this,
                  n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                  r = Ze.getTracks.call(this),
                  o = function o(e) {
                return Number((i.captions.meta.get(e) || {}).default);
              },
                  a = Array.from(r).sort(function (e, t) {
                return o(t) - o(e);
              });

              return e.every(function (e) {
                return !(t = a.find(function (t) {
                  return t.language === e;
                }));
              }), t || (n ? a[0] : void 0);
            },
            getCurrentTrack: function getCurrentTrack() {
              return Ze.getTracks.call(this)[this.currentTrack];
            },
            getLabel: function getLabel(e) {
              var t = e;
              return !J(t) && ve.textTracks && this.captions.toggled && (t = Ze.getCurrentTrack.call(this)), J(t) ? Q(t.label) ? Q(t.language) ? Ue("enabled", this.config) : e.language.toUpperCase() : t.label : Ue("disabled", this.config);
            },
            updateCues: function updateCues(e) {
              if (this.supported.ui) if (Y(this.elements.captions)) {
                if (V(e) || Array.isArray(e)) {
                  var t = e;

                  if (!t) {
                    var i = Ze.getCurrentTrack.call(this);
                    t = Array.from((i || {}).activeCues || []).map(function (e) {
                      return e.getCueAsHTML();
                    }).map(Be);
                  }

                  var n = t.map(function (e) {
                    return e.trim();
                  }).join("\n");

                  if (n !== this.elements.captions.innerHTML) {
                    le(this.elements.captions);
                    var r = oe("span", ue(this.config.selectors.caption));
                    r.innerHTML = n, this.elements.captions.appendChild(r), Ce.call(this, this.media, "cuechange");
                  }
                } else this.debug.warn("updateCues: Invalid input", e);
              } else this.debug.warn("No captions element to render to");
            }
          },
              et = {
            enabled: !0,
            title: "",
            debug: !1,
            autoplay: !1,
            autopause: !0,
            playsinline: !0,
            seekTime: 10,
            volume: 1,
            muted: !1,
            duration: null,
            displayDuration: !0,
            invertTime: !0,
            toggleInvert: !0,
            ratio: null,
            clickToPlay: !0,
            hideControls: !0,
            resetOnEnd: !1,
            disableContextMenu: !0,
            loadSprite: !0,
            iconPrefix: "plyr",
            iconUrl: "https://cdn.plyr.io/3.6.9/plyr.svg",
            blankVideo: "https://cdn.plyr.io/static/blank.mp4",
            quality: {
              default: 576,
              options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
              forced: !1,
              onChange: null
            },
            loop: {
              active: !1
            },
            speed: {
              selected: 1,
              options: [.5, .75, 1, 1.25, 1.5, 1.75, 2, 4]
            },
            keyboard: {
              focused: !0,
              global: !1
            },
            tooltips: {
              controls: !1,
              seek: !0
            },
            captions: {
              active: !1,
              language: "auto",
              update: !1
            },
            fullscreen: {
              enabled: !0,
              fallback: !0,
              iosNative: !1
            },
            storage: {
              enabled: !0,
              key: "plyr"
            },
            controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"],
            settings: ["captions", "quality", "speed"],
            i18n: {
              restart: "Restart",
              rewind: "Rewind {seektime}s",
              play: "Play",
              pause: "Pause",
              fastForward: "Forward {seektime}s",
              seek: "Seek",
              seekLabel: "{currentTime} of {duration}",
              played: "Played",
              buffered: "Buffered",
              currentTime: "Current time",
              duration: "Duration",
              volume: "Volume",
              mute: "Mute",
              unmute: "Unmute",
              enableCaptions: "Enable captions",
              disableCaptions: "Disable captions",
              download: "Download",
              enterFullscreen: "Enter fullscreen",
              exitFullscreen: "Exit fullscreen",
              frameTitle: "Player for {title}",
              captions: "Captions",
              settings: "Settings",
              pip: "PIP",
              menuBack: "Go back to previous menu",
              speed: "Speed",
              normal: "Normal",
              quality: "Quality",
              loop: "Loop",
              start: "Start",
              end: "End",
              all: "All",
              reset: "Reset",
              disabled: "Disabled",
              enabled: "Enabled",
              advertisement: "Ad",
              qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
              }
            },
            urls: {
              download: null,
              vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
              },
              youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
              },
              googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
              }
            },
            listeners: {
              seek: null,
              play: null,
              pause: null,
              restart: null,
              rewind: null,
              fastForward: null,
              mute: null,
              volume: null,
              captions: null,
              download: null,
              fullscreen: null,
              pip: null,
              airplay: null,
              speed: null,
              quality: null,
              loop: null,
              language: null
            },
            events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"],
            selectors: {
              editable: "input, textarea, select, [contenteditable]",
              container: ".plyr",
              controls: {
                container: null,
                wrapper: ".plyr__controls"
              },
              labels: "[data-plyr]",
              buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
              },
              inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
              },
              display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
              },
              progress: ".plyr__progress",
              captions: ".plyr__captions",
              caption: ".plyr__caption"
            },
            classNames: {
              type: "plyr--{0}",
              provider: "plyr--{0}",
              video: "plyr__video-wrapper",
              embed: "plyr__video-embed",
              videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
              embedContainer: "plyr__video-embed__container",
              poster: "plyr__poster",
              posterEnabled: "plyr__poster-enabled",
              ads: "plyr__ads",
              control: "plyr__control",
              controlPressed: "plyr__control--pressed",
              playing: "plyr--playing",
              paused: "plyr--paused",
              stopped: "plyr--stopped",
              loading: "plyr--loading",
              hover: "plyr--hover",
              tooltip: "plyr__tooltip",
              cues: "plyr__cues",
              hidden: "plyr__sr-only",
              hideControls: "plyr--hide-controls",
              isIos: "plyr--is-ios",
              isTouch: "plyr--is-touch",
              uiSupported: "plyr--full-ui",
              noTransition: "plyr--no-transition",
              display: {
                time: "plyr__time"
              },
              menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
              },
              captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
              },
              fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
              },
              pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
              },
              airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
              },
              tabFocus: "plyr__tab-focus",
              previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
              }
            },
            attributes: {
              embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
              }
            },
            ads: {
              enabled: !1,
              publisherId: "",
              tagUrl: ""
            },
            previewThumbnails: {
              enabled: !1,
              src: ""
            },
            vimeo: {
              byline: !1,
              portrait: !1,
              title: !1,
              speed: !0,
              transparent: !1,
              customControls: !0,
              referrerPolicy: null,
              premium: !1
            },
            youtube: {
              rel: 0,
              showinfo: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              customControls: !0,
              noCookie: !1
            }
          },
              tt = "picture-in-picture",
              it = {
            html5: "html5",
            youtube: "youtube",
            vimeo: "vimeo"
          },
              nt = "video",
              rt = function rt() {},
              ot = function () {
            function e() {
              var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              p(this, e), this.enabled = window.console && t, this.enabled && this.log("Debugging enabled");
            }

            return h(e, [{
              key: "log",
              get: function get() {
                return this.enabled ? Function.prototype.bind.call(console.log, console) : rt;
              }
            }, {
              key: "warn",
              get: function get() {
                return this.enabled ? Function.prototype.bind.call(console.warn, console) : rt;
              }
            }, {
              key: "error",
              get: function get() {
                return this.enabled ? Function.prototype.bind.call(console.error, console) : rt;
              }
            }]), e;
          }(),
              at = function () {
            function t(i) {
              var n = this;
              p(this, t), e(this, "onChange", function () {
                if (n.enabled) {
                  var e = n.player.elements.buttons.fullscreen;
                  Y(e) && (e.pressed = n.active);
                  var t = n.target === n.player.media ? n.target : n.player.elements.container;
                  Ce.call(n.player, t, n.active ? "enterfullscreen" : "exitfullscreen", !0);
                }
              }), e(this, "toggleFallback", function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

                if (e ? n.scrollPosition = {
                  x: window.scrollX || 0,
                  y: window.scrollY || 0
                } : window.scrollTo(n.scrollPosition.x, n.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", de(n.target, n.player.config.classNames.fullscreen.fallback, e), ee.isIos) {
                  var t = document.head.querySelector('meta[name="viewport"]'),
                      i = "viewport-fit=cover";
                  t || (t = document.createElement("meta")).setAttribute("name", "viewport");
                  var r = q(t.content) && t.content.includes(i);
                  e ? (n.cleanupViewport = !r, r || (t.content += ",".concat(i))) : n.cleanupViewport && (t.content = t.content.split(",").filter(function (e) {
                    return e.trim() !== i;
                  }).join(","));
                }

                n.onChange();
              }), e(this, "trapFocus", function (e) {
                if (!ee.isIos && n.active && "Tab" === e.key && 9 === e.keyCode) {
                  var t = document.activeElement,
                      i = me.call(n.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"),
                      r = g(i, 1)[0],
                      o = i[i.length - 1];
                  t !== o || e.shiftKey ? t === r && e.shiftKey && (o.focus(), e.preventDefault()) : (r.focus(), e.preventDefault());
                }
              }), e(this, "update", function () {
                var e;
                n.enabled ? (e = n.forceFallback ? "Fallback (forced)" : t.native ? "Native" : "Fallback", n.player.debug.log("".concat(e, " fullscreen enabled"))) : n.player.debug.log("Fullscreen not supported and fallback disabled"), de(n.player.elements.container, n.player.config.classNames.fullscreen.enabled, n.enabled);
              }), e(this, "enter", function () {
                n.enabled && (ee.isIos && n.player.config.fullscreen.iosNative ? n.player.isVimeo ? n.player.embed.requestFullscreen() : n.target.webkitEnterFullscreen() : !t.native || n.forceFallback ? n.toggleFallback(!0) : n.prefix ? Q(n.prefix) || n.target["".concat(n.prefix, "Request").concat(n.property)]() : n.target.requestFullscreen({
                  navigationUI: "hide"
                }));
              }), e(this, "exit", function () {
                if (n.enabled) if (ee.isIos && n.player.config.fullscreen.iosNative) n.target.webkitExitFullscreen(), Ee(n.player.play());else if (!t.native || n.forceFallback) n.toggleFallback(!1);else if (n.prefix) {
                  if (!Q(n.prefix)) {
                    var e = "moz" === n.prefix ? "Cancel" : "Exit";
                    document["".concat(n.prefix).concat(e).concat(n.property)]();
                  }
                } else (document.cancelFullScreen || document.exitFullscreen).call(document);
              }), e(this, "toggle", function () {
                n.active ? n.exit() : n.enter();
              }), this.player = i, this.prefix = t.prefix, this.property = t.property, this.scrollPosition = {
                x: 0,
                y: 0
              }, this.forceFallback = "force" === i.config.fullscreen.fallback, this.player.elements.fullscreen = i.config.fullscreen.container && function (e, t) {
                return (Element.prototype.closest || function () {
                  var e = this;

                  do {
                    if (fe.matches(e, t)) return e;
                    e = e.parentElement || e.parentNode;
                  } while (null !== e && 1 === e.nodeType);

                  return null;
                }).call(e, t);
              }(this.player.elements.container, i.config.fullscreen.container), ke.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : "".concat(this.prefix, "fullscreenchange"), function () {
                n.onChange();
              }), ke.call(this.player, this.player.elements.container, "dblclick", function (e) {
                Y(n.player.elements.controls) && n.player.elements.controls.contains(e.target) || n.player.listeners.proxy(e, n.toggle, "fullscreen");
              }), ke.call(this, this.player.elements.container, "keydown", function (e) {
                return n.trapFocus(e);
              }), this.update();
            }

            return h(t, [{
              key: "usingNative",
              get: function get() {
                return t.native && !this.forceFallback;
              }
            }, {
              key: "enabled",
              get: function get() {
                return (t.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
              }
            }, {
              key: "active",
              get: function get() {
                if (!this.enabled) return !1;
                if (!t.native || this.forceFallback) return he(this.target, this.player.config.classNames.fullscreen.fallback);
                var e = this.prefix ? this.target.getRootNode()["".concat(this.prefix).concat(this.property, "Element")] : this.target.getRootNode().fullscreenElement;
                return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
              }
            }, {
              key: "target",
              get: function get() {
                return ee.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
              }
            }], [{
              key: "native",
              get: function get() {
                return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
              }
            }, {
              key: "prefix",
              get: function get() {
                if (F(document.exitFullscreen)) return "";
                var e = "";
                return ["webkit", "moz", "ms"].some(function (t) {
                  return !(!F(document["".concat(t, "ExitFullscreen")]) && !F(document["".concat(t, "CancelFullScreen")]) || (e = t, 0));
                }), e;
              }
            }, {
              key: "property",
              get: function get() {
                return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
              }
            }]), t;
          }();

          function st(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return new Promise(function (i, n) {
              var r = new Image(),
                  o = function o() {
                delete r.onload, delete r.onerror, (r.naturalWidth >= t ? i : n)(r);
              };

              Object.assign(r, {
                onload: o,
                onerror: o,
                src: e
              });
            });
          }

          var lt = {
            addStyleHook: function addStyleHook() {
              de(this.elements.container, this.config.selectors.container.replace(".", ""), !0), de(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
            },
            toggleNativeControls: function toggleNativeControls() {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
            },
            build: function build() {
              var e = this;
              if (this.listeners.media(), !this.supported.ui) return this.debug.warn("Basic support only for ".concat(this.provider, " ").concat(this.type)), void lt.toggleNativeControls.call(this, !0);
              Y(this.elements.controls) || ($e.inject.call(this), this.listeners.controls()), lt.toggleNativeControls.call(this), this.isHTML5 && Ze.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, $e.updateVolume.call(this), $e.timeUpdate.call(this), $e.durationUpdate.call(this), lt.checkPlaying.call(this), de(this.elements.container, this.config.classNames.pip.supported, ve.pip && this.isHTML5 && this.isVideo), de(this.elements.container, this.config.classNames.airplay.supported, ve.airplay && this.isHTML5), de(this.elements.container, this.config.classNames.isIos, ee.isIos), de(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(function () {
                Ce.call(e, e.media, "ready");
              }, 0), lt.setTitle.call(this), this.poster && lt.setPoster.call(this, this.poster, !1).catch(function () {}), this.config.duration && $e.durationUpdate.call(this);
            },
            setTitle: function setTitle() {
              var e = Ue("play", this.config);

              if (q(this.config.title) && !Q(this.config.title) && (e += ", ".concat(this.config.title)), Array.from(this.elements.buttons.play || []).forEach(function (t) {
                t.setAttribute("aria-label", e);
              }), this.isEmbed) {
                var t = ge.call(this, "iframe");
                if (!Y(t)) return;
                var i = Q(this.config.title) ? "video" : this.config.title,
                    n = Ue("frameTitle", this.config);
                t.setAttribute("title", n.replace("{title}", i));
              }
            },
            togglePoster: function togglePoster(e) {
              de(this.elements.container, this.config.classNames.posterEnabled, e);
            },
            setPoster: function setPoster(e) {
              var t = this,
                  i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
              return i && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), Ae.call(this).then(function () {
                return st(e);
              }).catch(function (i) {
                throw e === t.poster && lt.togglePoster.call(t, !1), i;
              }).then(function () {
                if (e !== t.poster) throw new Error("setPoster cancelled by later call to setPoster");
              }).then(function () {
                return Object.assign(t.elements.poster.style, {
                  backgroundImage: "url('".concat(e, "')"),
                  backgroundSize: ""
                }), lt.togglePoster.call(t, !0), e;
              }));
            },
            checkPlaying: function checkPlaying(e) {
              var t = this;
              de(this.elements.container, this.config.classNames.playing, this.playing), de(this.elements.container, this.config.classNames.paused, this.paused), de(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach(function (e) {
                Object.assign(e, {
                  pressed: t.playing
                }), e.setAttribute("aria-label", Ue(t.playing ? "pause" : "play", t.config));
              }), K(e) && "timeupdate" === e.type || lt.toggleControls.call(this);
            },
            checkLoading: function checkLoading(e) {
              var t = this;
              this.loading = ["stalled", "waiting"].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(function () {
                de(t.elements.container, t.config.classNames.loading, t.loading), lt.toggleControls.call(t);
              }, this.loading ? 250 : 0);
            },
            toggleControls: function toggleControls(e) {
              var t = this.elements.controls;

              if (t && this.config.hideControls) {
                var i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
              }
            },
            migrateStyles: function migrateStyles() {
              var e = this;
              Object.values(m({}, this.media.style)).filter(function (e) {
                return !Q(e) && q(e) && e.startsWith("--plyr");
              }).forEach(function (t) {
                e.elements.container.style.setProperty(t, e.media.style.getPropertyValue(t)), e.media.style.removeProperty(t);
              }), Q(this.media.style) && this.media.removeAttribute("style");
            }
          },
              ct = function () {
            function t(i) {
              var n = this;
              p(this, t), e(this, "firstTouch", function () {
                var e = n.player,
                    t = e.elements;
                e.touch = !0, de(t.container, e.config.classNames.isTouch, !0);
              }), e(this, "setTabFocus", function (e) {
                var t = n.player,
                    i = t.elements;

                if (clearTimeout(n.focusTimer), "keydown" !== e.type || 9 === e.which) {
                  "keydown" === e.type && (n.lastKeyDown = e.timeStamp);
                  var r = e.timeStamp - n.lastKeyDown <= 20;
                  ("focus" !== e.type || r) && (function () {
                    var e = t.config.classNames.tabFocus;
                    de(me.call(t, ".".concat(e)), e, !1);
                  }(), "focusout" !== e.type && (n.focusTimer = setTimeout(function () {
                    var e = document.activeElement;
                    i.container.contains(e) && de(document.activeElement, t.config.classNames.tabFocus, !0);
                  }, 10)));
                }
              }), e(this, "global", function () {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                    t = n.player;
                t.config.keyboard.global && _e.call(t, window, "keydown keyup", n.handleKey, e, !1), _e.call(t, document.body, "click", n.toggleMenu, e), Te.call(t, document.body, "touchstart", n.firstTouch), _e.call(t, document.body, "keydown focus blur focusout", n.setTabFocus, e, !1, !0);
              }), e(this, "container", function () {
                var e = n.player,
                    t = e.config,
                    i = e.elements,
                    r = e.timers;
                !t.keyboard.global && t.keyboard.focused && ke.call(e, i.container, "keydown keyup", n.handleKey, !1), ke.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", function (t) {
                  var n = i.controls;
                  n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                  var o = 0;
                  ["touchstart", "touchmove", "mousemove"].includes(t.type) && (lt.toggleControls.call(e, !0), o = e.touch ? 3e3 : 2e3), clearTimeout(r.controls), r.controls = setTimeout(function () {
                    return lt.toggleControls.call(e, !1);
                  }, o);
                });

                var o = function o() {
                  if (e.isVimeo && !e.config.vimeo.premium) {
                    var t = i.wrapper,
                        n = e.fullscreen.active,
                        r = g(Oe.call(e), 2),
                        o = r[0],
                        a = r[1],
                        s = Me("aspect-ratio: ".concat(o, " / ").concat(a));

                    if (n) {
                      var l = [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)],
                          c = l[1],
                          u = l[0] / c > o / a;
                      s ? (t.style.width = u ? "auto" : "100%", t.style.height = u ? "100%" : "auto") : (t.style.maxWidth = u ? c / a * o + "px" : null, t.style.margin = u ? "0 auto" : null);
                    } else s ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null);
                  }
                },
                    a = function a() {
                  clearTimeout(r.resized), r.resized = setTimeout(o, 50);
                };

                ke.call(e, i.container, "enterfullscreen exitfullscreen", function (t) {
                  e.fullscreen.target === i.container && (!e.isEmbed && Q(e.config.ratio) || (o(), ("enterfullscreen" === t.type ? ke : xe).call(e, window, "resize", a)));
                });
              }), e(this, "media", function () {
                var e = n.player,
                    t = e.elements;

                if (ke.call(e, e.media, "timeupdate seeking seeked", function (t) {
                  return $e.timeUpdate.call(e, t);
                }), ke.call(e, e.media, "durationchange loadeddata loadedmetadata", function (t) {
                  return $e.durationUpdate.call(e, t);
                }), ke.call(e, e.media, "ended", function () {
                  e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), ke.call(e, e.media, "progress playing seeking seeked", function (t) {
                  return $e.updateProgress.call(e, t);
                }), ke.call(e, e.media, "volumechange", function (t) {
                  return $e.updateVolume.call(e, t);
                }), ke.call(e, e.media, "playing play pause ended emptied timeupdate", function (t) {
                  return lt.checkPlaying.call(e, t);
                }), ke.call(e, e.media, "waiting canplay seeked playing", function (t) {
                  return lt.checkLoading.call(e, t);
                }), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                  var i = ge.call(e, ".".concat(e.config.classNames.video));
                  if (!Y(i)) return;
                  ke.call(e, t.container, "click", function (r) {
                    ([t.container, i].includes(r.target) || i.contains(r.target)) && (e.touch && e.config.hideControls || (e.ended ? (n.proxy(r, e.restart, "restart"), n.proxy(r, function () {
                      Ee(e.play());
                    }, "play")) : n.proxy(r, function () {
                      Ee(e.togglePlay());
                    }, "play")));
                  });
                }

                e.supported.ui && e.config.disableContextMenu && ke.call(e, t.wrapper, "contextmenu", function (e) {
                  e.preventDefault();
                }, !1), ke.call(e, e.media, "volumechange", function () {
                  e.storage.set({
                    volume: e.volume,
                    muted: e.muted
                  });
                }), ke.call(e, e.media, "ratechange", function () {
                  $e.updateSetting.call(e, "speed"), e.storage.set({
                    speed: e.speed
                  });
                }), ke.call(e, e.media, "qualitychange", function (t) {
                  $e.updateSetting.call(e, "quality", null, t.detail.quality);
                }), ke.call(e, e.media, "ready qualitychange", function () {
                  $e.setDownloadUrl.call(e);
                });
                var r = e.config.events.concat(["keyup", "keydown"]).join(" ");
                ke.call(e, e.media, r, function (i) {
                  var n = i.detail,
                      r = void 0 === n ? {} : n;
                  "error" === i.type && (r = e.media.error), Ce.call(e, t.container, i.type, !0, r);
                });
              }), e(this, "proxy", function (e, t, i) {
                var r = n.player,
                    o = r.config.listeners[i],
                    a = !0;
                F(o) && (a = o.call(r, e)), !1 !== a && F(t) && t.call(r, e);
              }), e(this, "bind", function (e, t, i, r) {
                var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                    a = n.player,
                    s = a.config.listeners[r],
                    l = F(s);
                ke.call(a, e, t, function (e) {
                  return n.proxy(e, i, r);
                }, o && !l);
              }), e(this, "controls", function () {
                var e = n.player,
                    t = e.elements,
                    i = ee.isIE ? "change" : "input";

                if (t.buttons.play && Array.from(t.buttons.play).forEach(function (t) {
                  n.bind(t, "click", function () {
                    Ee(e.togglePlay());
                  }, "play");
                }), n.bind(t.buttons.restart, "click", e.restart, "restart"), n.bind(t.buttons.rewind, "click", function () {
                  e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), n.bind(t.buttons.fastForward, "click", function () {
                  e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), n.bind(t.buttons.mute, "click", function () {
                  e.muted = !e.muted;
                }, "mute"), n.bind(t.buttons.captions, "click", function () {
                  return e.toggleCaptions();
                }), n.bind(t.buttons.download, "click", function () {
                  Ce.call(e, e.media, "download");
                }, "download"), n.bind(t.buttons.fullscreen, "click", function () {
                  e.fullscreen.toggle();
                }, "fullscreen"), n.bind(t.buttons.pip, "click", function () {
                  e.pip = "toggle";
                }, "pip"), n.bind(t.buttons.airplay, "click", e.airplay, "airplay"), n.bind(t.buttons.settings, "click", function (t) {
                  t.stopPropagation(), t.preventDefault(), $e.toggleMenu.call(e, t);
                }, null, !1), n.bind(t.buttons.settings, "keyup", function (t) {
                  var i = t.which;
                  [13, 32].includes(i) && (13 !== i ? (t.preventDefault(), t.stopPropagation(), $e.toggleMenu.call(e, t)) : $e.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), n.bind(t.settings.menu, "keydown", function (t) {
                  27 === t.which && $e.toggleMenu.call(e, t);
                }), n.bind(t.inputs.seek, "mousedown mousemove", function (e) {
                  var i = t.progress.getBoundingClientRect(),
                      n = 100 / i.width * (e.pageX - i.left);
                  e.currentTarget.setAttribute("seek-value", n);
                }), n.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", function (t) {
                  var i = t.currentTarget,
                      n = t.keyCode ? t.keyCode : t.which,
                      r = "play-on-seeked";

                  if (!X(t) || 39 === n || 37 === n) {
                    e.lastSeekTime = Date.now();
                    var o = i.hasAttribute(r),
                        a = ["mouseup", "touchend", "keyup"].includes(t.type);
                    o && a ? (i.removeAttribute(r), Ee(e.play())) : !a && e.playing && (i.setAttribute(r, ""), e.pause());
                  }
                }), ee.isIos) {
                  var r = me.call(e, 'input[type="range"]');
                  Array.from(r).forEach(function (e) {
                    return n.bind(e, i, function (e) {
                      return Z(e.target);
                    });
                  });
                }

                n.bind(t.inputs.seek, i, function (t) {
                  var i = t.currentTarget,
                      n = i.getAttribute("seek-value");
                  Q(n) && (n = i.value), i.removeAttribute("seek-value"), e.currentTime = n / i.max * e.duration;
                }, "seek"), n.bind(t.progress, "mouseenter mouseleave mousemove", function (t) {
                  return $e.updateSeekTooltip.call(e, t);
                }), n.bind(t.progress, "mousemove touchmove", function (t) {
                  var i = e.previewThumbnails;
                  i && i.loaded && i.startMove(t);
                }), n.bind(t.progress, "mouseleave touchend click", function () {
                  var t = e.previewThumbnails;
                  t && t.loaded && t.endMove(!1, !0);
                }), n.bind(t.progress, "mousedown touchstart", function (t) {
                  var i = e.previewThumbnails;
                  i && i.loaded && i.startScrubbing(t);
                }), n.bind(t.progress, "mouseup touchend", function (t) {
                  var i = e.previewThumbnails;
                  i && i.loaded && i.endScrubbing(t);
                }), ee.isWebkit && Array.from(me.call(e, 'input[type="range"]')).forEach(function (t) {
                  n.bind(t, "input", function (t) {
                    return $e.updateRangeFill.call(e, t.target);
                  });
                }), e.config.toggleInvert && !Y(t.display.duration) && n.bind(t.display.currentTime, "click", function () {
                  0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, $e.timeUpdate.call(e));
                }), n.bind(t.inputs.volume, i, function (t) {
                  e.volume = t.target.value;
                }, "volume"), n.bind(t.controls, "mouseenter mouseleave", function (i) {
                  t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter(function (e) {
                  return !e.contains(t.container);
                }).forEach(function (i) {
                  n.bind(i, "mouseenter mouseleave", function (i) {
                    t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                  });
                }), n.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", function (e) {
                  t.controls.pressed = ["mousedown", "touchstart"].includes(e.type);
                }), n.bind(t.controls, "focusin", function () {
                  var i = e.config,
                      r = e.timers;
                  de(t.controls, i.classNames.noTransition, !0), lt.toggleControls.call(e, !0), setTimeout(function () {
                    de(t.controls, i.classNames.noTransition, !1);
                  }, 0);
                  var o = n.touch ? 3e3 : 4e3;
                  clearTimeout(r.controls), r.controls = setTimeout(function () {
                    return lt.toggleControls.call(e, !1);
                  }, o);
                }), n.bind(t.inputs.volume, "wheel", function (t) {
                  var i = t.webkitDirectionInvertedFromDevice,
                      n = g([t.deltaX, -t.deltaY].map(function (e) {
                    return i ? -e : e;
                  }), 2),
                      r = n[0],
                      o = n[1],
                      a = Math.sign(Math.abs(r) > Math.abs(o) ? r : o);
                  e.increaseVolume(a / 50);
                  var s = e.media.volume;
                  (1 === a && s < 1 || -1 === a && s > 0) && t.preventDefault();
                }, "volume", !1);
              }), this.player = i, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.setTabFocus = this.setTabFocus.bind(this), this.firstTouch = this.firstTouch.bind(this);
            }

            return h(t, [{
              key: "handleKey",
              value: function value(e) {
                var t = this.player,
                    i = t.elements,
                    n = e.keyCode ? e.keyCode : e.which,
                    r = "keydown" === e.type,
                    o = r && n === this.lastKey;
                if (!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) && D(n)) if (r) {
                  var a = document.activeElement;

                  if (Y(a)) {
                    var s = t.config.selectors.editable;
                    if (a !== i.inputs.seek && fe(a, s)) return;
                    if (32 === e.which && fe(a, 'button, [role^="menuitem"]')) return;
                  }

                  switch ([32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79].includes(n) && (e.preventDefault(), e.stopPropagation()), n) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                      o || (t.currentTime = t.duration / 10 * (n - 48));
                      break;

                    case 32:
                    case 75:
                      o || Ee(t.togglePlay());
                      break;

                    case 38:
                      t.increaseVolume(.1);
                      break;

                    case 40:
                      t.decreaseVolume(.1);
                      break;

                    case 77:
                      o || (t.muted = !t.muted);
                      break;

                    case 39:
                      t.forward();
                      break;

                    case 37:
                      t.rewind();
                      break;

                    case 70:
                      t.fullscreen.toggle();
                      break;

                    case 67:
                      o || t.toggleCaptions();
                      break;

                    case 76:
                      t.loop = !t.loop;
                  }

                  27 === n && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = n;
                } else this.lastKey = null;
              }
            }, {
              key: "toggleMenu",
              value: function value(e) {
                $e.toggleMenu.call(this.player, e);
              }
            }]), t;
          }();

          "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== i.g ? i.g : "undefined" != typeof self && self;

          var ut = function (e, t) {
            return function (e, t) {
              e.exports = function () {
                var e = function e() {},
                    t = {},
                    i = {},
                    n = {};

                function r(e, t) {
                  if (e) {
                    var r = n[e];
                    if (i[e] = t, r) for (; r.length;) {
                      r[0](e, t), r.splice(0, 1);
                    }
                  }
                }

                function o(t, i) {
                  t.call && (t = {
                    success: t
                  }), i.length ? (t.error || e)(i) : (t.success || e)(t);
                }

                function a(t, i, n, r) {
                  var o,
                      s,
                      l = document,
                      c = n.async,
                      u = (n.numRetries || 0) + 1,
                      p = n.before || e,
                      d = t.replace(/[\?|#].*$/, ""),
                      h = t.replace(/^(css|img)!/, "");
                  r = r || 0, /(^css!|\.css$)/.test(d) ? ((s = l.createElement("link")).rel = "stylesheet", s.href = h, (o = "hideFocus" in s) && s.relList && (o = 0, s.rel = "preload", s.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (s = l.createElement("img")).src = h : ((s = l.createElement("script")).src = t, s.async = void 0 === c || c), s.onload = s.onerror = s.onbeforeload = function (e) {
                    var l = e.type[0];
                    if (o) try {
                      s.sheet.cssText.length || (l = "e");
                    } catch (e) {
                      18 != e.code && (l = "e");
                    }

                    if ("e" == l) {
                      if ((r += 1) < u) return a(t, i, n, r);
                    } else if ("preload" == s.rel && "style" == s.as) return s.rel = "stylesheet";

                    i(t, l, e.defaultPrevented);
                  }, !1 !== p(t, s) && l.head.appendChild(s);
                }

                function s(e, t, i) {
                  var n,
                      r,
                      o = (e = e.push ? e : [e]).length,
                      s = o,
                      l = [];

                  for (n = function n(e, i, _n) {
                    if ("e" == i && l.push(e), "b" == i) {
                      if (!_n) return;
                      l.push(e);
                    }

                    --o || t(l);
                  }, r = 0; r < s; r++) {
                    a(e[r], n, i);
                  }
                }

                function l(e, i, n) {
                  var a, l;

                  if (i && i.trim && (a = i), l = (a ? n : i) || {}, a) {
                    if (a in t) throw "LoadJS";
                    t[a] = !0;
                  }

                  function c(t, i) {
                    s(e, function (e) {
                      o(l, e), t && o({
                        success: t,
                        error: i
                      }, e), r(a, e);
                    }, l);
                  }

                  if (l.returnPromise) return new Promise(c);
                  c();
                }

                return l.ready = function (e, t) {
                  return function (e, t) {
                    e = e.push ? e : [e];
                    var r,
                        o,
                        a,
                        s = [],
                        l = e.length,
                        c = l;

                    for (r = function r(e, i) {
                      i.length && s.push(e), --c || t(s);
                    }; l--;) {
                      o = e[l], (a = i[o]) ? r(o, a) : (n[o] = n[o] || []).push(r);
                    }
                  }(e, function (e) {
                    o(t, e);
                  }), l;
                }, l.done = function (e) {
                  r(e, []);
                }, l.reset = function () {
                  t = {}, i = {}, n = {};
                }, l.isDefined = function (e) {
                  return e in t;
                }, l;
              }();
            }(t = {
              exports: {}
            }), t.exports;
          }();

          function pt(e) {
            return new Promise(function (t, i) {
              ut(e, {
                success: t,
                error: i
              });
            });
          }

          function dt(e) {
            e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Ce.call(this, this.media, e ? "play" : "pause"));
          }

          var ht = {
            setup: function setup() {
              var e = this;
              de(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, je.call(e), R(window.Vimeo) ? ht.ready.call(e) : pt(e.config.urls.vimeo.sdk).then(function () {
                ht.ready.call(e);
              }).catch(function (t) {
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
              });
            },
            ready: function ready() {
              var e = this,
                  t = this,
                  i = t.config.vimeo,
                  n = i.premium,
                  r = i.referrerPolicy,
                  o = function (e, t) {
                if (null == e) return {};

                var i,
                    n,
                    r = function (e, t) {
                  if (null == e) return {};
                  var i,
                      n,
                      r = {},
                      o = Object.keys(e);

                  for (n = 0; n < o.length; n++) {
                    i = o[n], t.indexOf(i) >= 0 || (r[i] = e[i]);
                  }

                  return r;
                }(e, t);

                if (Object.getOwnPropertySymbols) {
                  var o = Object.getOwnPropertySymbols(e);

                  for (n = 0; n < o.length; n++) {
                    i = o[n], t.indexOf(i) >= 0 || Object.prototype.propertyIsEnumerable.call(e, i) && (r[i] = e[i]);
                  }
                }

                return r;
              }(i, a),
                  l = t.media.getAttribute("src"),
                  c = "";

              Q(l) ? (l = t.media.getAttribute(t.config.attributes.embed.id), c = t.media.getAttribute(t.config.attributes.embed.hash)) : c = function (e) {
                var t = e.match(s(/^.*(?:vimeo.com\/|video\/)(?:[0-9]+)(?:\?.*&*h=|\/)+([,0-9a-f]+)/, {
                  hash: 1
                }));
                return t ? t.groups.hash : null;
              }(l);
              var u = c ? {
                h: c
              } : {};
              n && Object.assign(o, {
                controls: !1,
                sidedock: !1
              });
              var p,
                  d = Ge(m(m({
                loop: t.config.loop.active,
                autoplay: t.autoplay,
                muted: t.muted,
                gesture: "media",
                playsinline: !this.config.fullscreen.iosNative
              }, u), o)),
                  h = Q(p = l) ? null : D(Number(p)) ? p : p.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : p,
                  f = oe("iframe"),
                  y = Re(t.config.urls.vimeo.iframe, h, d);
              if (f.setAttribute("src", y), f.setAttribute("allowfullscreen", ""), f.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")), Q(r) || f.setAttribute("referrerPolicy", r), n || !i.customControls) f.setAttribute("data-poster", t.poster), t.media = ce(f, t.media);else {
                var b = oe("div", {
                  class: t.config.classNames.embedContainer,
                  "data-poster": t.poster
                });
                b.appendChild(f), t.media = ce(b, t.media);
              }
              i.customControls || Ye(Re(t.config.urls.vimeo.api, y)).then(function (e) {
                !Q(e) && e.thumbnail_url && lt.setPoster.call(t, e.thumbnail_url).catch(function () {});
              }), t.embed = new window.Vimeo.Player(f, {
                autopause: t.config.autopause,
                muted: t.muted
              }), t.media.paused = !0, t.media.currentTime = 0, t.supported.ui && t.embed.disableTextTrack(), t.media.play = function () {
                return dt.call(t, !0), t.embed.play();
              }, t.media.pause = function () {
                return dt.call(t, !1), t.embed.pause();
              }, t.media.stop = function () {
                t.pause(), t.currentTime = 0;
              };
              var v = t.media.currentTime;
              Object.defineProperty(t.media, "currentTime", {
                get: function get() {
                  return v;
                },
                set: function set(e) {
                  var i = t.embed,
                      n = t.media,
                      r = t.paused,
                      o = t.volume,
                      a = r && !i.hasPlayed;
                  n.seeking = !0, Ce.call(t, n, "seeking"), Promise.resolve(a && i.setVolume(0)).then(function () {
                    return i.setCurrentTime(e);
                  }).then(function () {
                    return a && i.pause();
                  }).then(function () {
                    return a && i.setVolume(o);
                  }).catch(function () {});
                }
              });
              var w = t.config.speed.selected;
              Object.defineProperty(t.media, "playbackRate", {
                get: function get() {
                  return w;
                },
                set: function set(e) {
                  t.embed.setPlaybackRate(e).then(function () {
                    w = e, Ce.call(t, t.media, "ratechange");
                  }).catch(function () {
                    t.options.speed = [1];
                  });
                }
              });
              var _ = t.config.volume;
              Object.defineProperty(t.media, "volume", {
                get: function get() {
                  return _;
                },
                set: function set(e) {
                  t.embed.setVolume(e).then(function () {
                    _ = e, Ce.call(t, t.media, "volumechange");
                  });
                }
              });
              var k = t.config.muted;
              Object.defineProperty(t.media, "muted", {
                get: function get() {
                  return k;
                },
                set: function set(e) {
                  var i = !!B(e) && e;
                  t.embed.setVolume(i ? 0 : t.config.volume).then(function () {
                    k = i, Ce.call(t, t.media, "volumechange");
                  });
                }
              });
              var x,
                  T = t.config.loop;
              Object.defineProperty(t.media, "loop", {
                get: function get() {
                  return T;
                },
                set: function set(e) {
                  var i = B(e) ? e : t.config.loop.active;
                  t.embed.setLoop(i).then(function () {
                    T = i;
                  });
                }
              }), t.embed.getVideoUrl().then(function (e) {
                x = e, $e.setDownloadUrl.call(t);
              }).catch(function (t) {
                e.debug.warn(t);
              }), Object.defineProperty(t.media, "currentSrc", {
                get: function get() {
                  return x;
                }
              }), Object.defineProperty(t.media, "ended", {
                get: function get() {
                  return t.currentTime === t.duration;
                }
              }), Promise.all([t.embed.getVideoWidth(), t.embed.getVideoHeight()]).then(function (i) {
                var n = g(i, 2),
                    r = n[0],
                    o = n[1];
                t.embed.ratio = He(r, o), je.call(e);
              }), t.embed.setAutopause(t.config.autopause).then(function (e) {
                t.config.autopause = e;
              }), t.embed.getVideoTitle().then(function (i) {
                t.config.title = i, lt.setTitle.call(e);
              }), t.embed.getCurrentTime().then(function (e) {
                v = e, Ce.call(t, t.media, "timeupdate");
              }), t.embed.getDuration().then(function (e) {
                t.media.duration = e, Ce.call(t, t.media, "durationchange");
              }), t.embed.getTextTracks().then(function (e) {
                t.media.textTracks = e, Ze.setup.call(t);
              }), t.embed.on("cuechange", function (e) {
                var i = e.cues,
                    n = (void 0 === i ? [] : i).map(function (e) {
                  return function (e) {
                    var t = document.createDocumentFragment(),
                        i = document.createElement("div");
                    return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                  }(e.text);
                });
                Ze.updateCues.call(t, n);
              }), t.embed.on("loaded", function () {
                t.embed.getPaused().then(function (e) {
                  dt.call(t, !e), e || Ce.call(t, t.media, "playing");
                }), Y(t.embed.element) && t.supported.ui && t.embed.element.setAttribute("tabindex", -1);
              }), t.embed.on("bufferstart", function () {
                Ce.call(t, t.media, "waiting");
              }), t.embed.on("bufferend", function () {
                Ce.call(t, t.media, "playing");
              }), t.embed.on("play", function () {
                dt.call(t, !0), Ce.call(t, t.media, "playing");
              }), t.embed.on("pause", function () {
                dt.call(t, !1);
              }), t.embed.on("timeupdate", function (e) {
                t.media.seeking = !1, v = e.seconds, Ce.call(t, t.media, "timeupdate");
              }), t.embed.on("progress", function (e) {
                t.media.buffered = e.percent, Ce.call(t, t.media, "progress"), 1 === parseInt(e.percent, 10) && Ce.call(t, t.media, "canplaythrough"), t.embed.getDuration().then(function (e) {
                  e !== t.media.duration && (t.media.duration = e, Ce.call(t, t.media, "durationchange"));
                });
              }), t.embed.on("seeked", function () {
                t.media.seeking = !1, Ce.call(t, t.media, "seeked");
              }), t.embed.on("ended", function () {
                t.media.paused = !0, Ce.call(t, t.media, "ended");
              }), t.embed.on("error", function (e) {
                t.media.error = e, Ce.call(t, t.media, "error");
              }), i.customControls && setTimeout(function () {
                return lt.build.call(t);
              }, 0);
            }
          };

          function ft(e) {
            e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Ce.call(this, this.media, e ? "play" : "pause"));
          }

          function mt(e) {
            return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
          }

          var gt,
              yt = {
            setup: function setup() {
              var e = this;
              if (de(this.elements.wrapper, this.config.classNames.embed, !0), R(window.YT) && F(window.YT.Player)) yt.ready.call(this);else {
                var t = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = function () {
                  F(t) && t(), yt.ready.call(e);
                }, pt(this.config.urls.youtube.sdk).catch(function (t) {
                  e.debug.warn("YouTube API failed to load", t);
                });
              }
            },
            getTitle: function getTitle(e) {
              var t = this;
              Ye(Re(this.config.urls.youtube.api, e)).then(function (e) {
                if (R(e)) {
                  var i = e.title,
                      n = e.height,
                      r = e.width;
                  t.config.title = i, lt.setTitle.call(t), t.embed.ratio = He(r, n);
                }

                je.call(t);
              }).catch(function () {
                je.call(t);
              });
            },
            ready: function ready() {
              var e = this,
                  t = e.config.youtube,
                  i = e.media && e.media.getAttribute("id");

              if (Q(i) || !i.startsWith("youtube-")) {
                var n = e.media.getAttribute("src");
                Q(n) && (n = e.media.getAttribute(this.config.attributes.embed.id));
                var r,
                    o = Q(r = n) ? null : r.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : r,
                    a = oe("div", {
                  id: "".concat(e.provider, "-").concat(Math.floor(1e4 * Math.random())),
                  "data-poster": t.customControls ? e.poster : void 0
                });

                if (e.media = ce(a, e.media), t.customControls) {
                  var s = function s(e) {
                    return "https://i.ytimg.com/vi/".concat(o, "/").concat(e, "default.jpg");
                  };

                  st(s("maxres"), 121).catch(function () {
                    return st(s("sd"), 121);
                  }).catch(function () {
                    return st(s("hq"));
                  }).then(function (t) {
                    return lt.setPoster.call(e, t.src);
                  }).then(function (t) {
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                  }).catch(function () {});
                }

                e.embed = new window.YT.Player(e.media, {
                  videoId: o,
                  host: mt(t),
                  playerVars: ie({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.fullscreen.iosNative ? 0 : 1,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                  }, t),
                  events: {
                    onError: function onError(t) {
                      if (!e.media.error) {
                        var i = t.data,
                            n = {
                          2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                          5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                          100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                          101: "The owner of the requested video does not allow it to be played in embedded players.",
                          150: "The owner of the requested video does not allow it to be played in embedded players."
                        }[i] || "An unknown error occured";
                        e.media.error = {
                          code: i,
                          message: n
                        }, Ce.call(e, e.media, "error");
                      }
                    },
                    onPlaybackRateChange: function onPlaybackRateChange(t) {
                      var i = t.target;
                      e.media.playbackRate = i.getPlaybackRate(), Ce.call(e, e.media, "ratechange");
                    },
                    onReady: function onReady(i) {
                      if (!F(e.media.play)) {
                        var n = i.target;
                        yt.getTitle.call(e, o), e.media.play = function () {
                          ft.call(e, !0), n.playVideo();
                        }, e.media.pause = function () {
                          ft.call(e, !1), n.pauseVideo();
                        }, e.media.stop = function () {
                          n.stopVideo();
                        }, e.media.duration = n.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                          get: function get() {
                            return Number(n.getCurrentTime());
                          },
                          set: function set(t) {
                            e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Ce.call(e, e.media, "seeking"), n.seekTo(t);
                          }
                        }), Object.defineProperty(e.media, "playbackRate", {
                          get: function get() {
                            return n.getPlaybackRate();
                          },
                          set: function set(e) {
                            n.setPlaybackRate(e);
                          }
                        });
                        var r = e.config.volume;
                        Object.defineProperty(e.media, "volume", {
                          get: function get() {
                            return r;
                          },
                          set: function set(t) {
                            r = t, n.setVolume(100 * r), Ce.call(e, e.media, "volumechange");
                          }
                        });
                        var a = e.config.muted;
                        Object.defineProperty(e.media, "muted", {
                          get: function get() {
                            return a;
                          },
                          set: function set(t) {
                            var i = B(t) ? t : a;
                            a = i, n[i ? "mute" : "unMute"](), n.setVolume(100 * r), Ce.call(e, e.media, "volumechange");
                          }
                        }), Object.defineProperty(e.media, "currentSrc", {
                          get: function get() {
                            return n.getVideoUrl();
                          }
                        }), Object.defineProperty(e.media, "ended", {
                          get: function get() {
                            return e.currentTime === e.duration;
                          }
                        });
                        var s = n.getAvailablePlaybackRates();
                        e.options.speed = s.filter(function (t) {
                          return e.config.speed.options.includes(t);
                        }), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Ce.call(e, e.media, "timeupdate"), Ce.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(function () {
                          e.media.buffered = n.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Ce.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Ce.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(function () {
                          return lt.build.call(e);
                        }, 50);
                      }
                    },
                    onStateChange: function onStateChange(i) {
                      var n = i.target;

                      switch (clearInterval(e.timers.playing), e.media.seeking && [1, 2].includes(i.data) && (e.media.seeking = !1, Ce.call(e, e.media, "seeked")), i.data) {
                        case -1:
                          Ce.call(e, e.media, "timeupdate"), e.media.buffered = n.getVideoLoadedFraction(), Ce.call(e, e.media, "progress");
                          break;

                        case 0:
                          ft.call(e, !1), e.media.loop ? (n.stopVideo(), n.playVideo()) : Ce.call(e, e.media, "ended");
                          break;

                        case 1:
                          t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (ft.call(e, !0), Ce.call(e, e.media, "playing"), e.timers.playing = setInterval(function () {
                            Ce.call(e, e.media, "timeupdate");
                          }, 50), e.media.duration !== n.getDuration() && (e.media.duration = n.getDuration(), Ce.call(e, e.media, "durationchange")));
                          break;

                        case 2:
                          e.muted || e.embed.unMute(), ft.call(e, !1);
                          break;

                        case 3:
                          Ce.call(e, e.media, "waiting");
                      }

                      Ce.call(e, e.elements.container, "statechange", !1, {
                        code: i.data
                      });
                    }
                  }
                });
              }
            }
          },
              bt = {
            setup: function setup() {
              this.media ? (de(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), de(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && de(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = oe("div", {
                class: this.config.classNames.video
              }), ne(this.media, this.elements.wrapper), this.elements.poster = oe("div", {
                class: this.config.classNames.poster
              }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? Ve.setup.call(this) : this.isYouTube ? yt.setup.call(this) : this.isVimeo && ht.setup.call(this)) : this.debug.warn("No media element found!");
            }
          },
              vt = function () {
            function t(i) {
              var n = this;
              p(this, t), e(this, "load", function () {
                n.enabled && (R(window.google) && R(window.google.ima) ? n.ready() : pt(n.player.config.urls.googleIMA.sdk).then(function () {
                  n.ready();
                }).catch(function () {
                  n.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
              }), e(this, "ready", function () {
                var e;
                n.enabled || ((e = n).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), n.startSafetyTimer(12e3, "ready()"), n.managerPromise.then(function () {
                  n.clearSafetyTimer("onAdsManagerLoaded()");
                }), n.listeners(), n.setupIMA();
              }), e(this, "setupIMA", function () {
                n.elements.container = oe("div", {
                  class: n.player.config.classNames.ads
                }), n.player.elements.container.appendChild(n.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(n.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(n.player.config.playsinline), n.elements.displayContainer = new google.ima.AdDisplayContainer(n.elements.container, n.player.media), n.loader = new google.ima.AdsLoader(n.elements.displayContainer), n.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function (e) {
                  return n.onAdsManagerLoaded(e);
                }, !1), n.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function (e) {
                  return n.onAdError(e);
                }, !1), n.requestAds();
              }), e(this, "requestAds", function () {
                var e = n.player.elements.container;

                try {
                  var t = new google.ima.AdsRequest();
                  t.adTagUrl = n.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!n.player.muted), n.loader.requestAds(t);
                } catch (e) {
                  n.onAdError(e);
                }
              }), e(this, "pollCountdown", function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (!e) return clearInterval(n.countdownTimer), void n.elements.container.removeAttribute("data-badge-text");
                n.countdownTimer = setInterval(function () {
                  var e = Je(Math.max(n.manager.getRemainingTime(), 0)),
                      t = "".concat(Ue("advertisement", n.player.config), " - ").concat(e);
                  n.elements.container.setAttribute("data-badge-text", t);
                }, 100);
              }), e(this, "onAdsManagerLoaded", function (e) {
                if (n.enabled) {
                  var t = new google.ima.AdsRenderingSettings();
                  t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, n.manager = e.getAdsManager(n.player, t), n.cuePoints = n.manager.getCuePoints(), n.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function (e) {
                    return n.onAdError(e);
                  }), Object.keys(google.ima.AdEvent.Type).forEach(function (e) {
                    n.manager.addEventListener(google.ima.AdEvent.Type[e], function (e) {
                      return n.onAdEvent(e);
                    });
                  }), n.trigger("loaded");
                }
              }), e(this, "addCuePoints", function () {
                Q(n.cuePoints) || n.cuePoints.forEach(function (e) {
                  if (0 !== e && -1 !== e && e < n.player.duration) {
                    var t = n.player.elements.progress;

                    if (Y(t)) {
                      var i = 100 / n.player.duration * e,
                          r = oe("span", {
                        class: n.player.config.classNames.cues
                      });
                      r.style.left = "".concat(i.toString(), "%"), t.appendChild(r);
                    }
                  }
                });
              }), e(this, "onAdEvent", function (e) {
                var t = n.player.elements.container,
                    i = e.getAd(),
                    r = e.getAdData();

                switch (function (e) {
                  Ce.call(n.player, n.player.media, "ads".concat(e.replace(/_/g, "").toLowerCase()));
                }(e.type), e.type) {
                  case google.ima.AdEvent.Type.LOADED:
                    n.trigger("loaded"), n.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                    break;

                  case google.ima.AdEvent.Type.STARTED:
                    n.manager.setVolume(n.player.volume);
                    break;

                  case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                    n.player.ended ? n.loadAds() : n.loader.contentComplete();
                    break;

                  case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                    n.pauseContent();
                    break;

                  case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                    n.pollCountdown(), n.resumeContent();
                    break;

                  case google.ima.AdEvent.Type.LOG:
                    r.adError && n.player.debug.warn("Non-fatal ad error: ".concat(r.adError.getMessage()));
                }
              }), e(this, "onAdError", function (e) {
                n.cancel(), n.player.debug.warn("Ads error", e);
              }), e(this, "listeners", function () {
                var e,
                    t = n.player.elements.container;
                n.player.on("canplay", function () {
                  n.addCuePoints();
                }), n.player.on("ended", function () {
                  n.loader.contentComplete();
                }), n.player.on("timeupdate", function () {
                  e = n.player.currentTime;
                }), n.player.on("seeked", function () {
                  var t = n.player.currentTime;
                  Q(n.cuePoints) || n.cuePoints.forEach(function (i, r) {
                    e < i && i < t && (n.manager.discardAdBreak(), n.cuePoints.splice(r, 1));
                  });
                }), window.addEventListener("resize", function () {
                  n.manager && n.manager.resize(t.offsetWidth, t.offsetHeight, google.ima.ViewMode.NORMAL);
                });
              }), e(this, "play", function () {
                var e = n.player.elements.container;
                n.managerPromise || n.resumeContent(), n.managerPromise.then(function () {
                  n.manager.setVolume(n.player.volume), n.elements.displayContainer.initialize();

                  try {
                    n.initialized || (n.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), n.manager.start()), n.initialized = !0;
                  } catch (e) {
                    n.onAdError(e);
                  }
                }).catch(function () {});
              }), e(this, "resumeContent", function () {
                n.elements.container.style.zIndex = "", n.playing = !1, Ee(n.player.media.play());
              }), e(this, "pauseContent", function () {
                n.elements.container.style.zIndex = 3, n.playing = !0, n.player.media.pause();
              }), e(this, "cancel", function () {
                n.initialized && n.resumeContent(), n.trigger("error"), n.loadAds();
              }), e(this, "loadAds", function () {
                n.managerPromise.then(function () {
                  n.manager && n.manager.destroy(), n.managerPromise = new Promise(function (e) {
                    n.on("loaded", e), n.player.debug.log(n.manager);
                  }), n.initialized = !1, n.requestAds();
                }).catch(function () {});
              }), e(this, "trigger", function (e) {
                for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
                  i[r - 1] = arguments[r];
                }

                var o = n.events[e];
                U(o) && o.forEach(function (e) {
                  F(e) && e.apply(n, i);
                });
              }), e(this, "on", function (e, t) {
                return U(n.events[e]) || (n.events[e] = []), n.events[e].push(t), n;
              }), e(this, "startSafetyTimer", function (e, t) {
                n.player.debug.log("Safety timer invoked from: ".concat(t)), n.safetyTimer = setTimeout(function () {
                  n.cancel(), n.clearSafetyTimer("startSafetyTimer()");
                }, e);
              }), e(this, "clearSafetyTimer", function (e) {
                V(n.safetyTimer) || (n.player.debug.log("Safety timer cleared from: ".concat(e)), clearTimeout(n.safetyTimer), n.safetyTimer = null);
              }), this.player = i, this.config = i.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
              }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise(function (e, t) {
                n.on("loaded", e), n.on("error", t);
              }), this.load();
            }

            return h(t, [{
              key: "enabled",
              get: function get() {
                var e = this.config;
                return this.player.isHTML5 && this.player.isVideo && e.enabled && (!Q(e.publisherId) || $(e.tagUrl));
              }
            }, {
              key: "tagUrl",
              get: function get() {
                var e = this.config;
                return $(e.tagUrl) ? e.tagUrl : "https://go.aniview.com/api/adserver6/vast/?".concat(Ge({
                  AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                  AV_CHANNELID: "5a0458dc28a06145e4519d21",
                  AV_URL: window.location.hostname,
                  cb: Date.now(),
                  AV_WIDTH: 640,
                  AV_HEIGHT: 480,
                  AV_CDIM2: e.publisherId
                }));
              }
            }]), t;
          }(),
              wt = function wt(e) {
            var t = [];
            return e.split(/\r\n\r\n|\n\n|\r\r/).forEach(function (e) {
              var i = {};
              e.split(/\r\n|\n|\r/).forEach(function (e) {
                if (D(i.startTime)) {
                  if (!Q(e.trim()) && Q(i.text)) {
                    var t,
                        n,
                        r = e.trim().split("#xywh=");
                    t = g(r, 1), i.text = t[0], r[1] && (n = g(r[1].split(","), 4), i.x = n[0], i.y = n[1], i.w = n[2], i.h = n[3]);
                  }
                } else {
                  var o = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                  o && (i.startTime = 60 * Number(o[1] || 0) * 60 + 60 * Number(o[2]) + Number(o[3]) + Number("0.".concat(o[4])), i.endTime = 60 * Number(o[6] || 0) * 60 + 60 * Number(o[7]) + Number(o[8]) + Number("0.".concat(o[9])));
                }
              }), i.text && t.push(i);
            }), t;
          },
              _t = function _t(e, t) {
            var i = {};
            return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
          },
              kt = function () {
            function t(i) {
              var n = this;
              p(this, t), e(this, "load", function () {
                n.player.elements.display.seekTooltip && (n.player.elements.display.seekTooltip.hidden = n.enabled), n.enabled && n.getThumbnails().then(function () {
                  n.enabled && (n.render(), n.determineContainerAutoSizing(), n.loaded = !0);
                });
              }), e(this, "getThumbnails", function () {
                return new Promise(function (e) {
                  var t = n.player.config.previewThumbnails.src;
                  if (Q(t)) throw new Error("Missing previewThumbnails.src config attribute");

                  var i = function i() {
                    n.thumbnails.sort(function (e, t) {
                      return e.height - t.height;
                    }), n.player.debug.log("Preview thumbnails", n.thumbnails), e();
                  };

                  if (F(t)) t(function (e) {
                    n.thumbnails = e, i();
                  });else {
                    var r = (q(t) ? [t] : t).map(function (e) {
                      return n.getThumbnail(e);
                    });
                    Promise.all(r).then(i);
                  }
                });
              }), e(this, "getThumbnail", function (e) {
                return new Promise(function (t) {
                  Ye(e).then(function (i) {
                    var r = {
                      frames: wt(i),
                      height: null,
                      urlPrefix: ""
                    };
                    r.frames[0].text.startsWith("/") || r.frames[0].text.startsWith("http://") || r.frames[0].text.startsWith("https://") || (r.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                    var o = new Image();
                    o.onload = function () {
                      r.height = o.naturalHeight, r.width = o.naturalWidth, n.thumbnails.push(r), t();
                    }, o.src = r.urlPrefix + r.frames[0].text;
                  });
                });
              }), e(this, "startMove", function (e) {
                if (n.loaded && K(e) && ["touchmove", "mousemove"].includes(e.type) && n.player.media.duration) {
                  if ("touchmove" === e.type) n.seekTime = n.player.media.duration * (n.player.elements.inputs.seek.value / 100);else {
                    var t = n.player.elements.progress.getBoundingClientRect(),
                        i = 100 / t.width * (e.pageX - t.left);
                    n.seekTime = n.player.media.duration * (i / 100), n.seekTime < 0 && (n.seekTime = 0), n.seekTime > n.player.media.duration - 1 && (n.seekTime = n.player.media.duration - 1), n.mousePosX = e.pageX, n.elements.thumb.time.innerText = Je(n.seekTime);
                  }
                  n.showImageAtCurrentTime();
                }
              }), e(this, "endMove", function () {
                n.toggleThumbContainer(!1, !0);
              }), e(this, "startScrubbing", function (e) {
                (V(e.button) || !1 === e.button || 0 === e.button) && (n.mouseDown = !0, n.player.media.duration && (n.toggleScrubbingContainer(!0), n.toggleThumbContainer(!1, !0), n.showImageAtCurrentTime()));
              }), e(this, "endScrubbing", function () {
                n.mouseDown = !1, Math.ceil(n.lastTime) === Math.ceil(n.player.media.currentTime) ? n.toggleScrubbingContainer(!1) : Te.call(n.player, n.player.media, "timeupdate", function () {
                  n.mouseDown || n.toggleScrubbingContainer(!1);
                });
              }), e(this, "listeners", function () {
                n.player.on("play", function () {
                  n.toggleThumbContainer(!1, !0);
                }), n.player.on("seeked", function () {
                  n.toggleThumbContainer(!1);
                }), n.player.on("timeupdate", function () {
                  n.lastTime = n.player.media.currentTime;
                });
              }), e(this, "render", function () {
                n.elements.thumb.container = oe("div", {
                  class: n.player.config.classNames.previewThumbnails.thumbContainer
                }), n.elements.thumb.imageContainer = oe("div", {
                  class: n.player.config.classNames.previewThumbnails.imageContainer
                }), n.elements.thumb.container.appendChild(n.elements.thumb.imageContainer);
                var e = oe("div", {
                  class: n.player.config.classNames.previewThumbnails.timeContainer
                });
                n.elements.thumb.time = oe("span", {}, "00:00"), e.appendChild(n.elements.thumb.time), n.elements.thumb.container.appendChild(e), Y(n.player.elements.progress) && n.player.elements.progress.appendChild(n.elements.thumb.container), n.elements.scrubbing.container = oe("div", {
                  class: n.player.config.classNames.previewThumbnails.scrubbingContainer
                }), n.player.elements.wrapper.appendChild(n.elements.scrubbing.container);
              }), e(this, "destroy", function () {
                n.elements.thumb.container && n.elements.thumb.container.remove(), n.elements.scrubbing.container && n.elements.scrubbing.container.remove();
              }), e(this, "showImageAtCurrentTime", function () {
                n.mouseDown ? n.setScrubbingContainerSize() : n.setThumbContainerSizeAndPos();
                var e = n.thumbnails[0].frames.findIndex(function (e) {
                  return n.seekTime >= e.startTime && n.seekTime <= e.endTime;
                }),
                    t = e >= 0,
                    i = 0;
                n.mouseDown || n.toggleThumbContainer(t), t && (n.thumbnails.forEach(function (t, r) {
                  n.loadedImages.includes(t.frames[e].text) && (i = r);
                }), e !== n.showingThumb && (n.showingThumb = e, n.loadImage(i)));
              }), e(this, "loadImage", function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                    t = n.showingThumb,
                    i = n.thumbnails[e],
                    r = i.urlPrefix,
                    o = i.frames[t],
                    a = i.frames[t].text,
                    s = r + a;
                if (n.currentImageElement && n.currentImageElement.dataset.filename === a) n.showImage(n.currentImageElement, o, e, t, a, !1), n.currentImageElement.dataset.index = t, n.removeOldImages(n.currentImageElement);else {
                  n.loadingImage && n.usingSprites && (n.loadingImage.onload = null);
                  var l = new Image();
                  l.src = s, l.dataset.index = t, l.dataset.filename = a, n.showingThumbFilename = a, n.player.debug.log("Loading image: ".concat(s)), l.onload = function () {
                    return n.showImage(l, o, e, t, a, !0);
                  }, n.loadingImage = l, n.removeOldImages(l);
                }
              }), e(this, "showImage", function (e, t, i, r, o) {
                var a = !(arguments.length > 5 && void 0 !== arguments[5]) || arguments[5];
                n.player.debug.log("Showing thumb: ".concat(o, ". num: ").concat(r, ". qual: ").concat(i, ". newimg: ").concat(a)), n.setImageSizeAndOffset(e, t), a && (n.currentImageContainer.appendChild(e), n.currentImageElement = e, n.loadedImages.includes(o) || n.loadedImages.push(o)), n.preloadNearby(r, !0).then(n.preloadNearby(r, !1)).then(n.getHigherQuality(i, e, t, o));
              }), e(this, "removeOldImages", function (e) {
                Array.from(n.currentImageContainer.children).forEach(function (t) {
                  if ("img" === t.tagName.toLowerCase()) {
                    var i = n.usingSprites ? 500 : 1e3;

                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                      t.dataset.deleting = !0;
                      var r = n.currentImageContainer;
                      setTimeout(function () {
                        r.removeChild(t), n.player.debug.log("Removing thumb: ".concat(t.dataset.filename));
                      }, i);
                    }
                  }
                });
              }), e(this, "preloadNearby", function (e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return new Promise(function (i) {
                  setTimeout(function () {
                    var r = n.thumbnails[0].frames[e].text;

                    if (n.showingThumbFilename === r) {
                      var o;
                      o = t ? n.thumbnails[0].frames.slice(e) : n.thumbnails[0].frames.slice(0, e).reverse();
                      var a = !1;
                      o.forEach(function (e) {
                        var t = e.text;

                        if (t !== r && !n.loadedImages.includes(t)) {
                          a = !0, n.player.debug.log("Preloading thumb filename: ".concat(t));
                          var o = n.thumbnails[0].urlPrefix + t,
                              s = new Image();
                          s.src = o, s.onload = function () {
                            n.player.debug.log("Preloaded thumb filename: ".concat(t)), n.loadedImages.includes(t) || n.loadedImages.push(t), i();
                          };
                        }
                      }), a || i();
                    }
                  }, 300);
                });
              }), e(this, "getHigherQuality", function (e, t, i, r) {
                if (e < n.thumbnails.length - 1) {
                  var o = t.naturalHeight;
                  n.usingSprites && (o = i.h), o < n.thumbContainerHeight && setTimeout(function () {
                    n.showingThumbFilename === r && (n.player.debug.log("Showing higher quality thumb for: ".concat(r)), n.loadImage(e + 1));
                  }, 300);
                }
              }), e(this, "toggleThumbContainer", function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    i = n.player.config.classNames.previewThumbnails.thumbContainerShown;
                n.elements.thumb.container.classList.toggle(i, e), !e && t && (n.showingThumb = null, n.showingThumbFilename = null);
              }), e(this, "toggleScrubbingContainer", function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    t = n.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                n.elements.scrubbing.container.classList.toggle(t, e), e || (n.showingThumb = null, n.showingThumbFilename = null);
              }), e(this, "determineContainerAutoSizing", function () {
                (n.elements.thumb.imageContainer.clientHeight > 20 || n.elements.thumb.imageContainer.clientWidth > 20) && (n.sizeSpecifiedInCSS = !0);
              }), e(this, "setThumbContainerSizeAndPos", function () {
                if (n.sizeSpecifiedInCSS) {
                  if (n.elements.thumb.imageContainer.clientHeight > 20 && n.elements.thumb.imageContainer.clientWidth < 20) {
                    var e = Math.floor(n.elements.thumb.imageContainer.clientHeight * n.thumbAspectRatio);
                    n.elements.thumb.imageContainer.style.width = "".concat(e, "px");
                  } else if (n.elements.thumb.imageContainer.clientHeight < 20 && n.elements.thumb.imageContainer.clientWidth > 20) {
                    var t = Math.floor(n.elements.thumb.imageContainer.clientWidth / n.thumbAspectRatio);
                    n.elements.thumb.imageContainer.style.height = "".concat(t, "px");
                  }
                } else {
                  var i = Math.floor(n.thumbContainerHeight * n.thumbAspectRatio);
                  n.elements.thumb.imageContainer.style.height = "".concat(n.thumbContainerHeight, "px"), n.elements.thumb.imageContainer.style.width = "".concat(i, "px");
                }

                n.setThumbContainerPos();
              }), e(this, "setThumbContainerPos", function () {
                var e = n.player.elements.progress.getBoundingClientRect(),
                    t = n.player.elements.container.getBoundingClientRect(),
                    i = n.elements.thumb.container,
                    r = t.left - e.left + 10,
                    o = t.right - e.left - i.clientWidth - 10,
                    a = n.mousePosX - e.left - i.clientWidth / 2;
                a < r && (a = r), a > o && (a = o), i.style.left = "".concat(a, "px");
              }), e(this, "setScrubbingContainerSize", function () {
                var e = _t(n.thumbAspectRatio, {
                  width: n.player.media.clientWidth,
                  height: n.player.media.clientHeight
                }),
                    t = e.width,
                    i = e.height;

                n.elements.scrubbing.container.style.width = "".concat(t, "px"), n.elements.scrubbing.container.style.height = "".concat(i, "px");
              }), e(this, "setImageSizeAndOffset", function (e, t) {
                if (n.usingSprites) {
                  var i = n.thumbContainerHeight / t.h;
                  e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = "-".concat(t.x * i, "px"), e.style.top = "-".concat(t.y * i, "px");
                }
              }), this.player = i, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
              }, this.load();
            }

            return h(t, [{
              key: "enabled",
              get: function get() {
                return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
              }
            }, {
              key: "currentImageContainer",
              get: function get() {
                return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
              }
            }, {
              key: "usingSprites",
              get: function get() {
                return Object.keys(this.thumbnails[0].frames[0]).includes("w");
              }
            }, {
              key: "thumbAspectRatio",
              get: function get() {
                return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
              }
            }, {
              key: "thumbContainerHeight",
              get: function get() {
                return this.mouseDown ? _t(this.thumbAspectRatio, {
                  width: this.player.media.clientWidth,
                  height: this.player.media.clientHeight
                }).height : this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
              }
            }, {
              key: "currentImageElement",
              get: function get() {
                return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
              },
              set: function set(e) {
                this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
              }
            }]), t;
          }(),
              xt = {
            insertElements: function insertElements(e, t) {
              var i = this;
              q(t) ? ae(e, this.media, {
                src: t
              }) : U(t) && t.forEach(function (t) {
                ae(e, i.media, t);
              });
            },
            change: function change(e) {
              var t = this;
              te(e, "sources.length") ? (Ve.cancelRequests.call(this), this.destroy.call(this, function () {
                t.options.quality = [], se(t.media), t.media = null, Y(t.elements.container) && t.elements.container.removeAttribute("class");
                var i = e.sources,
                    n = e.type,
                    r = g(i, 1)[0],
                    o = r.provider,
                    a = void 0 === o ? it.html5 : o,
                    s = r.src,
                    l = "html5" === a ? n : "div",
                    c = "html5" === a ? {} : {
                  src: s
                };
                Object.assign(t, {
                  provider: a,
                  type: n,
                  supported: ve.check(n, a, t.config.playsinline),
                  media: oe(l, c)
                }), t.elements.container.appendChild(t.media), B(e.autoplay) && (t.config.autoplay = e.autoplay), t.isHTML5 && (t.config.crossorigin && t.media.setAttribute("crossorigin", ""), t.config.autoplay && t.media.setAttribute("autoplay", ""), Q(e.poster) || (t.poster = e.poster), t.config.loop.active && t.media.setAttribute("loop", ""), t.config.muted && t.media.setAttribute("muted", ""), t.config.playsinline && t.media.setAttribute("playsinline", "")), lt.addStyleHook.call(t), t.isHTML5 && xt.insertElements.call(t, "source", i), t.config.title = e.title, bt.setup.call(t), t.isHTML5 && Object.keys(e).includes("tracks") && xt.insertElements.call(t, "track", e.tracks), (t.isHTML5 || t.isEmbed && !t.supported.ui) && lt.build.call(t), t.isHTML5 && t.media.load(), Q(e.previewThumbnails) || (Object.assign(t.config.previewThumbnails, e.previewThumbnails), t.previewThumbnails && t.previewThumbnails.loaded && (t.previewThumbnails.destroy(), t.previewThumbnails = null), t.config.previewThumbnails.enabled && (t.previewThumbnails = new kt(t))), t.fullscreen.update();
              }, !0)) : this.debug.warn("Invalid source format");
            }
          },
              Tt = function () {
            function t(i, n) {
              var r = this;
              if (p(this, t), e(this, "play", function () {
                return F(r.media.play) ? (r.ads && r.ads.enabled && r.ads.managerPromise.then(function () {
                  return r.ads.play();
                }).catch(function () {
                  return Ee(r.media.play());
                }), r.media.play()) : null;
              }), e(this, "pause", function () {
                return r.playing && F(r.media.pause) ? r.media.pause() : null;
              }), e(this, "togglePlay", function (e) {
                return (B(e) ? e : !r.playing) ? r.play() : r.pause();
              }), e(this, "stop", function () {
                r.isHTML5 ? (r.pause(), r.restart()) : F(r.media.stop) && r.media.stop();
              }), e(this, "restart", function () {
                r.currentTime = 0;
              }), e(this, "rewind", function (e) {
                r.currentTime -= D(e) ? e : r.config.seekTime;
              }), e(this, "forward", function (e) {
                r.currentTime += D(e) ? e : r.config.seekTime;
              }), e(this, "increaseVolume", function (e) {
                var t = r.media.muted ? 0 : r.volume;
                r.volume = t + (D(e) ? e : 0);
              }), e(this, "decreaseVolume", function (e) {
                r.increaseVolume(-e);
              }), e(this, "airplay", function () {
                ve.airplay && r.media.webkitShowPlaybackTargetPicker();
              }), e(this, "toggleControls", function (e) {
                if (r.supported.ui && !r.isAudio) {
                  var t = he(r.elements.container, r.config.classNames.hideControls),
                      i = void 0 === e ? void 0 : !e,
                      n = de(r.elements.container, r.config.classNames.hideControls, i);

                  if (n && U(r.config.controls) && r.config.controls.includes("settings") && !Q(r.config.settings) && $e.toggleMenu.call(r, !1), n !== t) {
                    var o = n ? "controlshidden" : "controlsshown";
                    Ce.call(r, r.media, o);
                  }

                  return !n;
                }

                return !1;
              }), e(this, "on", function (e, t) {
                ke.call(r, r.elements.container, e, t);
              }), e(this, "once", function (e, t) {
                Te.call(r, r.elements.container, e, t);
              }), e(this, "off", function (e, t) {
                xe(r.elements.container, e, t);
              }), e(this, "destroy", function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

                if (r.ready) {
                  var i = function i() {
                    document.body.style.overflow = "", r.embed = null, t ? (Object.keys(r.elements).length && (se(r.elements.buttons.play), se(r.elements.captions), se(r.elements.controls), se(r.elements.wrapper), r.elements.buttons.play = null, r.elements.captions = null, r.elements.controls = null, r.elements.wrapper = null), F(e) && e()) : (Se.call(r), Ve.cancelRequests.call(r), ce(r.elements.original, r.elements.container), Ce.call(r, r.elements.original, "destroyed", !0), F(e) && e.call(r.elements.original), r.ready = !1, setTimeout(function () {
                      r.elements = null, r.media = null;
                    }, 200));
                  };

                  r.stop(), clearTimeout(r.timers.loading), clearTimeout(r.timers.controls), clearTimeout(r.timers.resized), r.isHTML5 ? (lt.toggleNativeControls.call(r, !0), i()) : r.isYouTube ? (clearInterval(r.timers.buffering), clearInterval(r.timers.playing), null !== r.embed && F(r.embed.destroy) && r.embed.destroy(), i()) : r.isVimeo && (null !== r.embed && r.embed.unload().then(i), setTimeout(i, 200));
                }
              }), e(this, "supports", function (e) {
                return ve.mime.call(r, e);
              }), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = ve.touch, this.media = i, q(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || W(this.media) || U(this.media)) && (this.media = this.media[0]), this.config = ie({}, et, t.defaults, n || {}, function () {
                try {
                  return JSON.parse(r.media.getAttribute("data-plyr-config"));
                } catch (e) {
                  return {};
                }
              }()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                  popup: null,
                  menu: null,
                  panels: {},
                  buttons: {}
                }
              }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap()
              }, this.fullscreen = {
                active: !1
              }, this.options = {
                speed: [],
                quality: []
              }, this.debug = new ot(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", ve), !V(this.media) && Y(this.media)) {
                if (this.media.plyr) this.debug.warn("Target already setup");else if (this.config.enabled) {
                  if (ve.check().api) {
                    var o = this.media.cloneNode(!0);
                    o.autoplay = !1, this.elements.original = o;
                    var a = this.media.tagName.toLowerCase(),
                        s = null,
                        l = null;

                    switch (a) {
                      case "div":
                        if (s = this.media.querySelector("iframe"), Y(s)) {
                          if (l = Qe(s.getAttribute("src")), this.provider = function (e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? it.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? it.vimeo : null;
                          }(l.toString()), this.elements.container = this.media, this.media = s, this.elements.container.className = "", l.search.length) {
                            var c = ["1", "true"];
                            c.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), c.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = c.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                          }
                        } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);

                        if (Q(this.provider) || !Object.values(it).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                        this.type = nt;
                        break;

                      case "video":
                      case "audio":
                        this.type = a, this.provider = it.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                        break;

                      default:
                        return void this.debug.error("Setup failed: unsupported type");
                    }

                    this.supported = ve.check(this.type, this.provider, this.config.playsinline), this.supported.api ? (this.eventListeners = [], this.listeners = new ct(this), this.storage = new We(this), this.media.plyr = this, Y(this.elements.container) || (this.elements.container = oe("div", {
                      tabindex: 0
                    }), ne(this.media, this.elements.container)), lt.migrateStyles.call(this), lt.addStyleHook.call(this), bt.setup.call(this), this.config.debug && ke.call(this, this.elements.container, this.config.events.join(" "), function (e) {
                      r.debug.log("event: ".concat(e.type));
                    }), this.fullscreen = new at(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && lt.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new vt(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", function () {
                      return Ee(r.play());
                    }), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new kt(this))) : this.debug.error("Setup failed: no support");
                  } else this.debug.error("Setup failed: no support");
                } else this.debug.error("Setup failed: disabled by config");
              } else this.debug.error("Setup failed: no suitable element passed");
            }

            return h(t, [{
              key: "isHTML5",
              get: function get() {
                return this.provider === it.html5;
              }
            }, {
              key: "isEmbed",
              get: function get() {
                return this.isYouTube || this.isVimeo;
              }
            }, {
              key: "isYouTube",
              get: function get() {
                return this.provider === it.youtube;
              }
            }, {
              key: "isVimeo",
              get: function get() {
                return this.provider === it.vimeo;
              }
            }, {
              key: "isVideo",
              get: function get() {
                return this.type === nt;
              }
            }, {
              key: "isAudio",
              get: function get() {
                return "audio" === this.type;
              }
            }, {
              key: "playing",
              get: function get() {
                return Boolean(this.ready && !this.paused && !this.ended);
              }
            }, {
              key: "paused",
              get: function get() {
                return Boolean(this.media.paused);
              }
            }, {
              key: "stopped",
              get: function get() {
                return Boolean(this.paused && 0 === this.currentTime);
              }
            }, {
              key: "ended",
              get: function get() {
                return Boolean(this.media.ended);
              }
            }, {
              key: "currentTime",
              get: function get() {
                return Number(this.media.currentTime);
              },
              set: function set(e) {
                if (this.duration) {
                  var t = D(e) && e > 0;
                  this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log("Seeking to ".concat(this.currentTime, " seconds"));
                }
              }
            }, {
              key: "buffered",
              get: function get() {
                var e = this.media.buffered;
                return D(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
              }
            }, {
              key: "seeking",
              get: function get() {
                return Boolean(this.media.seeking);
              }
            }, {
              key: "duration",
              get: function get() {
                var e = parseFloat(this.config.duration),
                    t = (this.media || {}).duration,
                    i = D(t) && t !== 1 / 0 ? t : 0;
                return e || i;
              }
            }, {
              key: "volume",
              get: function get() {
                return Number(this.media.volume);
              },
              set: function set(e) {
                var t = e;
                q(t) && (t = Number(t)), D(t) || (t = this.storage.get("volume")), D(t) || (t = this.config.volume), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !Q(e) && this.muted && t > 0 && (this.muted = !1);
              }
            }, {
              key: "muted",
              get: function get() {
                return Boolean(this.media.muted);
              },
              set: function set(e) {
                var t = e;
                B(t) || (t = this.storage.get("muted")), B(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
              }
            }, {
              key: "hasAudio",
              get: function get() {
                return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
              }
            }, {
              key: "speed",
              get: function get() {
                return Number(this.media.playbackRate);
              },
              set: function set(e) {
                var t = this,
                    i = null;
                D(e) && (i = e), D(i) || (i = this.storage.get("speed")), D(i) || (i = this.config.speed.selected);
                var n = this.minimumSpeed,
                    r = this.maximumSpeed;
                i = function () {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                      t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 255;
                  return Math.min(Math.max(e, t), i);
                }(i, n, r), this.config.speed.selected = i, setTimeout(function () {
                  t.media && (t.media.playbackRate = i);
                }, 0);
              }
            }, {
              key: "minimumSpeed",
              get: function get() {
                return this.isYouTube ? Math.min.apply(Math, u(this.options.speed)) : this.isVimeo ? .5 : .0625;
              }
            }, {
              key: "maximumSpeed",
              get: function get() {
                return this.isYouTube ? Math.max.apply(Math, u(this.options.speed)) : this.isVimeo ? 2 : 16;
              }
            }, {
              key: "quality",
              get: function get() {
                return this.media.quality;
              },
              set: function set(e) {
                var t = this.config.quality,
                    i = this.options.quality;

                if (i.length) {
                  var n = [!Q(e) && Number(e), this.storage.get("quality"), t.selected, t.default].find(D),
                      r = !0;

                  if (!i.includes(n)) {
                    var o = ze(i, n);
                    this.debug.warn("Unsupported quality option: ".concat(n, ", using ").concat(o, " instead")), n = o, r = !1;
                  }

                  t.selected = n, this.media.quality = n, r && this.storage.set({
                    quality: n
                  });
                }
              }
            }, {
              key: "loop",
              get: function get() {
                return Boolean(this.media.loop);
              },
              set: function set(e) {
                var t = B(e) ? e : this.config.loop.active;
                this.config.loop.active = t, this.media.loop = t;
              }
            }, {
              key: "source",
              get: function get() {
                return this.media.currentSrc;
              },
              set: function set(e) {
                xt.change.call(this, e);
              }
            }, {
              key: "download",
              get: function get() {
                var e = this.config.urls.download;
                return $(e) ? e : this.source;
              },
              set: function set(e) {
                $(e) && (this.config.urls.download = e, $e.setDownloadUrl.call(this));
              }
            }, {
              key: "poster",
              get: function get() {
                return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
              },
              set: function set(e) {
                this.isVideo ? lt.setPoster.call(this, e, !1).catch(function () {}) : this.debug.warn("Poster can only be set for video");
              }
            }, {
              key: "ratio",
              get: function get() {
                if (!this.isVideo) return null;
                var e = Ne(Oe.call(this));
                return U(e) ? e.join(":") : e;
              },
              set: function set(e) {
                this.isVideo ? q(e) && Le(e) ? (this.config.ratio = Ne(e), je.call(this)) : this.debug.error("Invalid aspect ratio specified (".concat(e, ")")) : this.debug.warn("Aspect ratio can only be set for video");
              }
            }, {
              key: "autoplay",
              get: function get() {
                return Boolean(this.config.autoplay);
              },
              set: function set(e) {
                var t = B(e) ? e : this.config.autoplay;
                this.config.autoplay = t;
              }
            }, {
              key: "toggleCaptions",
              value: function value(e) {
                Ze.toggle.call(this, e, !1);
              }
            }, {
              key: "currentTrack",
              get: function get() {
                var e = this.captions,
                    t = e.toggled,
                    i = e.currentTrack;
                return t ? i : -1;
              },
              set: function set(e) {
                Ze.set.call(this, e, !1), Ze.setup();
              }
            }, {
              key: "language",
              get: function get() {
                return (Ze.getCurrentTrack.call(this) || {}).language;
              },
              set: function set(e) {
                Ze.setLanguage.call(this, e, !1);
              }
            }, {
              key: "pip",
              get: function get() {
                return ve.pip ? Q(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === tt : null;
              },
              set: function set(e) {
                if (ve.pip) {
                  var t = B(e) ? e : !this.pip;
                  F(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? tt : "inline"), F(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
                }
              }
            }, {
              key: "setPreviewThumbnails",
              value: function value(e) {
                this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new kt(this));
              }
            }], [{
              key: "supported",
              value: function value(e, t, i) {
                return ve.check(e, t, i);
              }
            }, {
              key: "loadSprite",
              value: function value(e, t) {
                return Ke(e, t);
              }
            }, {
              key: "setup",
              value: function value(e) {
                var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = null;
                return q(e) ? n = Array.from(document.querySelectorAll(e)) : W(e) ? n = Array.from(e) : U(e) && (n = e.filter(Y)), Q(n) ? null : n.map(function (e) {
                  return new t(e, i);
                });
              }
            }]), t;
          }();

          return Tt.defaults = (gt = et, JSON.parse(JSON.stringify(gt))), Tt;
        }, "object" == w(t) ? e.exports = o() : void 0 === (r = "function" == typeof (n = o) ? n.call(t, i, t, e) : n) || (e.exports = r));
      },
      594: function _(e, t, i) {
        "use strict";

        var n = i(645),
            r = i.n(n)()(function (e) {
          return e[1];
        });
        r.push([e.id, '@charset "UTF-8";@keyframes plyr-progress{to{background-position:25px 0;background-position:var(--plyr-progress-loading-size,25px) 0}}@keyframes plyr-popup{0%{opacity:.5;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes plyr-fade-in{0%{opacity:0}to{opacity:1}}.plyr{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;align-items:center;direction:ltr;display:flex;flex-direction:column;font-family:inherit;font-family:var(--plyr-font-family,inherit);font-variant-numeric:tabular-nums;font-weight:400;font-weight:var(--plyr-font-weight-regular,400);line-height:1.7;line-height:var(--plyr-line-height,1.7);max-width:100%;min-width:200px;position:relative;text-shadow:none;transition:box-shadow .3s ease;z-index:0}.plyr audio,.plyr iframe,.plyr video{display:block;height:100%;width:100%}.plyr button{font:inherit;line-height:inherit;width:auto}.plyr:focus{outline:0}.plyr--full-ui{box-sizing:border-box}.plyr--full-ui *,.plyr--full-ui :after,.plyr--full-ui :before{box-sizing:inherit}.plyr--full-ui a,.plyr--full-ui button,.plyr--full-ui input,.plyr--full-ui label{touch-action:manipulation}.plyr__badge{background:#4a5464;background:var(--plyr-badge-background,#4a5464);border-radius:2px;border-radius:var(--plyr-badge-border-radius,2px);color:#fff;color:var(--plyr-badge-text-color,#fff);font-size:9px;font-size:var(--plyr-font-size-badge,9px);line-height:1;padding:3px 4px}.plyr--full-ui ::-webkit-media-text-track-container{display:none}.plyr__captions{animation:plyr-fade-in .3s ease;bottom:0;display:none;font-size:13px;font-size:var(--plyr-font-size-small,13px);left:0;padding:10px;padding:var(--plyr-control-spacing,10px);position:absolute;text-align:center;transition:transform .4s ease-in-out;width:100%}.plyr__captions span:empty{display:none}@media (min-width:480px){.plyr__captions{font-size:15px;font-size:var(--plyr-font-size-base,15px);padding:20px;padding:calc(var(--plyr-control-spacing, 10px)*2)}}@media (min-width:768px){.plyr__captions{font-size:18px;font-size:var(--plyr-font-size-large,18px)}}.plyr--captions-active .plyr__captions{display:block}.plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty)~.plyr__captions{transform:translateY(-40px);transform:translateY(calc(var(--plyr-control-spacing, 10px)*-4))}.plyr__caption{background:rgba(0,0,0,.8);background:var(--plyr-captions-background,rgba(0,0,0,.8));border-radius:2px;-webkit-box-decoration-break:clone;box-decoration-break:clone;color:#fff;color:var(--plyr-captions-text-color,#fff);line-height:185%;padding:.2em .5em;white-space:pre-wrap}.plyr__caption div{display:inline}.plyr__control{background:transparent;border:0;border-radius:3px;border-radius:var(--plyr-control-radius,3px);color:inherit;cursor:pointer;flex-shrink:0;overflow:visible;padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7);position:relative;transition:all .3s ease}.plyr__control svg{fill:currentColor;display:block;height:18px;height:var(--plyr-control-icon-size,18px);pointer-events:none;width:18px;width:var(--plyr-control-icon-size,18px)}.plyr__control:focus{outline:0}.plyr__control.plyr__tab-focus{outline-color:#00b3ff;outline-color:var(--plyr-tab-focus-color,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));outline-offset:2px;outline-style:dotted;outline-width:3px}a.plyr__control{text-decoration:none}.plyr__control.plyr__control--pressed .icon--not-pressed,.plyr__control.plyr__control--pressed .label--not-pressed,.plyr__control:not(.plyr__control--pressed) .icon--pressed,.plyr__control:not(.plyr__control--pressed) .label--pressed,a.plyr__control:after,a.plyr__control:before{display:none}.plyr--full-ui ::-webkit-media-controls{display:none}.plyr__controls{align-items:center;display:flex;justify-content:flex-end;text-align:center}.plyr__controls .plyr__progress__container{flex:1;min-width:0}.plyr__controls .plyr__controls__item{margin-left:2.5px;margin-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item:first-child{margin-left:0;margin-right:auto}.plyr__controls .plyr__controls__item.plyr__progress__container{padding-left:2.5px;padding-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item.plyr__time{padding:0 5px;padding:0 calc(var(--plyr-control-spacing, 10px)/2)}.plyr__controls .plyr__controls__item.plyr__progress__container:first-child,.plyr__controls .plyr__controls__item.plyr__time+.plyr__time,.plyr__controls .plyr__controls__item.plyr__time:first-child{padding-left:0}.plyr [data-plyr=airplay],.plyr [data-plyr=captions],.plyr [data-plyr=fullscreen],.plyr [data-plyr=pip],.plyr__controls:empty{display:none}.plyr--airplay-supported [data-plyr=airplay],.plyr--captions-enabled [data-plyr=captions],.plyr--fullscreen-enabled [data-plyr=fullscreen],.plyr--pip-supported [data-plyr=pip]{display:inline-block}.plyr__menu{display:flex;position:relative}.plyr__menu .plyr__control svg{transition:transform .3s ease}.plyr__menu .plyr__control[aria-expanded=true] svg{transform:rotate(90deg)}.plyr__menu .plyr__control[aria-expanded=true] .plyr__tooltip{display:none}.plyr__menu__container{animation:plyr-popup .2s ease;background:hsla(0,0%,100%,.9);background:var(--plyr-menu-background,hsla(0,0%,100%,.9));border-radius:4px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);box-shadow:var(--plyr-menu-shadow,0 1px 2px rgba(0,0,0,.15));color:#4a5464;color:var(--plyr-menu-color,#4a5464);font-size:15px;font-size:var(--plyr-font-size-base,15px);margin-bottom:10px;position:absolute;right:-3px;text-align:left;white-space:nowrap;z-index:3}.plyr__menu__container>div{overflow:hidden;transition:height .35s cubic-bezier(.4,0,.2,1),width .35s cubic-bezier(.4,0,.2,1)}.plyr__menu__container:after{border:4px solid transparent;border-top:var(--plyr-menu-arrow-size,4px) solid hsla(0,0%,100%,.9);border-width:var(--plyr-menu-arrow-size,4px);content:"";height:0;position:absolute;right:14px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7 - var(--plyr-menu-arrow-size, 4px)/2);top:100%;width:0}.plyr__menu__container [role=menu]{padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container [role=menuitem],.plyr__menu__container [role=menuitemradio]{margin-top:2px}.plyr__menu__container [role=menuitem]:first-child,.plyr__menu__container [role=menuitemradio]:first-child{margin-top:0}.plyr__menu__container .plyr__control{align-items:center;color:#4a5464;color:var(--plyr-menu-color,#4a5464);display:flex;font-size:13px;font-size:var(--plyr-font-size-menu,var(--plyr-font-size-small,13px));padding:4.66667px 10.5px;padding:calc(var(--plyr-control-spacing, 10px)*.7/1.5) calc(var(--plyr-control-spacing, 10px)*.7*1.5);-webkit-user-select:none;user-select:none;width:100%}.plyr__menu__container .plyr__control>span{align-items:inherit;display:flex;width:100%}.plyr__menu__container .plyr__control:after{border:4px solid transparent;border:var(--plyr-menu-item-arrow-size,4px) solid transparent;content:"";position:absolute;top:50%;transform:translateY(-50%)}.plyr__menu__container .plyr__control--forward{padding-right:28px;padding-right:calc(var(--plyr-control-spacing, 10px)*.7*4)}.plyr__menu__container .plyr__control--forward:after{border-left-color:#728197;border-left-color:var(--plyr-menu-arrow-color,#728197);right:6.5px;right:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--forward.plyr__tab-focus:after,.plyr__menu__container .plyr__control--forward:hover:after{border-left-color:currentColor}.plyr__menu__container .plyr__control--back{font-weight:400;font-weight:var(--plyr-font-weight-regular,400);margin:7px;margin:calc(var(--plyr-control-spacing, 10px)*.7);margin-bottom:3.5px;margin-bottom:calc(var(--plyr-control-spacing, 10px)*.7/2);padding-left:28px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*4);position:relative;width:calc(100% - 14px);width:calc(100% - var(--plyr-control-spacing, 10px)*.7*2)}.plyr__menu__container .plyr__control--back:after{border-right-color:#728197;border-right-color:var(--plyr-menu-arrow-color,#728197);left:6.5px;left:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--back:before{background:#dcdfe5;background:var(--plyr-menu-back-border-color,#dcdfe5);box-shadow:0 1px 0 #fff;box-shadow:0 1px 0 var(--plyr-menu-back-border-shadow-color,#fff);content:"";height:1px;left:0;margin-top:3.5px;margin-top:calc(var(--plyr-control-spacing, 10px)*.7/2);overflow:hidden;position:absolute;right:0;top:100%}.plyr__menu__container .plyr__control--back.plyr__tab-focus:after,.plyr__menu__container .plyr__control--back:hover:after{border-right-color:currentColor}.plyr__menu__container .plyr__control[role=menuitemradio]{padding-left:7px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container .plyr__control[role=menuitemradio]:after,.plyr__menu__container .plyr__control[role=menuitemradio]:before{border-radius:100%}.plyr__menu__container .plyr__control[role=menuitemradio]:before{background:rgba(0,0,0,.1);content:"";display:block;flex-shrink:0;height:16px;margin-right:10px;margin-right:var(--plyr-control-spacing,10px);transition:all .3s ease;width:16px}.plyr__menu__container .plyr__control[role=menuitemradio]:after{background:#fff;border:0;height:6px;left:12px;opacity:0;top:50%;transform:translateY(-50%) scale(0);transition:transform .3s ease,opacity .3s ease;width:6px}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:before{background:#00b3ff;background:var(--plyr-control-toggle-checked-background,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)))}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:after{opacity:1;transform:translateY(-50%) scale(1)}.plyr__menu__container .plyr__control[role=menuitemradio].plyr__tab-focus:before,.plyr__menu__container .plyr__control[role=menuitemradio]:hover:before{background:rgba(35,40,47,.1)}.plyr__menu__container .plyr__menu__value{align-items:center;display:flex;margin-left:auto;margin-right:calc(-7px - -2);margin-right:calc(var(--plyr-control-spacing, 10px)*.7*-1 - -2);overflow:hidden;padding-left:24.5px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*3.5);pointer-events:none}.plyr--full-ui input[type=range]{-webkit-appearance:none;background:transparent;border:0;border-radius:26px;border-radius:calc(var(--plyr-range-thumb-height, 13px)*2);color:#00b3ff;color:var(--plyr-range-fill-background,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));display:block;height:19px;height:calc(var(--plyr-range-thumb-active-shadow-width, 3px)*2 + var(--plyr-range-thumb-height, 13px));margin:0;min-width:0;padding:0;transition:box-shadow .3s ease;width:100%}.plyr--full-ui input[type=range]::-webkit-slider-runnable-track{background:transparent;background-image:linear-gradient(90deg,currentColor 0,transparent 0);background-image:linear-gradient(to right,currentColor var(--value,0),transparent var(--value,0));border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-webkit-transition:box-shadow .3s ease;transition:box-shadow .3s ease;-webkit-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2));height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:-4px;margin-top:calc(var(--plyr-range-thumb-height, 13px)/2*-1 - var(--plyr-range-track-height, 5px)/2*-1);position:relative;-webkit-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-track{background:transparent;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-moz-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-moz-range-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2));height:13px;height:var(--plyr-range-thumb-height,13px);position:relative;-moz-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-progress{background:currentColor;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px)}.plyr--full-ui input[type=range]::-ms-track{color:transparent}.plyr--full-ui input[type=range]::-ms-fill-upper,.plyr--full-ui input[type=range]::-ms-track{background:transparent;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-fill-lower{background:transparent;background:currentColor;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2));height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:0;position:relative;-ms-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-ms-tooltip{display:none}.plyr--full-ui input[type=range]:focus{outline:0}.plyr--full-ui input[type=range]::-moz-focus-outer{border:0}.plyr--full-ui input[type=range].plyr__tab-focus::-webkit-slider-runnable-track{outline-color:#00b3ff;outline-color:var(--plyr-tab-focus-color,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));outline-offset:2px;outline-style:dotted;outline-width:3px}.plyr--full-ui input[type=range].plyr__tab-focus::-moz-range-track{outline-color:#00b3ff;outline-color:var(--plyr-tab-focus-color,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));outline-offset:2px;outline-style:dotted;outline-width:3px}.plyr--full-ui input[type=range].plyr__tab-focus::-ms-track{outline-color:#00b3ff;outline-color:var(--plyr-tab-focus-color,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));outline-offset:2px;outline-style:dotted;outline-width:3px}.plyr__poster{background-color:#000;background-color:var(--plyr-video-background,var(--plyr-video-background,#000));background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s ease;width:100%;z-index:1}.plyr--stopped.plyr__poster-enabled .plyr__poster{opacity:1}.plyr--youtube.plyr--paused.plyr__poster-enabled:not(.plyr--stopped) .plyr__poster{display:none}.plyr__time{font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px))}.plyr__time+.plyr__time:before{content:"⁄";margin-right:10px;margin-right:var(--plyr-control-spacing,10px)}@media (max-width:767px){.plyr__time+.plyr__time{display:none}}.plyr__tooltip{background:hsla(0,0%,100%,.9);background:var(--plyr-tooltip-background,hsla(0,0%,100%,.9));border-radius:3px;border-radius:var(--plyr-tooltip-radius,3px);bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);box-shadow:var(--plyr-tooltip-shadow,0 1px 2px rgba(0,0,0,.15));color:#4a5464;color:var(--plyr-tooltip-color,#4a5464);font-size:13px;font-size:var(--plyr-font-size-small,13px);font-weight:400;font-weight:var(--plyr-font-weight-regular,400);left:50%;line-height:1.3;margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:5px 7.5px;padding:calc(var(--plyr-control-spacing, 10px)/2) calc(var(--plyr-control-spacing, 10px)/2*1.5);pointer-events:none;position:absolute;transform:translate(-50%,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;white-space:nowrap;z-index:2}.plyr__tooltip:before{border-left:4px solid transparent;border-left:var(--plyr-tooltip-arrow-size,4px) solid transparent;border-right:4px solid transparent;border-right:var(--plyr-tooltip-arrow-size,4px) solid transparent;border-top:4px solid hsla(0,0%,100%,.9);border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,hsla(0,0%,100%,.9));bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:"";height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr .plyr__control.plyr__tab-focus .plyr__tooltip,.plyr .plyr__control:hover .plyr__tooltip,.plyr__tooltip--visible{opacity:1;transform:translate(-50%) scale(1)}.plyr .plyr__control:hover .plyr__tooltip{z-index:3}.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip,.plyr__controls>.plyr__control:first-child .plyr__tooltip{left:0;transform:translateY(10px) scale(.8);transform-origin:0 100%}.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip:before,.plyr__controls>.plyr__control:first-child .plyr__tooltip:before{left:16px;left:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7)}.plyr__controls>.plyr__control:last-child .plyr__tooltip{left:auto;right:0;transform:translateY(10px) scale(.8);transform-origin:100% 100%}.plyr__controls>.plyr__control:last-child .plyr__tooltip:before{left:auto;right:16px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7);transform:translateX(50%)}.plyr__controls>.plyr__control:first-child+.plyr__control.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control:hover .plyr__tooltip,.plyr__controls>.plyr__control:first-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child:hover .plyr__tooltip,.plyr__controls>.plyr__control:last-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:last-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:last-child:hover .plyr__tooltip{transform:translate(0) scale(1)}.plyr__progress{left:6.5px;left:calc(var(--plyr-range-thumb-height, 13px)*.5);margin-right:13px;margin-right:var(--plyr-range-thumb-height,13px);position:relative}.plyr__progress__buffer,.plyr__progress input[type=range]{margin-left:-6.5px;margin-left:calc(var(--plyr-range-thumb-height, 13px)*-.5);margin-right:-6.5px;margin-right:calc(var(--plyr-range-thumb-height, 13px)*-.5);width:calc(100% + 13px);width:calc(100% + var(--plyr-range-thumb-height, 13px))}.plyr__progress input[type=range]{position:relative;z-index:2}.plyr__progress .plyr__tooltip{font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px));left:0}.plyr__progress__buffer{-webkit-appearance:none;background:transparent;border:0;border-radius:100px;height:5px;height:var(--plyr-range-track-height,5px);left:0;margin-top:-2.5px;margin-top:calc(var(--plyr-range-track-height, 5px)/2*-1);padding:0;position:absolute;top:50%}.plyr__progress__buffer::-webkit-progress-bar{background:transparent}.plyr__progress__buffer::-webkit-progress-value{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-webkit-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-moz-progress-bar{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-moz-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-ms-fill{border-radius:100px;-ms-transition:width .2s ease;transition:width .2s ease}.plyr--loading .plyr__progress__buffer{animation:plyr-progress 1s linear infinite;background-image:linear-gradient(-45deg,rgba(35,40,47,.6) 25%,transparent 0,transparent 50%,rgba(35,40,47,.6) 0,rgba(35,40,47,.6) 75%,transparent 0,transparent);background-image:linear-gradient(-45deg,var(--plyr-progress-loading-background,rgba(35,40,47,.6)) 25%,transparent 25%,transparent 50%,var(--plyr-progress-loading-background,rgba(35,40,47,.6)) 50%,var(--plyr-progress-loading-background,rgba(35,40,47,.6)) 75%,transparent 75%,transparent);background-repeat:repeat-x;background-size:25px 25px;background-size:var(--plyr-progress-loading-size,25px) var(--plyr-progress-loading-size,25px);color:transparent}.plyr--video.plyr--loading .plyr__progress__buffer{background-color:hsla(0,0%,100%,.25);background-color:var(--plyr-video-progress-buffered-background,hsla(0,0%,100%,.25))}.plyr--audio.plyr--loading .plyr__progress__buffer{background-color:rgba(193,200,209,.6);background-color:var(--plyr-audio-progress-buffered-background,rgba(193,200,209,.6))}.plyr__volume{align-items:center;display:flex;max-width:110px;min-width:80px;position:relative;width:20%}.plyr__volume input[type=range]{margin-left:5px;margin-left:calc(var(--plyr-control-spacing, 10px)/2);margin-right:5px;margin-right:calc(var(--plyr-control-spacing, 10px)/2);position:relative;z-index:2}.plyr--is-ios .plyr__volume{min-width:0;width:auto}.plyr--audio{display:block}.plyr--audio .plyr__controls{background:#fff;background:var(--plyr-audio-controls-background,#fff);border-radius:inherit;color:#4a5464;color:var(--plyr-audio-control-color,#4a5464);padding:10px;padding:var(--plyr-control-spacing,10px)}.plyr--audio .plyr__control.plyr__tab-focus,.plyr--audio .plyr__control:hover,.plyr--audio .plyr__control[aria-expanded=true]{background:#00b3ff;background:var(--plyr-audio-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));color:#fff;color:var(--plyr-audio-control-color-hover,#fff)}.plyr--full-ui.plyr--audio input[type=range]::-webkit-slider-runnable-track{background-color:rgba(193,200,209,.6);background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,rgba(193,200,209,.6)))}.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track{background-color:rgba(193,200,209,.6);background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,rgba(193,200,209,.6)))}.plyr--full-ui.plyr--audio input[type=range]::-ms-track{background-color:rgba(193,200,209,.6);background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,rgba(193,200,209,.6)))}.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px rgba(35,40,47,.1);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,rgba(35,40,47,.1))}.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px rgba(35,40,47,.1);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,rgba(35,40,47,.1))}.plyr--full-ui.plyr--audio input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px rgba(35,40,47,.1);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,rgba(35,40,47,.1))}.plyr--audio .plyr__progress__buffer{color:rgba(193,200,209,.6);color:var(--plyr-audio-progress-buffered-background,rgba(193,200,209,.6))}.plyr--video{background:#000;background:var(--plyr-video-background,var(--plyr-video-background,#000));overflow:hidden}.plyr--video.plyr--menu-open{overflow:visible}.plyr__video-wrapper{background:#000;background:var(--plyr-video-background,var(--plyr-video-background,#000));height:100%;margin:auto;overflow:hidden;position:relative;width:100%}.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{aspect-ratio:16/9}@supports not (aspect-ratio:16/9){.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{height:0;padding-bottom:56.25%;position:relative}}.plyr__video-embed iframe,.plyr__video-wrapper--fixed-ratio video{border:0;height:100%;left:0;position:absolute;top:0;width:100%}.plyr--full-ui .plyr__video-embed>.plyr__video-embed__container{padding-bottom:240%;position:relative;transform:translateY(-38.28125%)}.plyr--video .plyr__controls{background:linear-gradient(transparent,rgba(0,0,0,.75));background:var(--plyr-video-controls-background,linear-gradient(transparent,rgba(0,0,0,.75)));border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;bottom:0;color:#fff;color:var(--plyr-video-control-color,#fff);left:0;padding:5px;padding:calc(var(--plyr-control-spacing, 10px)/2);padding-top:20px;padding-top:calc(var(--plyr-control-spacing, 10px)*2);position:absolute;right:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}@media (min-width:480px){.plyr--video .plyr__controls{padding:10px;padding:var(--plyr-control-spacing,10px);padding-top:35px;padding-top:calc(var(--plyr-control-spacing, 10px)*3.5)}}.plyr--video.plyr--hide-controls .plyr__controls{opacity:0;pointer-events:none;transform:translateY(100%)}.plyr--video .plyr__control.plyr__tab-focus,.plyr--video .plyr__control:hover,.plyr--video .plyr__control[aria-expanded=true]{background:#00b3ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));color:#fff;color:var(--plyr-video-control-color-hover,#fff)}.plyr__control--overlaid{background:#00b3ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b3ff)));border:0;border-radius:100%;color:#fff;color:var(--plyr-video-control-color,#fff);display:none;left:50%;opacity:.9;padding:15px;padding:calc(var(--plyr-control-spacing, 10px)*1.5);position:absolute;top:50%;transform:translate(-50%,-50%);transition:.3s;z-index:2}.plyr__control--overlaid svg{left:2px;position:relative}.plyr__control--overlaid:focus,.plyr__control--overlaid:hover{opacity:1}.plyr--playing .plyr__control--overlaid{opacity:0;visibility:hidden}.plyr--full-ui.plyr--video .plyr__control--overlaid{display:block}.plyr--full-ui.plyr--video input[type=range]::-webkit-slider-runnable-track{background-color:hsla(0,0%,100%,.25);background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,hsla(0,0%,100%,.25)))}.plyr--full-ui.plyr--video input[type=range]::-moz-range-track{background-color:hsla(0,0%,100%,.25);background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,hsla(0,0%,100%,.25)))}.plyr--full-ui.plyr--video input[type=range]::-ms-track{background-color:hsla(0,0%,100%,.25);background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,hsla(0,0%,100%,.25)))}.plyr--full-ui.plyr--video input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px hsla(0,0%,100%,.5);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,hsla(0,0%,100%,.5))}.plyr--full-ui.plyr--video input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px hsla(0,0%,100%,.5);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,hsla(0,0%,100%,.5))}.plyr--full-ui.plyr--video input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2),0 0 0 3px hsla(0,0%,100%,.5);box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px rgba(35,40,47,.15),0 0 0 1px rgba(35,40,47,.2)),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,hsla(0,0%,100%,.5))}.plyr--video .plyr__progress__buffer{color:hsla(0,0%,100%,.25);color:var(--plyr-video-progress-buffered-background,hsla(0,0%,100%,.25))}.plyr:fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:fullscreen video{height:100%}.plyr:fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}.plyr:fullscreen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr:-webkit-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-webkit-full-screen video{height:100%}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-webkit-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr:-moz-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-moz-full-screen video{height:100%}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-moz-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-moz-full-screen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr:-ms-fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-ms-fullscreen video{height:100%}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-ms-fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-ms-fullscreen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr--fullscreen-fallback{background:#000;border-radius:0!important;bottom:0;display:block;height:100%;left:0;margin:0;position:fixed;right:0;top:0;width:100%;z-index:10000000}.plyr--fullscreen-fallback video{height:100%}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen{display:block}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr--fullscreen-fallback.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr--fullscreen-fallback .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr__ads{border-radius:inherit;bottom:0;cursor:pointer;left:0;overflow:hidden;position:absolute;right:0;top:0;z-index:-1}.plyr__ads>div,.plyr__ads>div iframe{height:100%;position:absolute;width:100%}.plyr__ads:after{background:#23282f;border-radius:2px;bottom:10px;bottom:var(--plyr-control-spacing,10px);color:#fff;content:attr(data-badge-text);font-size:11px;padding:2px 6px;pointer-events:none;position:absolute;right:10px;right:var(--plyr-control-spacing,10px);z-index:3}.plyr__ads:empty:after{display:none}.plyr__cues{background:currentColor;display:block;height:5px;height:var(--plyr-range-track-height,5px);left:0;margin:-var(--plyr-range-track-height,5px)/2 0 0;opacity:.8;position:absolute;top:50%;width:3px;z-index:3}.plyr__preview-thumb{background-color:hsla(0,0%,100%,.9);background-color:var(--plyr-tooltip-background,hsla(0,0%,100%,.9));border-radius:3px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);box-shadow:var(--plyr-tooltip-shadow,0 1px 2px rgba(0,0,0,.15));margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:3px;padding:var(--plyr-tooltip-radius,3px);pointer-events:none;position:absolute;transform:translateY(10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;z-index:2}.plyr__preview-thumb--is-shown{opacity:1;transform:translate(0) scale(1)}.plyr__preview-thumb:before{border-left:4px solid transparent;border-left:var(--plyr-tooltip-arrow-size,4px) solid transparent;border-right:4px solid transparent;border-right:var(--plyr-tooltip-arrow-size,4px) solid transparent;border-top:4px solid hsla(0,0%,100%,.9);border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,hsla(0,0%,100%,.9));bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:"";height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr__preview-thumb__image-container{background:#c1c8d1;border-radius:2px;border-radius:calc(var(--plyr-tooltip-radius, 3px) - 1px);overflow:hidden;position:relative;z-index:0}.plyr__preview-thumb__image-container img{height:100%;left:0;max-height:none;max-width:none;position:absolute;top:0;width:100%}.plyr__preview-thumb__time-container{bottom:6px;left:0;position:absolute;right:0;white-space:nowrap;z-index:3}.plyr__preview-thumb__time-container span{background-color:rgba(0,0,0,.55);border-radius:2px;border-radius:calc(var(--plyr-tooltip-radius, 3px) - 1px);color:#fff;font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px));padding:3px 6px}.plyr__preview-scrubbing{bottom:0;filter:blur(1px);height:100%;left:0;margin:auto;opacity:0;overflow:hidden;pointer-events:none;position:absolute;right:0;top:0;transition:opacity .3s ease;width:100%;z-index:1}.plyr__preview-scrubbing--is-shown{opacity:1}.plyr__preview-scrubbing img{height:100%;left:0;max-height:none;max-width:none;-o-object-fit:contain;object-fit:contain;position:absolute;top:0;width:100%}.plyr--no-transition{transition:none!important}.plyr__sr-only{clip:rect(1px,1px,1px,1px);border:0!important;height:1px!important;overflow:hidden;padding:0!important;position:absolute!important;width:1px!important}.plyr [hidden]{display:none!important}', ""]), t.Z = r;
      },
      430: function _(e, t, i) {
        "use strict";

        var n = i(645),
            r = i.n(n)()(function (e) {
          return e[1];
        });
        r.push([e.id, ".plyr{--plyr-color-main:#ddd}.plyr--video{width:100%;height:100%}.plyr--video video{object-fit:contain;position:relative}.kaizen-player-root{width:100%;height:100%}.plyr__control--overlaid{background:rgba(255,255,255,.65)}.kaizen-loader-container{visibility:visible;margin:0;padding:0;position:absolute;top:50%;left:50%;-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:9999}.kaizen-loader,.kaizen-loader:after{width:64px;height:64px}.kaizen-loader{position:relative}.kaizen-loader div{width:33%;height:33%;background-color:#a0a0a0;float:left;-webkit-animation:scaleDelay 1.3s infinite ease-in-out;animation:scaleDelay 1.3s infinite ease-in-out}.kaizen-loader .kaizen-loader-inner1{-webkit-animation-delay:.2s;animation-delay:.2s}.kaizen-loader .kaizen-loader-inner2{-webkit-animation-delay:.3s;animation-delay:.3s}.kaizen-loader .kaizen-loader-inner3{-webkit-animation-delay:.4s;animation-delay:.4s}.kaizen-loader .kaizen-loader-inner4{-webkit-animation-delay:.1s;animation-delay:.1s}.kaizen-loader .kaizen-loader-inner5{-webkit-animation-delay:.2s;animation-delay:.2s}.kaizen-loader .kaizen-loader-inner6{-webkit-animation-delay:.3s;animation-delay:.3s}.kaizen-loader .kaizen-loader-inner7{-webkit-animation-delay:0s;animation-delay:0s}.kaizen-loader .kaizen-loader-inner8{-webkit-animation-delay:.1s;animation-delay:.1s}.kaizen-loader .kaizen-loader-inner9{-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes scaleDelay{0%,100%,70%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}35%{-webkit-transform:scale3d(0,0,1);transform:scale3d(0,0,1)}}@keyframes scaleDelay{0%,100%,70%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}35%{-webkit-transform:scale3d(0,0,1);transform:scale3d(0,0,1)}}.kaizen-hide-play-button button.plyr__control--overlaid{display:none!important}ul.plyr__progress--markers{position:absolute;top:0;left:0;margin:0;padding:0;width:100%;height:100%;list-style:none}ul.plyr__progress--markers li{position:absolute;top:calc(50% - 4px);width:8px;height:8px;border-radius:4px;background-color:#fff;z-index:1}div.plyr__custom-controls{background:linear-gradient(transparent,rgba(0,0,0,.75));background:var(--plyr-video-controls-background,linear-gradient(transparent,rgba(0,0,0,.75)));border-radius:3px;border-radius:var(--plyr-control-radius,3px);color:#fff;color:var(--plyr-video-control-color,#fff);position:absolute;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}.plyr__mute-button-top-left{top:10px;left:10px}.plyr__mute-button-top-right{top:10px;right:10px}.plyr__mute-button-bottom-left{bottom:60px;left:10px}.plyr__mute-button-bottom-right{bottom:60px;right:10px}.plyr__custom-speed-setting{position:relative!important;height:32px;font-size:.875rem;font-weight:600;display:flex;justify-content:center;width:64px}.plyr__custom-speed-setting-button{width:100%!important;height:32px;padding:0}.plyr__speed-setting-option{margin-bottom:4px;padding:4px;background:rgba(0,0,0,.5)}.plyr__speed-setting-menu{position:absolute;bottom:32px;margin:0;padding:0;list-style:none;width:100%}.plyr__speed-control-hide{display:none}.plyr__speed-active-option{background:rgba(255,255,255,.75);background:var(--plyr-color-main,rgba(255,255,255,.75));color:#fff;color:var(--plyr-video-control-color,#fff)}", ""]), t.Z = r;
      },
      645: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var i = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(i, "}") : i;
            }).join("");
          }, t.i = function (e, i, n) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var r = {};
            if (n) for (var o = 0; o < this.length; o++) {
              var a = this[o][0];
              null != a && (r[a] = !0);
            }

            for (var s = 0; s < e.length; s++) {
              var l = [].concat(e[s]);
              n && r[l[0]] || (i && (l[2] ? l[2] = "".concat(i, " and ").concat(l[2]) : l[2] = i), t.push(l));
            }
          }, t;
        };
      }
    },
        t = {};

    function i(n) {
      var r = t[n];
      if (void 0 !== r) return r.exports;
      var o = t[n] = {
        id: n,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, i), o.exports;
    }

    i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return i.d(t, {
        a: t
      }), t;
    }, i.d = function (e, t) {
      for (var n in t) {
        i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, i.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return function () {
      "use strict";

      i.r(n), i.d(n, {
        Player: function Player() {
          return F;
        }
      });

      var e = i(18),
          t = i.n(e),
          r = function r() {
        return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
      },
          o = "object" == typeof window.performance && "function" == typeof performance.now && "number" == typeof performance.timeOrigin;

      function a() {
        return "" + r() + r() + "-" + r() + "-" + r() + "-" + r() + "-" + r() + r() + r();
      }

      function s() {
        return "" + r() + r() + r();
      }

      function l() {
        return o ? Math.round(1e3 * (performance.timeOrigin + performance.now())) : 1e3 * Date.now();
      }

      var c = function c(e, t, i) {
        if (i || 2 === arguments.length) for (var n, r = 0, o = t.length; r < o; r++) {
          !n && r in t || (n || (n = Array.prototype.slice.call(t, 0, r)), n[r] = t[r]);
        }
        return e.concat(n || Array.prototype.slice.call(t));
      },
          u = "[kaizen-video-player] ",
          p = window.console,
          d = !1,
          h = !1;

      function f() {
        return h || function (e) {
          var t = e.location.search,
              i = t.indexOf("_kz_debug=");
          i >= 0 ? parseInt(t.substring(i + 10, i + 10 + 1)) >= 1 ? (e.cookie = "_kz_debug=1; path=/", d = !0) : (e.cookie = "_kz_debug=1; path=/; expires=" + new Date(0).toUTCString(), d = !1) : d = e.cookie.indexOf("_kz_debug=1") >= 0, h = !0;
        }(document), d;
      }

      function m(e) {
        d && e(m);
      }

      m.log = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.log.apply(p, c(["" + u + e], t, !1));
      }, m.debug = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.debug.apply(p, c(["" + u + e], t, !1));
      }, m.info = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.info.apply(p, c(["" + u + e], t, !1));
      }, m.warn = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.warn.apply(p, c(["" + u + e], t, !1));
      }, m.error = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.error.apply(p, c(["" + u + e], t, !1));
      }, m.assert = function (e) {
        for (var t = [], i = 1; i < arguments.length; i++) {
          t[i - 1] = arguments[i];
        }

        f() && p.assert.apply(p, c(["" + u + e], t, !1));
      };
      var g = i(594).Z.toString() + "\n" + i(430).Z.toString() + "\n";

      function y(e, t, i) {
        var n,
            r = e.plyrOptions || {};
        r.loadSprite = !1, r.storage = {
          enabled: !1
        }, r.keyboard = {
          focused: !1,
          global: !1
        }, r.controls || (r.controls = ["play-large", "play", "progress", "current-time", "mute", "volume"]);
        var o = t.getMutedAndVolume(),
            a = o[0],
            s = o[1];
        return r.muted = "boolean" == typeof e.muted ? e.muted : a || !1, r.volume = "number" == typeof e.volume ? e.volume : s || 1, r.muted && (r.vimeo = {
          muted: !0
        }), r.blankVideo || (r.blankVideo = "https://cdn.kaizenplatform.net/libs/blank.mp4"), i.isIE() && (r.fullscreen = {
          enabled: !1
        }), (null === (n = e.customSpeedSetting) || void 0 === n ? void 0 : n.enabled) && Array.isArray(r.controls) && r.controls.find(function (e) {
          return "settings" === e;
        }) && (r.settings || (r.settings = ["captions", "quality", "loop"]), r.settings = r.settings.filter(function (e) {
          return "speed" !== e;
        }), r.settings.length <= 0 && r.controls.filter(function (e) {
          return "settings" !== e;
        })), r;
      }

      var b = function b(e) {
        return Math.round(100 * e) / 100;
      };

      function v(e, t, i) {
        var n = T(e),
            r = n[0],
            o = n[1],
            a = b(r * i + (t.outsideControls ? 50 : 0));

        if (t.maxHeight) {
          var s = function (e) {
            var t = parseInt(e.replace(/[^\d]/g, "")),
                i = e.match(/(vw|vh|vmin|vmax)$/);
            if (!i) return t;
            var n = i[1],
                r = x(),
                o = r[0],
                a = r[1];

            switch (n) {
              case "vw":
                return b(t * o / 100);

              case "vh":
                return b(t * a / 100);

              case "vmin":
                return b(t * Math.min(o, a) / 100);

              case "vmax":
                return b(t * Math.max(o, a) / 100);

              default:
                return t;
            }
          }(t.maxHeight);

          a > s && (a = s);
        }

        a !== o && (e.style.height = a + "px");
      }

      var w = !1,
          _ = {
        w: 0,
        h: 0
      },
          k = {
        w: 0,
        h: 0
      };

      function x() {
        var e = !1,
            t = window.outerWidth,
            i = window.outerHeight,
            n = document.documentElement.clientWidth,
            r = n > 0 && window.innerHeight > 0 ? n / window.innerWidth : 1,
            o = window.innerWidth * r,
            a = window.innerHeight * r,
            s = Math.abs(k.w - o) > 1,
            l = Math.abs(k.h - a) > 1;
        return t != _.w || i != _.h ? (_.w = t, _.h = i, e = !0) : w || s === l || (e = !0), e && (k.w = o, k.h = a), [k.w, k.h];
      }

      function T(e) {
        var t = e.getBoundingClientRect(),
            i = t.width,
            n = t.height;
        return [b(i), b(n)];
      }

      function C(e) {
        var t = window.getComputedStyle(e, null),
            i = "hidden" !== t.visibility && "none" !== t.display,
            n = e.getBoundingClientRect(),
            r = n.width,
            o = n.height,
            a = window.pageXOffset,
            s = window.pageYOffset,
            l = n.left + a,
            c = n.top + s,
            u = document.documentElement.clientWidth,
            p = document.documentElement.clientHeight,
            d = x(),
            h = d[0],
            f = d[1];
        return {
          visible: i,
          x: b(l),
          y: b(c),
          width: b(r),
          height: b(o),
          scrollX: b(a),
          scrollY: b(s),
          windowWidth: b(h),
          windowHeight: b(f),
          pageWidth: b(u),
          pageHeight: b(p)
        };
      }

      function S(e, t) {
        if (void 0 === t && (t = !0), t && !e.visible) return 0;
        var i = e.width,
            n = e.height,
            r = e.x,
            o = e.scrollX,
            a = e.y,
            s = e.scrollY,
            l = r + i,
            c = o + e.windowWidth,
            u = a + n,
            p = s + e.windowHeight,
            d = (Math.min(l, c) - Math.max(r, o)) * (Math.min(u, p) - Math.max(a, s)),
            h = i > 0 && n > 0 ? d / (i * n) : 0;
        return h < 0 && (h = 0), b(h);
      }

      var A = void 0 === document.visibilityState ? function () {
        return !0;
      } : function () {
        return "visible" === document.visibilityState;
      };

      function E(e, t, i) {
        var n = "",
            r = "";

        if (t.outsideControls) {
          n = "margin-bottom:50px;";
          var o = "calc(50% - 25px)";
          r = ".plyr__control--overlaid{top:" + o + "}.kaizen-loader-container{top:" + o + "}";
        }

        i && (r += ".plyr__video-wrapper video{opacity:0 !important;transition:none !important;}", r += ".plyr__poster{opacity:1 !important;transition:none !important;}"), e.innerHTML = (n ? ".plyr__video-wrapper{" + n + "}" : "") + r;
      }

      var P = function () {
        function e() {
          this.version = 0, this.lastCheckedAt = 0;
        }

        return e.prototype.isAvailable = function () {
          return this.version > 0 || this.check();
        }, e.prototype.getInsightUuid = function () {
          return 3 === this.version ? this.context.getUserId() : 2 === this.version ? this.context.setting.getUserId() : void 0;
        }, e.prototype.getInsightVisitLogId = function () {
          var e, t;
          return 3 === this.version ? this.context.visitLogId : 2 === this.version ? null === (t = null === (e = this.context.setting.insight) || void 0 === e ? void 0 : e.tracker) || void 0 === t ? void 0 : t.log_id : void 0;
        }, e.prototype.check = function (e) {
          var t, i;
          void 0 === e && (e = !1);
          var n = Date.now();
          if (!e && n - this.lastCheckedAt < 1e3) return this.version > 0;

          if (this.version = 0, this.context = void 0, this.lastCheckedAt = n, null === (i = null === (t = window.kzs) || void 0 === t ? void 0 : t.current) || void 0 === i ? void 0 : i.context) {
            var r = window.kzs.current.context,
                o = this.getVersion(r);
            if (o > 0) return this.version = o, this.context = r, !0;
          }

          for (var a = document.getElementsByTagName("script"), s = a.length, l = 0; l < s; ++l) {
            r = a[l].context;
            var c = this.getVersion(r);
            if (c > 0) return this.version = c, this.context = r, !0;
          }

          return !1;
        }, e.prototype.getVersion = function (e) {
          if (e) {
            if ("function" == typeof e.getUserId && "string" == typeof e.visitLogId) return 3;

            if (e.setting && "function" == typeof e.setting.getUserId) {
              var t = e.setting;
              if (t.insight && t.insight.tracker && "string" == typeof t.insight.tracker.log_id) return 2;
            }
          }

          return 0;
        }, e;
      }(),
          z = function () {
        function e(e, t) {
          this.player = e, this.events = t, this.endpoint = e.options.loggerEndpoint || "https://c0ve1jo507.execute-api.us-east-1.amazonaws.com/development", this.useBeacon = "function" == typeof navigator.sendBeacon, this.scriptKey = e.options.scriptKey, this.progressSentAt = 0, this.lastCurrentTime = 0, this.sitejs = new P(), this.startTrack();
        }

        return e.prototype.startTrack = function () {
          var e = this;
          this.events.on("begin", function () {
            e.isPlyrAlive() && (e.progressSentAt = 0, e.lastCurrentTime = e.player.plyr.currentTime, e.sendLog("begin"));
          }), this.events.on("progress", function () {
            if (e.isPlyrAlive()) {
              var t = l(),
                  i = e.player.plyr.currentTime;
              e.player.playing && !e.player.pausing && e.lastCurrentTime !== i && t - e.progressSentAt >= 1e6 && (e.progressSentAt = t, e.lastCurrentTime = i, e.sendLog("progress"));
            }
          }), this.events.on("end", function () {
            e.isPlyrAlive() && e.sendLog("end");
          }), this.events.on("ready", function () {
            e.isPlyrAlive() && e.sendLog("ready");
          }), this.events.on("play", function () {
            e.isPlyrAlive() && e.sendLog("play");
          }), this.events.on("pause", function () {
            e.isPlyrAlive() && e.sendLog("pause");
          }), this.events.on("autoplay", function () {
            e.isPlyrAlive() && e.sendLog("autoplay");
          }), this.events.on("autopause", function () {
            e.isPlyrAlive() && e.sendLog("autopause");
          }), this.events.on("seek", function () {
            e.isPlyrAlive() && e.sendLog("seek");
          }), this.events.on("volumechange", function () {
            e.isPlyrAlive() && e.sendLog("volumechange");
          }), this.events.on("error", function (t) {
            e.isPlyrAlive() && e.sendLog("error", null == t ? void 0 : t.detail);
          });
        }, e.prototype.buildLog = function (e, t) {
          var i = this.player.options.service,
              n = this.player.options.serviceResourceId,
              r = this.player.options.placement,
              o = this.scriptKey,
              s = this.player.userId,
              c = a(),
              u = l(),
              p = this.player.videoId,
              d = this.player.videoType,
              h = this.player.videoCached,
              f = this.player.plyr.duration,
              m = f > 0 ? Math.round(1e6 * this.player.plyr.currentTime) : void 0,
              g = f > 0 ? Math.round(1e6 * this.player.plyr.duration) : void 0,
              y = this.player.videoSession,
              b = this.player.playedCount,
              v = this.player.plyr.muted ? 0 : this.player.plyr.volume,
              w = C(this.player.root),
              _ = {
            w: w.width,
            h: w.height
          },
              k = {
            x: w.x,
            y: w.y
          },
              x = S(w),
              T = {
            w: w.pageWidth,
            h: w.pageHeight
          },
              A = {
            w: w.windowWidth,
            h: w.windowHeight
          },
              E = {
            x: w.scrollX,
            y: w.scrollY
          },
              P = this.player.browser,
              z = P.mobile,
              M = P.device,
              I = P.os,
              L = P.browser,
              N = document.location.href,
              O = document.referrer,
              j = this.player.options.customValue,
              H = {
            scriptKey: o,
            userId: s,
            logId: c,
            browserTime: u,
            eventType: e,
            videoId: p,
            videoType: d,
            videoCached: h,
            videoTime: m,
            videoDuration: g,
            videoSession: y,
            playedCount: b,
            playerVolume: v,
            playerSize: _,
            playerPosition: k,
            playerVisibility: x,
            pageSize: T,
            windowSize: A,
            scrollPosition: E,
            mobile: z,
            device: M,
            os: I,
            browser: L,
            url: N,
            referrer: O
          };
          return i && (H.service = i), n && (H.serviceResourceId = n), r && (H.placement = r), j && (H.customValue = JSON.stringify(j)), this.sitejs.isAvailable() && (H.insightUuid = this.sitejs.getInsightUuid(), H.insightVisitLogId = this.sitejs.getInsightVisitLogId()), t && (H.error = JSON.stringify(t)), H;
        }, e.prototype.sendLog = function (e, t) {
          void 0 === t && (t = void 0);
          var i,
              n,
              r,
              o = this.buildLog(e, t);
          return m.debug("sendLog:" + e, o), this.useBeacon ? navigator.sendBeacon(this.endpoint, JSON.stringify(o)) : (i = this.endpoint, n = JSON.stringify(o), (r = new XMLHttpRequest()).open("POST", i), r.setRequestHeader("Content-Type", "text/plain"), r.withCredentials = !1, r.onreadystatechange = function () {
            4 === r.readyState && 200 !== r.status && 204 !== r.status && m.error("Server responded with a status of " + r.status);
          }, r.send(n)), o;
        }, e.prototype.isPlyrAlive = function () {
          try {
            return this.player.plyr.currentTime, !0;
          } catch (e) {
            return !1;
          }
        }, e;
      }(),
          M = function () {
        function e(e) {
          this.player = e, this.plyr = e.plyr, this.listeners = [], this.progressTimer = 0, this.lastSeekedTime = 0, this.internalListeners = [], this.clickedTimings = {}, this.ready = !1, this.began = !1, this.loading = !1, this.loadingTimer = 0, this.visibilityTimer = 0, this.playerVisibility = 1, this.registeredListeners = [], this.changing = !1, this.showingOnlyPoster = !1;
        }

        return e.prototype.start = function () {
          var e = this;
          this.stop(), this.listen(this.plyr, "canplay", function (t) {
            e.emit("canplay"), e.checkVisibility(), e.startVisibilityTimer();
          }), this.listen(this.plyr, "playing", function (t) {
            e.onPlaying(), e.emit("playing");
          }), this.listen(this.plyr, "ended", function (t) {
            e.onEnded(), e.emit("ended");
          }), this.listen(this.plyr, "ready", function (t) {
            e.onReady();
          }), this.listen(this.plyr, "play", function (t) {
            setTimeout(function () {
              e.onPlay();
            }, 1);
          }), this.listen(this.plyr, "pause", function (t) {
            setTimeout(function () {
              e.onPause();
            }, 1);
          }), this.listen(this.plyr, "seeked", function (t) {
            e.onSeeked();
          }), this.listen(this.plyr, "volumechange", function (t) {
            e.onVolumechange();
          }), this.listen(document, "visibilitychange", function () {
            e.docVisibilityChanged();
          }), this.listen(this.plyr, "waiting canplay seeked playing", function (t) {
            var i = ["stalled", "waiting"].includes(t.type);
            e.emit("loading", {
              loading: i,
              type: "media"
            });
          }), this.player.browser.isSafari() && (this.listen(this.plyr, "loadedmetadata", function (t) {
            e.plyr.autoplay || setTimeout(function () {
              e.emit("canplay");
            }, 500);
          }), this.listen(this.plyr, "loadstart", function () {
            e.changing && (e.showingOnlyPoster = !0, E(e.player.dynamicStyle, e.player.options, !0));
          })), this.startLoadingTimer();
        }, e.prototype.stop = function () {
          this.internalListeners.forEach(function (e) {
            var i = e.context,
                n = e.name,
                r = e.listener;
            i instanceof t() ? i.off(n, r) : i.removeEventListener(n, r);
          }), this.loadingTimer && window.clearInterval(this.loadingTimer), this.loadingTimer = 0, this.loading = !1;
        }, e.prototype.on = function (e, t) {
          this.listeners.findIndex(function (i) {
            return i.type === e && i.listener === t;
          }) < 0 && this.listeners.push({
            type: e,
            listener: t
          });
        }, e.prototype.off = function (e, t) {
          this.listeners = this.listeners.filter(function (i) {
            return i.type !== e || i.listener !== t;
          });
        }, e.prototype.emit = function (e, t) {
          var i = {
            player: this.player,
            plyr: this.plyr
          };
          t && Object.assign(i, t);
          var n = new CustomEvent(e, {
            detail: i
          });
          this.listeners.forEach(function (t) {
            e === t.type && t.listener && t.listener(n);
          });
        }, e.prototype.registerListeners = function (e) {
          var t = this;
          e && e.forEach(function (e) {
            var i = e[0],
                n = e[1],
                r = function r(e) {
              n(e);
            };

            t.on(i, r), t.registeredListeners.push({
              type: i,
              listener: r
            });
          });
        }, e.prototype.unregisterListeners = function () {
          for (; this.registeredListeners.length > 0;) {
            var e = this.registeredListeners.pop(),
                t = e.type,
                i = e.listener;
            this.off(t, i);
          }
        }, e.prototype.listen = function (e, i, n) {
          e instanceof t() ? e.on(i, n) : e.addEventListener(i, n), this.internalListeners.push({
            context: e,
            name: i,
            listener: n
          });
        }, e.prototype.onPlaying = function () {
          var e = this;
          this.began || (this.began = !0, this.emit("begin"), this.progressTimer && window.clearInterval(this.progressTimer), this.progressTimer = window.setInterval(function () {
            e.emit("progress");
          }, 200));
        }, e.prototype.onEnded = function () {
          this.began && (this.began = !1, this.emit("end"), this.progressTimer && window.clearInterval(this.progressTimer), this.progressTimer = 0);
        }, e.prototype.onReady = function () {
          var e = this;

          if (!this.ready) {
            this.ready = !0;
            var t = this.player.root.querySelector(".plyr--video");
            this.emit("ready", {
              container: t
            }), t && (this.listen(t, "click", function (t) {
              e.onClickVideo();
            }), t.querySelectorAll(".plyr__control").forEach(function (t) {
              e.listen(t, "click", function (t) {
                e.onClickControl(t);
              });
            }));
          }
        }, e.prototype.onPlay = function () {
          if ("vimeo" !== this.player.videoType) {
            var e = Date.now() - Math.max(this.clickedTimings.video || 0, this.clickedTimings.play || 0) < 200 ? "play" : "autoplay";
            this.emit(e);
          } else this.emit("play");
        }, e.prototype.onPause = function () {
          if ("vimeo" !== this.player.videoType) {
            var e = Date.now() - Math.max(this.clickedTimings.video || 0, this.clickedTimings.pause || 0) < 200 ? "pause" : "autopause";
            this.emit(e);
          } else this.emit("pause");
        }, e.prototype.onSeeked = function () {
          var e = this.plyr.currentTime || 0;
          Math.abs(e - this.lastSeekedTime) >= 1 && (this.emit("seek"), this.lastSeekedTime = e);
        }, e.prototype.onVolumechange = function () {
          this.emit("volumechange");
        }, e.prototype.docVisibilityChanged = function () {
          var e = A();
          this.emit("docvisibilitychange", {
            visible: e
          });
        }, e.prototype.onClickVideo = function () {
          this.clickedTimings.video = Date.now();
        }, e.prototype.onClickControl = function (e) {
          var t = e.target;

          if (t && t.getAttribute) {
            var i = t.getAttribute("aria-label");
            i && (this.clickedTimings[i] = Date.now());
          }
        }, e.prototype.startLoadingTimer = function () {
          var e = this;
          this.loadingTimer && window.clearInterval(this.loadingTimer), this.loadingTimer = window.setInterval(function () {
            var t;
            if (!e.plyr.elements) return e.stopLoadingTimer();
            var i = !!(null === (t = e.plyr.elements.container) || void 0 === t ? void 0 : t.classList.contains("plyr--loading"));
            e.loading !== i && (e.loading = i, e.emit("loading", {
              loading: i,
              type: "ui"
            }));
          }, 50);
        }, e.prototype.stopLoadingTimer = function () {
          window.clearInterval(this.loadingTimer), this.loadingTimer = 0, this.loading = !1;
        }, e.prototype.startVisibilityTimer = function () {
          var e = this;
          this.visibilityTimer && window.clearInterval(this.visibilityTimer), this.visibilityTimer = window.setInterval(function () {
            e.checkVisibility();
          }, 500);
        }, e.prototype.stopVisibilityTimer = function () {
          window.clearInterval(this.visibilityTimer), this.visibilityTimer = 0;
        }, e.prototype.checkVisibility = function () {
          if (this.changing && (this.changing = !1, this.showingOnlyPoster && (this.showingOnlyPoster = !1, E(this.player.dynamicStyle, this.player.options, !1))), !this.plyr.elements) return this.stopVisibilityTimer();

          try {
            var e = S(C(this.player.root), this.player.visible);
            this.playerVisibility != e && (this.playerVisibility = e, this.emit("playervisibilitychange", {
              visibility: e
            })), this.player.adjustHeight(), this.player.visible || (this.player.visible = !0);
          } catch (e) {
            return this.stopVisibilityTimer();
          }
        }, e;
      }();

      function I(e, t) {
        var i = "http://www.w3.org/2000/svg",
            n = "http://www.w3.org/1999/xlink",
            r = document.createElementNS(i, "svg");
        r.setAttribute("class", e), r.setAttribute("focusable", "false");
        var o = document.createElementNS(i, "use");
        return o.href && o.setAttributeNS(n, "href", t), o.setAttributeNS(n, "xlink:href", t), r.appendChild(o), r;
      }

      var L = function () {
        function e(e, t, i, n) {
          var r,
              o = this;
          this.container = function (e) {
            var t = document.createElement("div"),
                i = ["top-left", "top-right", "bottom-left", "bottom-right"].indexOf(e) >= 0 ? e : "top-right";
            return t.className = "plyr__custom-controls plyr__mute-button-" + i, t;
          }(t), this.button = ((r = document.createElement("button")).type = "button", r.className = "plyr__control", r.appendChild(I("icon--pressed", "#plyr-muted")), r.appendChild(I("icon--not-pressed", "#plyr-volume")), r), this.container.appendChild(this.button), this.getMutedAndVolume = i, this.toggleMuted = n, this.button.addEventListener("click", function () {
            o.toggleMuted(), o.update();
          }), this.update(), e.appendChild(this.container);
        }

        return e.prototype.update = function () {
          var e = "plyr__control--pressed",
              t = this.getMutedAndVolume(),
              i = t[0],
              n = t[1];
          i || 0 === n ? this.button.classList.add(e) : this.button.classList.remove(e);
        }, e;
      }(),
          N = [.5, .75, 1, 1.25, 1.5, 1.75, 2],
          O = function () {
        function e(e, t, i, n, r) {
          var o,
              a,
              s = this;
          this.setSpeed = t, this.currentSpeed = n || 1, this.root = ((o = document.createElement("div")).className = "plyr__controls__item plyr__custom-speed-setting", o), this.button = function (e) {
            var t = document.createElement("button");
            return t.innerHTML = e + "x", t.type = "button", t.className = "plyr__control plyr__custom-speed-setting-button", t;
          }(this.currentSpeed), this.menu = ((a = document.createElement("ul")).className = "plyr__speed-setting-menu plyr__speed-control-hide", a), this.menuItems = function (e, t) {
            return e.map(function (e) {
              var i = document.createElement("li"),
                  n = e === t;
              return i.innerHTML = e + "x", i.setAttribute("key", e.toString()), i.className = "plyr__control plyr__speed-setting-option " + (n ? "plyr__speed-active-option" : void 0), i;
            });
          }(r || N, this.currentSpeed), this.menuItems.forEach(function (e) {
            e.addEventListener("click", function () {
              s.updateCurrentSpeed(parseFloat(e.getAttribute("key") || "1"));
            }), s.menu.append(e);
          }), this.root.append(this.button), this.root.append(this.menu), i ? e.insertBefore(this.root, i) : e.appendChild(this.root), this.button.addEventListener("click", function () {
            return s.handleClickSettingButton();
          }), n && this.setSpeed(n);
        }

        return e.prototype.handleCloseMenu = function () {
          this.menu.classList.add("plyr__speed-control-hide");
        }, e.prototype.handleClickSettingButton = function () {
          this.menu.classList.contains("plyr__speed-control-hide") ? this.menu.classList.remove("plyr__speed-control-hide") : this.menu.classList.add("plyr__speed-control-hide");
        }, e.prototype.updateCurrentSpeed = function (e) {
          this.button.innerHTML = e + "x", this.setSpeed(e), this.menuItems.forEach(function (t) {
            parseFloat(t.getAttribute("key") || "0") === e ? t.classList.add("plyr__speed-active-option") : t.classList.remove("plyr__speed-active-option");
          });
        }, e;
      }(),
          j = "hls-35e2f6f6-ea18-4d96-b912-efb90a887353",
          H = function () {
        function e() {
          this.loading = !1, this.loaded = !1, this.onLoadedCallbacks = [];
        }

        return e.prototype.load = function (e) {
          var t = this;

          if (this.loaded ? e && e() : e && this.onLoadedCallbacks.push(e), !this.loading) {
            this.loading = !0, function () {
              if (!document.getElementById(j)) {
                var e = document.createElement("script");
                e.src = "https://cdn.kaizenplatform.net/libs/hls-1.1.5.js", e.id = j, document.head.appendChild(e);
              }
            }();
            var i = setInterval(function () {
              var e;

              if ((null === (e = window.Hls) || void 0 === e ? void 0 : e.scriptId) === j) {
                clearInterval(i), t.loaded = !0;
                var n = t.onLoadedCallbacks;
                t.onLoadedCallbacks = [], n.forEach(function (e) {
                  return e();
                });
              }
            }, 20);
          }
        }, e.prototype.getHls = function () {
          return window.Hls;
        }, e;
      }(),
          V = function V(e) {
        return Math.round(100 * e) / 100;
      },
          R = function () {
        function e() {
          this.player = {
            width: NaN,
            height: NaN
          }, this.video = {
            width: NaN,
            height: NaN,
            top: NaN,
            left: NaN,
            aspectRatio: NaN
          };
        }

        return e.prototype.update = function (e, t, i) {
          if (!(t > 0)) return !1;
          var n = !1,
              r = T(e),
              o = r[0],
              a = r[1];
          o === this.player.width && a === this.player.height || (n = !0, this.player.width = o, this.player.height = a);
          var s = i ? a - 50 : a,
              l = 0,
              c = 0,
              u = 0,
              p = 0;
          return s < V(o * t) ? (l = 0, c = V((o - (u = (p = s) / t)) / 2), u = V(u)) : (l = V((s - (p = (u = o) * t)) / 2), c = 0, p = V(p)), u === this.video.width && p === this.video.height && l === this.video.top && c === this.video.left && t === this.video.aspectRatio || (this.video.width = u, this.video.height = p, this.video.top = l, this.video.left = c, this.video.aspectRatio = t, n = !0), n;
        }, e;
      }(),
          D = "__kaizen_video_player",
          q = function () {
        function e() {
          this.data = e.readRaw();
        }

        return e.prototype.getUserId = function () {
          return this.data.userId;
        }, e.prototype.setUserId = function (t) {
          return e.readRaw(), this.data.userId = t, e.writeRaw(this.data), t;
        }, e.prototype.getMutedAndVolume = function () {
          return [this.data.muted, this.data.volume];
        }, e.prototype.setMutedAndVolume = function (t, i) {
          e.readRaw(), this.data.muted = t, this.data.volume = i, e.writeRaw(this.data);
        }, e.readRaw = function () {
          var e = {};

          try {
            var t = JSON.parse(localStorage.getItem(D) || "{}"),
                i = t.userId,
                n = t.muted,
                r = t.volume;
            "string" == typeof i && (e.userId = i), "boolean" == typeof n && (e.muted = n), "number" == typeof r && (e.volume = r);
          } catch (t) {
            e = {};
          }

          return e;
        }, e.writeRaw = function (e) {
          try {
            localStorage.setItem(D, JSON.stringify(e));
          } catch (e) {
            return {};
          }
        }, e;
      }(),
          B = function () {
        function e(e) {
          var t = function (e) {
            var t = e.match(/(iPhone);\s(?:U;\s)?(?:CPU\s)?(?:iPhone\s)?OS\s(\d+)_(\d+)(?:_(\d+))?/) || e.match(/(iPad);\s(?:U;\s)?(?:CPU\s)?(?:iPhone\s)?OS\s(\d+)_(\d+)(?:_(\d+))?/) || e.match(/(iPod)(?:\stouch)?;\s(?:U;\s)?(?:CPU\s)?(?:iPhone\s)?OS\s(\d+)_(\d+)(?:_(\d+))?/);
            if (t) return [t[1].toLowerCase(), "ios " + t[2]];
            var i = e.match(/Android\s+(\d+)\.?(\d+)?(.*)/);

            if (i) {
              var n = "android " + i[1] + "." + (i[2] || "0");
              return [/^.+ Mobile($| )/.test(i[3]) ? "android" : "android_tablet", n];
            }

            var r = e.match(/Macintosh;\s(?:U;\s)?Intel\sMac\sOS\sX(?:\s(\d+)[._](\d+)(?:[._](\d+))?)?/);
            if (r) return ["mac", n = r[1] && r[2] ? "mac " + r[1] + "." + r[2] : "mac"];
            var o = e.match(/Windows\sNT\s(\d+)\.(\d)/);
            return o ? ["windows", "windows " + o[1] + "." + o[2]] : e.match(/\([^)]*\bLinux|Ubuntu|Debian\b/) ? ["linux", "linux"] : ["unknown", "unknown"];
          }(e),
              i = t[0],
              n = t[1],
              r = function (e) {
            var t = e.match(/Edg\/([\d.]+)/i);
            if (t) return ["edge", parseInt(t[1])];
            var i = e.match(/(Opera|OPR)[\s/]+([\d.]+)/i);
            if (i) return ["opera", parseInt(i[1])];
            var n = e.match(/(MSIE\s|Trident.*rv:)(([\d]+)[\d.]*)/i);
            if (n) return ["ie", parseInt(n[3])];
            var r = e.match(/Chrome\/([\d.]+)/i);
            if (r) return ["chrome", parseInt(r[1])];
            var o = e.match(/Firefox\/([\d.]+)/i);
            if (o) return ["firefox", parseInt(o[1])];
            var a = e.match(/Version\/([\d.]+)(\sMobile\/[A-Z\d]+)?\sSafari/i);
            return a ? ["safari", parseInt(a[1])] : ["unknown", 0];
          }(e),
              o = r[0],
              a = r[1];

          this.browser = a > 0 ? o + " " + a : o, this.mobile = "windows" !== i && "mac" !== i && "unknown" !== i && "linux" !== i, this.device = i, this.os = n, this.name = o, this.version = a;
        }

        return e.prototype.needHls = function () {
          return this.isIE() || this.isFirefox() || this.isEdge() || this.isAndroid() || this.isChrome();
        }, e.prototype.needPlyr = function () {
          return "iphone" === this.device;
        }, e.prototype.isIE = function () {
          return "ie" === this.name;
        }, e.prototype.isSafari = function () {
          return "safari" === this.name;
        }, e.prototype.isEdge = function () {
          return "edge" === this.name;
        }, e.prototype.isFirefox = function () {
          return "firefox" === this.name;
        }, e.prototype.isAndroid = function () {
          return "android_tablet" === this.device || "android" === this.device;
        }, e.prototype.isChrome = function () {
          return "chrome" === this.name;
        }, e;
      }(),
          F = function () {
        function e(e, i) {
          var n,
              r,
              o = this;

          if (this.browser = new B(navigator.userAgent), r = this.browser.mobile, w = r, x(), "string" == typeof e) {
            var a = document.querySelector(e);
            if (!a) throw new Error("KaizenVideoPlayer: " + e + " is not found");
            this.container = a;
          } else this.container = e;

          this.options = i;
          var l = this.options.videoType;
          "vimeo" !== l && "html5" !== l && (l = "shaka"), this._visible = !i.autoHeight, this.givenRatio = W(i.aspectRatio), this.actualRatio = 0, this.size = new R(), n = function (e, t, i, n) {
            t.autoHeight && v(e, t, n);
            var r = document.createElement("div");
            r.className = "kaizen-player-root", i || (r.style.visibility = "hidden");
            var o = document.createElement("style"),
                a = g;
            o.className = "plyr__base-css", o.innerHTML = a, r.appendChild(o);
            var s = document.createElement("style");
            s.className = "plyr__dynamic-css", E(s, t, !1), r.appendChild(s);
            var l = document.createElement("style");
            l.className = "plyr__user-css", t.plyrCss && (l.innerHTML = t.plyrCss), r.appendChild(l);
            var c = document.createElement("div");
            c.className = "plyr__sprite", c.hidden = !0, c.innerHTML = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><symbol id="plyr-airplay" viewBox="0 0 18 18"><path d="M16 1H2a1 1 0 00-1 1v10a1 1 0 001 1h3v-2H3V3h12v8h-2v2h3a1 1 0 001-1V2a1 1 0 00-1-1z"/><path d="M4 17h10l-5-6z"/></symbol><symbol id="plyr-captions-off" viewBox="0 0 18 18"><path d="M1 1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h4.6l2.7 2.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3l2.7-2.7H17c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H1zm4.52 10.15c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41C8.47 4.96 7.46 3.76 5.5 3.76c-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69zm7.57 0c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41c-.28-1.15-1.29-2.35-3.25-2.35-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69z" fill-rule="evenodd" fill-opacity=".5"/></symbol><symbol id="plyr-captions-on" viewBox="0 0 18 18"><path d="M1 1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h4.6l2.7 2.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3l2.7-2.7H17c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H1zm4.52 10.15c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41C8.47 4.96 7.46 3.76 5.5 3.76c-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69zm7.57 0c1.99 0 3.01-1.32 3.28-2.41l-1.29-.39c-.19.66-.78 1.45-1.99 1.45-1.14 0-2.2-.83-2.2-2.34 0-1.61 1.12-2.37 2.18-2.37 1.23 0 1.78.75 1.95 1.43l1.3-.41c-.28-1.15-1.29-2.35-3.25-2.35-1.9 0-3.61 1.44-3.61 3.7 0 2.26 1.65 3.69 3.63 3.69z" fill-rule="evenodd"/></symbol><symbol id="plyr-download" viewBox="0 0 18 18"><path d="M9 13c.3 0 .5-.1.7-.3L15.4 7 14 5.6l-4 4V1H8v8.6l-4-4L2.6 7l5.7 5.7c.2.2.4.3.7.3zm-7 2h14v2H2z"/></symbol><symbol id="plyr-enter-fullscreen" viewBox="0 0 18 18"><path d="M10 3h3.6l-4 4L11 8.4l4-4V8h2V1h-7zM7 9.6l-4 4V10H1v7h7v-2H4.4l4-4z"/></symbol><symbol id="plyr-exit-fullscreen" viewBox="0 0 18 18"><path d="M1 12h3.6l-4 4L2 17.4l4-4V17h2v-7H1zM16 .6l-4 4V1h-2v7h7V6h-3.6l4-4z"/></symbol><symbol id="plyr-fast-forward" viewBox="0 0 18 18"><path d="M7.875 7.171L0 1v16l7.875-6.171V17L18 9 7.875 1z"/></symbol><symbol id="plyr-logo-vimeo" viewBox="0 0 18 18"><path d="M17 5.3c-.1 1.6-1.2 3.7-3.3 6.4-2.2 2.8-4 4.2-5.5 4.2-.9 0-1.7-.9-2.4-2.6C5 10.9 4.4 6 3 6c-.1 0-.5.3-1.2.8l-.8-1c.8-.7 3.5-3.4 4.7-3.5 1.2-.1 2 .7 2.3 2.5.3 2 .8 6.1 1.8 6.1.9 0 2.5-3.4 2.6-4 .1-.9-.3-1.9-2.3-1.1.8-2.6 2.3-3.8 4.5-3.8 1.7.1 2.5 1.2 2.4 3.3z"/></symbol><symbol id="plyr-logo-youtube" viewBox="0 0 18 18"><path d="M16.8 5.8c-.2-1.3-.8-2.2-2.2-2.4C12.4 3 9 3 9 3s-3.4 0-5.6.4C2 3.6 1.3 4.5 1.2 5.8 1 7.1 1 9 1 9s0 1.9.2 3.2c.2 1.3.8 2.2 2.2 2.4C5.6 15 9 15 9 15s3.4 0 5.6-.4c1.4-.3 2-1.1 2.2-2.4.2-1.3.2-3.2.2-3.2s0-1.9-.2-3.2zM7 12V6l5 3-5 3z"/></symbol><symbol id="plyr-muted" viewBox="0 0 18 18"><path d="M12.4 12.5l2.1-2.1 2.1 2.1 1.4-1.4L15.9 9 18 6.9l-1.4-1.4-2.1 2.1-2.1-2.1L11 6.9 13.1 9 11 11.1zM3.786 6.008H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"/></symbol><symbol id="plyr-pause" viewBox="0 0 18 18"><path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm6 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"/></symbol><symbol id="plyr-pip" viewBox="0 0 18 18"><path d="M13.293 3.293L7.022 9.564l1.414 1.414 6.271-6.271L17 7V1h-6z"/><path d="M13 15H3V5h5V3H2a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1v-6h-2v5z"/></symbol><symbol id="plyr-play" viewBox="0 0 18 18"><path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"/></symbol><symbol id="plyr-restart" viewBox="0 0 18 18"><path d="M9.7 1.2l.7 6.4 2.1-2.1c1.9 1.9 1.9 5.1 0 7-.9 1-2.2 1.5-3.5 1.5-1.3 0-2.6-.5-3.5-1.5-1.9-1.9-1.9-5.1 0-7 .6-.6 1.4-1.1 2.3-1.3l-.6-1.9C6 2.6 4.9 3.2 4 4.1 1.3 6.8 1.3 11.2 4 14c1.3 1.3 3.1 2 4.9 2 1.9 0 3.6-.7 4.9-2 2.7-2.7 2.7-7.1 0-9.9L16 1.9l-6.3-.7z"/></symbol><symbol id="plyr-rewind" viewBox="0 0 18 18"><path d="M10.125 1L0 9l10.125 8v-6.171L18 17V1l-7.875 6.171z"/></symbol><symbol id="plyr-settings" viewBox="0 0 18 18"><path d="M16.135 7.784a2 2 0 01-1.23-2.969c.322-.536.225-.998-.094-1.316l-.31-.31c-.318-.318-.78-.415-1.316-.094a2 2 0 01-2.969-1.23C10.065 1.258 9.669 1 9.219 1h-.438c-.45 0-.845.258-.997.865a2 2 0 01-2.969 1.23c-.536-.322-.999-.225-1.317.093l-.31.31c-.318.318-.415.781-.093 1.317a2 2 0 01-1.23 2.969C1.26 7.935 1 8.33 1 8.781v.438c0 .45.258.845.865.997a2 2 0 011.23 2.969c-.322.536-.225.998.094 1.316l.31.31c.319.319.782.415 1.316.094a2 2 0 012.969 1.23c.151.607.547.865.997.865h.438c.45 0 .845-.258.997-.865a2 2 0 012.969-1.23c.535.321.997.225 1.316-.094l.31-.31c.318-.318.415-.781.094-1.316a2 2 0 011.23-2.969c.607-.151.865-.547.865-.997v-.438c0-.451-.26-.846-.865-.997zM9 12a3 3 0 110-6 3 3 0 010 6z"/></symbol><symbol id="plyr-volume" viewBox="0 0 18 18"><path d="M15.6 3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C15.4 5.9 16 7.4 16 9c0 1.6-.6 3.1-1.8 4.3-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3C17.1 13.2 18 11.2 18 9s-.9-4.2-2.4-5.7z"/><path d="M11.282 5.282a.909.909 0 000 1.316c.735.735.995 1.458.995 2.402 0 .936-.425 1.917-.995 2.487a.909.909 0 000 1.316c.145.145.636.262 1.018.156a.725.725 0 00.298-.156C13.773 11.733 14.13 10.16 14.13 9c0-.17-.002-.34-.011-.51-.053-.992-.319-2.005-1.522-3.208a.909.909 0 00-1.316 0zm-7.496.726H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"/></symbol></svg>', r.appendChild(c);
            var u = document.createElement("video");
            return function (e, t, i, n) {
              var r = !!n.autoplay,
                  o = n.poster;
              e.controls = !0, e.crossOrigin = "", e.playsInline = !0, e.width = t, e.height = i, e.autoplay = r, o && e.setAttribute("data-poster", o);
            }(u, e.clientWidth, e.clientHeight, t), r.appendChild(u), "function" != typeof e.attachShadow || e.shadowRoot ? e.appendChild(r) : e.attachShadow({
              mode: "open"
            }).append(r), [u, r, s, l];
          }(this.container, i, this._visible, this.givenRatio), this.videoTag = n[0], this.root = n[1], this.dynamicStyle = n[2], this.userStyle = n[3], this.storage = new q(), this.plyr = new (t())(this.videoTag, y(i, this.storage, this.browser)), this.options.userId && this.storage.setUserId(this.options.userId), this.autoPauseEnabled = !1 !== i.autopause, this.autoPausing = !1, this.playedCount = 1, this.videoSession = s(), this.started = !1, this.events = new M(this), this.events.on("ready", function (e) {
            var t;
            o.videoContainer = null === (t = null == e ? void 0 : e.detail) || void 0 === t ? void 0 : t.container, o.setupCustomControls(), o.setupCustomSpeedControl();
          }), this.events.on("begin", function () {
            o.started ? (o.playedCount++, o.videoSession = s()) : o.started = !0;
          }), this.events.on("canplay", function () {
            var e;
            o.updateMarkers(), o.adjustHeight(), o.plyr.speed = (null === (e = o.options.customSpeedSetting) || void 0 === e ? void 0 : e.default) || 1;
          }), "shaka" !== l && "html5" !== l || (this.customLoader = new U(this)), this.events.registerListeners(i.listeners), this.events.start(), this.options.scriptKey && !1 !== this.options.logging ? this.tracker = new z(this, this.events) : this.options.scriptKey || !0 !== this.options.logging || m.error("[KaizenVideoPlayer] scriptKey must be set to enable logging!"), this.events.on("docvisibilitychange", function (e) {
            var t = window.scrollY + window.innerHeight,
                i = null == e ? void 0 : e.detail.player.container.getBoundingClientRect(),
                n = window.scrollY + i.top,
                r = window.scrollY + i.top + (null == e ? void 0 : e.detail.player.container.clientHeight);
            (((null == e ? void 0 : e.detail.player.container.clientHeight) > 0 || (null == e ? void 0 : e.detail.player.container.clientWidth) > 0) && t > n && window.scrollY < r || 0 === (null == e ? void 0 : e.detail.player.container.clientHeight) && e.detail.player.container.clientWidth > 0) && o.docVisibilityChanged(e);
          }), this.events.on("playervisibilitychange", function (e) {
            ((null == e ? void 0 : e.detail.player.container.clientHeight) > 0 || 0 === (null == e ? void 0 : e.detail.player.container.clientWidth)) && o.playerVisibilityChanged(e);
          }), this.events.on("volumechange", function (e) {
            o.volumeChanged(e);
          }), this.hlsLoader = new H(), this.browser.needHls() && this.hlsLoader.load(function () {
            m.info("hls.js is loaded");
          });
        }

        return e.prototype.changeVideo = function (e) {
          if (e.videoType !== this.options.videoType) throw new Error("KaizenVideoPlayer: can't change videoType");
          var t = this.options.userId;
          this.events.stopVisibilityTimer(), this.events.unregisterListeners(), this.options = e, this.events.changing = !0, this.events.registerListeners(e.listeners), this.events.startLoadingTimer(), this.options.userId && this.options.userId !== t && this.storage.setUserId(this.options.userId);
          var i = y(e, this.storage, this.browser);
          this.autoPauseEnabled = !1 !== e.autopause, this.autoPausing = !1, this.playedCount = 1, this.videoSession = s(), this.started = !1, this.givenRatio = void 0 === e.aspectRatio ? this.actualRatio || this.givenRatio : W(e.aspectRatio), this.actualRatio = 0, this.videoId = this.options.videoId = e.videoId, this.manifestUrl = this.options.manifestUrl = e.manifestUrl, this.options.poster = e.poster, this.options.markers = e.markers, this.plyr.currentTime = 0, this.plyr.setPreviewThumbnails(i.previewThumbnails || {
            enabled: !1
          }), this.plyr.poster = this.options.poster || "", this.clearMarkers(), this.plyr.rewind(), this.adjustHeight(!0), this.events.emit("videochange"), this.start();
        }, Object.defineProperty(e.prototype, "videoId", {
          get: function get() {
            return this.options.videoId;
          },
          set: function set(e) {
            this.options.videoId = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "videoType", {
          get: function get() {
            return this.options.videoType;
          },
          set: function set(e) {
            this.options.videoType = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "videoCached", {
          get: function get() {
            return !1;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "manifestUrl", {
          get: function get() {
            return this.options.manifestUrl;
          },
          set: function set(e) {
            this.options.manifestUrl = e;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "playing", {
          get: function get() {
            return !!this.plyr && this.plyr.playing;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "pausing", {
          get: function get() {
            return !!this.plyr && this.plyr.paused;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "userId", {
          get: function get() {
            var e = this.storage.getUserId();
            return e || (e = a(), this.storage.setUserId(e)), e;
          },
          set: function set(e) {
            this.storage.setUserId(e);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "visible", {
          get: function get() {
            return this._visible;
          },
          set: function set(e) {
            this.root.style.visibility = e ? "" : "hidden", this._visible = e;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.start = function () {
          var e = this;

          if ("shaka" === this.videoType) {
            if (this.videoId && this.manifestUrl) {
              var i = this.manifestUrl;
              this.browser.needHls() ? this.hlsLoader.load(function () {
                var n = new (e.hlsLoader.getHls())();
                n.loadSource(i), n.attachMedia(e.videoTag), t().setup(e.videoTag);
              }) : this.videoId && (this.plyr.source = {
                type: "video",
                sources: [{
                  src: this.manifestUrl
                }]
              });
            }
          } else "vimeo" === this.videoType ? this.videoId && (this.plyr.source = {
            type: "video",
            sources: [{
              provider: "vimeo",
              src: this.videoId
            }]
          }) : this.videoId && (this.plyr.source = {
            type: "video",
            sources: [{
              src: this.videoId
            }]
          });
        }, e.prototype.pause = function () {
          this.playing && !this.pausing && this.plyr.pause(), this.autoPausing = !1;
        }, e.prototype.resume = function () {
          !this.playing && this.pausing && this.plyr.play();
        }, e.prototype.autoPause = function () {
          this.playing && !this.pausing && (this.autoPausing = !0, this.plyr.pause());
        }, e.prototype.autoResume = function () {
          !this.playing && this.pausing && this.autoPausing && (this.autoPausing = !1, this.plyr.play());
        }, e.prototype.on = function (e, t) {
          this.events.on(e, t);
        }, e.prototype.off = function (e, t) {
          this.events.off(e, t);
        }, e.prototype.destroy = function () {
          this.plyr.destroy();
        }, e.prototype.docVisibilityChanged = function (e) {
          this.autoPauseEnabled && (e.detail.visible ? this.autoResume() : this.autoPause());
        }, e.prototype.playerVisibilityChanged = function (e) {
          this.autoPauseEnabled && this.visible && (e.detail.visibility > 0 ? this.autoResume() : this.autoPause());
        }, e.prototype.volumeChanged = function (e) {
          this.storage.setMutedAndVolume(this.plyr.muted, this.plyr.volume);
        }, e.prototype.updateMarkers = function () {
          this.clearMarkers();
          var e = this.root.querySelector(".plyr__progress"),
              t = this.plyr.duration;

          if (e && this.options.markers && 0 != this.options.markers.length && t) {
            var i = document.createElement("ul");
            i.className = "plyr__progress--markers", this.options.markers.forEach(function (e) {
              if (!(e > t)) {
                var n = document.createElement("li");
                n.setAttribute("style", "left:calc(" + Math.round(e / t * 100) + "% - 4px)"), i.appendChild(n);
              }
            }), e.appendChild(i);
          }
        }, e.prototype.clearMarkers = function () {
          var e,
              t = this.root.querySelector(".plyr__progress--markers");
          null === (e = null == t ? void 0 : t.parentElement) || void 0 === e || e.removeChild(t);
        }, e.prototype.setupCustomControls = function () {
          var e = this;
          this.options.muteButton && this.videoContainer && (this.muteButton || (this.muteButton = new L(this.videoContainer, this.options.muteButton, function () {
            return [e.plyr.muted, e.plyr.volume];
          }, function () {
            e.plyr.muted = !e.plyr.muted;
          }), this.events.on("volumechange", function () {
            var t;
            null === (t = e.muteButton) || void 0 === t || t.update();
          })));
        }, e.prototype.setupCustomSpeedControl = function () {
          var e,
              t,
              i,
              n,
              r,
              o,
              a = this;

          if ((null === (e = this.options.customSpeedSetting) || void 0 === e ? void 0 : e.enabled) && !this.speedSettingButton) {
            var s = this.plyr.elements.controls;

            if (s) {
              var l = (null === (t = this.options.customSpeedSetting) || void 0 === t ? void 0 : t.controlsIndex) ? s.childNodes[null === (i = this.options.customSpeedSetting) || void 0 === i ? void 0 : i.controlsIndex] : void 0;
              this.speedSettingButton = new O(s, function (e) {
                return a.plyr.speed = e;
              }, l, null === (n = this.options.customSpeedSetting) || void 0 === n ? void 0 : n.default, null === (r = this.options.customSpeedSetting) || void 0 === r ? void 0 : r.options), this.plyr.on("controlshidden", function (e) {
                var t;
                return null === (t = a.speedSettingButton) || void 0 === t ? void 0 : t.handleCloseMenu();
              }), null === (o = this.plyr.elements.wrapper) || void 0 === o || o.addEventListener("click", function (e) {
                var t, i;
                (null === (t = a.speedSettingButton) || void 0 === t ? void 0 : t.root.contains(e.target)) || null === (i = a.speedSettingButton) || void 0 === i || i.handleCloseMenu();
              });
            }
          }
        }, e.prototype.adjustHeight = function (e) {
          var t;

          if (void 0 === e && (e = !1), this.videoContainer && (this.actualRatio = (t = this.videoContainer.querySelector("video")) ? t.videoHeight / t.videoWidth : 0), e || this.options.autoHeight) {
            var i = this.actualRatio || this.givenRatio;
            v(this.container, this.options, i), this.size.update(this.container, i, !!this.options.outsideControls) && this.events.emit("sizechange");
          }
        }, e.version = "0.1.13-6", e;
      }(),
          U = function () {
        function e(e) {
          var t = this;
          this.player = e, this.enabled = !1, this.canplay = !1, this.loading = !1, this.first = !0;
          var i = e.events;
          i.on("ready", function () {
            t.update();
          }), i.on("loading", function (e) {
            var i,
                n = null === (i = null == e ? void 0 : e.detail) || void 0 === i ? void 0 : i.type;

            if (n) {
              var r = !!e.detail.loading;
              "ui" === n ? (t.loading = r, t.update()) : "media" === n && r && t.hideButton(!0);
            }
          }), i.on("canplay", function () {
            t.canplay = !0, t.update();
          }), i.on("videochange", function () {
            t.first = !1, t.canplay = !1, t.hideButton(!0), t.update();
          });
        }

        return e.prototype.update = function () {
          var e = this.first && this.loading || !this.canplay;
          e !== this.enabled && (e ? this.showLoader() : this.hideLoader()) && (this.enabled = e);
        }, e.prototype.showLoader = function () {
          var e = this.player.videoContainer;
          if (!e) return !1;
          if (this.hideButton(!0), e.querySelector(".kaizen-loader-container")) return !1;
          var t = document.createElement("div"),
              i = document.createElement("div"),
              n = document.createElement("div"),
              r = document.createElement("div"),
              o = document.createElement("div"),
              a = document.createElement("div"),
              s = document.createElement("div"),
              l = document.createElement("div"),
              c = document.createElement("div"),
              u = document.createElement("div"),
              p = document.createElement("div");
          return t.setAttribute("class", "kaizen-loader-container"), i.setAttribute("class", "kaizen-loader"), n.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner1"), r.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner2"), o.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner3"), a.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner4"), s.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner5"), l.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner6"), c.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner7"), u.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner8"), p.setAttribute("class", "kaizen-loader-inner kaizen-loader-inner9"), i.append(n, r, o, a, s, l, c, u, p), t.appendChild(i), e.appendChild(t), !0;
        }, e.prototype.hideLoader = function () {
          var e = this.player.videoContainer;
          if (!e) return !1;
          this.hideButton(!1);
          var t = e.querySelector(".kaizen-loader-container");
          return !!t && (e.removeChild(t), !0);
        }, e.prototype.hideButton = function (e) {
          var t = this.player.root,
              i = "kaizen-hide-play-button";
          e ? t.classList.add(i) : setTimeout(function () {
            t.classList.remove(i);
          }, 1);
        }, e;
      }();

      function W(e) {
        var t = .5625;
        if (!e) return t;
        if ("number" == typeof e) return e;
        var i = /^((\d*\.)?\d+):((\d*\.)?\d+)$/.exec(e);
        if (!i) throw new Error();
        var n = parseFloat(i[1]),
            r = parseFloat(i[3]);
        return n > 0 && r > 0 ? r / n : t;
      }
    }(), n;
  }();
});